// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, ServerSentEventsResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptInvitationData, AcceptInvitationErrors, AcceptInvitationResponses, AcceptProjectWorkstreamCodeTuningVersionData, AcceptProjectWorkstreamCodeTuningVersionErrors, AcceptProjectWorkstreamCodeTuningVersionResponses, AcceptPromotionCandidateData, AcceptPromotionCandidateErrors, AcceptPromotionCandidateResponses, AcceptRiskBreachData, AcceptRiskBreachErrors, AcceptRiskBreachResponses, AcknowledgeOrgModuleData, AcknowledgeOrgModuleErrors, AcknowledgeOrgModuleResponses, ActivateEntityVersionData, ActivateEntityVersionErrors, ActivateEntityVersionResponses, ActivateRiskHaltData, ActivateRiskHaltErrors, ActivateRiskHaltResponses, AddEvaluationTemplateVersionData, AddEvaluationTemplateVersionErrors, AddEvaluationTemplateVersionResponses, AddMarketplaceBundleEntityData, AddMarketplaceBundleEntityErrors, AddMarketplaceBundleEntityResponses, AddOrgMemberData, AddOrgMemberErrors, AddOrgMemberResponses, AddProjectMemberData, AddProjectMemberErrors, AddProjectMemberResponses, AddProjectTeamMemberData, AddProjectTeamMemberErrors, AddProjectTeamMemberResponses, AddTeamMemberData, AddTeamMemberErrors, AddTeamMemberResponses, AddToWatchlistData, AddToWatchlistResponses, AddWidgetData, AddWidgetErrors, AddWidgetResponses, AddWorkflowStepData, AddWorkflowStepErrors, AddWorkflowStepResponses, AddWorkstreamMemberData, AddWorkstreamMemberErrors, AddWorkstreamMemberResponses, AmendStrategyDefinitionParametersData, AmendStrategyDefinitionParametersErrors, AmendStrategyDefinitionParametersResponses, AnalyzeConfluenceData, AnalyzeConfluenceFromSignalsData, AnalyzeConfluenceFromSignalsResponses, AnalyzeConfluenceResponses, AnalyzeOrderBookData, AnalyzeOrderBookResponses, AnalyzeTickerAdHocData, AnalyzeTickerAdHocResponses, ApiApproveDecisionData, ApiApproveDecisionErrors, ApiApproveDecisionResponses, ApiCancelDecisionData, ApiCancelDecisionErrors, ApiCancelDecisionResponses, ApiCompareBacktestsData, ApiCompareBacktestsErrors, ApiCompareBacktestsResponses, ApiCreateBacktestData, ApiCreateBacktestErrors, ApiCreateBacktestResponses, ApiGetBacktestAnalyticsData, ApiGetBacktestAnalyticsErrors, ApiGetBacktestAnalyticsResponses, ApiGetBacktestData, ApiGetBacktestErrors, ApiGetBacktestResponses, ApiGetCandlesData, ApiGetCandlesErrors, ApiGetCandlesResponses, ApiGetDashboardDataData, ApiGetDashboardDataErrors, ApiGetDashboardDataResponses, ApiGetStrategyBucketData, ApiGetStrategyBucketErrors, ApiGetStrategyBucketResponses, ApiGetStrategyData, ApiGetStrategyErrors, ApiGetStrategyResponses, ApiGetWorkflowRunPartData, ApiGetWorkflowRunPartErrors, ApiGetWorkflowRunPartResponses, ApiListBacktestsData, ApiListBacktestSeriesData, ApiListBacktestSeriesErrors, ApiListBacktestSeriesResponses, ApiListBacktestsErrors, ApiListBacktestsResponses, ApiListDecisionsData, ApiListDecisionsErrors, ApiListDecisionsResponses, ApiListIntelSourceItemsData, ApiListIntelSourceItemsErrors, ApiListIntelSourceItemsResponses, ApiListIntelSourcesData, ApiListIntelSourcesErrors, ApiListIntelSourcesResponses, ApiListMarketRegimesData, ApiListMarketRegimesErrors, ApiListMarketRegimesResponses, ApiListStrategiesData, ApiListStrategiesErrors, ApiListStrategiesResponses, ApiListStrategyBucketsData, ApiListStrategyBucketsErrors, ApiListStrategyBucketsResponses, ApiRejectDecisionData, ApiRejectDecisionErrors, ApiRejectDecisionResponses, ApiStreamBacktestEventsData, ApiStreamBacktestEventsErrors, ApiStreamBacktestEventsResponse, ApiStreamBacktestEventsResponses, ApplyContractResolutionData, ApplyContractResolutionErrors, ApplyContractResolutionResponses, ApplyEvaluationTemplateData, ApplyEvaluationTemplateErrors, ApplyEvaluationTemplateResponses, ApplyFinanceBucketDecisionData, ApplyFinanceBucketDecisionErrors, ApplyFinanceBucketDecisionResponses, ApplyFinanceIndicatorPromotionData, ApplyFinanceIndicatorPromotionErrors, ApplyFinanceIndicatorPromotionResponses, ApplyMarketplaceUpdatesData, ApplyMarketplaceUpdatesErrors, ApplyMarketplaceUpdatesResponses, ApproveDaemonDecisionData, ApproveDaemonDecisionErrors, ApproveDaemonDecisionResponses, ApproveDecisionData, ApproveDecisionResponses, ApproveRecommendationData, ApproveRecommendationErrors, ApproveRecommendationResponses, ApproveTaskActionData, ApproveTaskActionErrors, ApproveTaskActionResponses, ApproveWorkflowGateData, ApproveWorkflowGateErrors, ApproveWorkflowGateResponses, ArchiveProjectData, ArchiveProjectErrors, ArchiveProjectResponses, ArchiveWorkflowData, ArchiveWorkflowResponses, ArchiveWorkstreamData, ArchiveWorkstreamErrors, ArchiveWorkstreamResponses, AssignDaemonWorkflowData, AssignDaemonWorkflowErrors, AssignDaemonWorkflowResponses, AssignEmployeeWorkflowData, AssignEmployeeWorkflowErrors, AssignEmployeeWorkflowResponses, AssignUserRoleData, AssignUserRoleErrors, AssignUserRoleResponses, AttachToConversationData, AttachToConversationErrors, AttachToConversationResponses, BackfillIntelSourceSubscriptionData, BackfillIntelSourceSubscriptionErrors, BackfillIntelSourceSubscriptionResponses, BatchDeactivateIntelSourcesData, BatchDeactivateIntelSourcesResponses, BatchFetchIntelSourcesData, BatchFetchIntelSourcesResponses, BindMarketplaceEntityConnectionData, BindMarketplaceEntityConnectionErrors, BindMarketplaceEntityConnectionResponses, BulkCreateIntelSourcesData, BulkCreateIntelSourcesErrors, BulkCreateIntelSourcesResponses, BulkUpdateUserStatusData, BulkUpdateUserStatusErrors, BulkUpdateUserStatusResponses, CalculateOrbData, CalculateOrbErrors, CalculateOrbResponses, CallAiWorkerMcpData, CallAiWorkerMcpErrors, CallAiWorkerMcpResponses, CallPlatformMcpData, CallPlatformMcpErrors, CallPlatformMcpResponses, CancelAllOrdersData, CancelAllOrdersResponses, CancelExecutionAlgoData, CancelExecutionAlgoErrors, CancelExecutionAlgoResponses, CancelOrderData, CancelOrderErrors, CancelOrderResponses, CancelTaskData, CancelTaskErrors, CancelTaskResponses, CancelWorkerRunData, CancelWorkerRunErrors, CancelWorkerRunResponses, CertifyShadowModeDaemonData, CertifyShadowModeDaemonErrors, CertifyShadowModeDaemonResponses, CheckAlertPriceData, CheckAlertPriceResponses, CheckDeploymentReadinessData, CheckDeploymentReadinessErrors, CheckDeploymentReadinessResponses, CheckMarketDataData, CheckMarketDataResponses, CheckPortCompatibilityData, CheckPortCompatibilityErrors, CheckPortCompatibilityResponses, ClaimActionQueueItemData, ClaimActionQueueItemErrors, ClaimActionQueueItemResponses, ClearOrganizationRuntimePolicySurfaceRuleData, ClearOrganizationRuntimePolicySurfaceRuleResponses, CloneAnalysisTemplateData, CloneAnalysisTemplateErrors, CloneAnalysisTemplateResponses, CloseContextPanelData, CloseContextPanelErrors, CloseContextPanelResponses, ClosePositionData, ClosePositionErrors, ClosePositionResponses, CloseProjectData, CloseProjectErrors, CloseProjectResponses, CommitFinanceStrategyLifecycleTransitionData, CommitFinanceStrategyLifecycleTransitionErrors, CommitFinanceStrategyLifecycleTransitionResponses, CompareAgentTemplateVersionsData, CompareAgentTemplateVersionsErrors, CompareAgentTemplateVersionsResponses, ComparePortfoliosData, ComparePortfoliosErrors, ComparePortfoliosResponses, CompleteTaskData, CompleteTaskErrors, CompleteTaskResponses, ConfigureProjectCodeClientDatabaseData, ConfigureProjectCodeClientDatabaseErrors, ConfigureProjectCodeClientDatabaseResponses, ConnectMcpConnectionData, ConnectMcpConnectionErrors, ConnectMcpConnectionResponses, CreateActiveStrategyData, CreateActiveStrategyErrors, CreateActiveStrategyResponses, CreateAdjustmentData, CreateAdjustmentErrors, CreateAdjustmentResponses, CreateAgentTemplateVersionData, CreateAgentTemplateVersionResponses, CreateAlertData, CreateAlertErrors, CreateAlertResponses, CreateAlertRuleData, CreateAlertRuleErrors, CreateAlertRuleResponses, CreateAnalysisTemplateData, CreateAnalysisTemplateErrors, CreateAnalysisTemplateResponses, CreateApiKeyData, CreateApiKeyErrors, CreateApiKeyResponses, CreateApproverDelegationData, CreateApproverDelegationErrors, CreateApproverDelegationResponses, CreateArtifactData, CreateArtifactErrors, CreateArtifactResponses, CreateBackfillData, CreateBackfillErrors, CreateBrokerCredentialData, CreateBrokerCredentialResponses, CreateBucketForwardRunData, CreateBucketForwardRunErrors, CreateBucketForwardRunResponses, CreateConversationData, CreateConversationErrors, CreateConversationGroupData, CreateConversationGroupResponses, CreateConversationResponses, CreateDaemonData, CreateDaemonErrors, CreateDaemonResponses, CreateDaemonTriggerData, CreateDaemonTriggerErrors, CreateDaemonTriggerResponses, CreateDashboardData, CreateDashboardErrors, CreateDashboardResponses, CreateDepositData, CreateDepositErrors, CreateDepositResponses, CreateDiscretionaryRunData, CreateDiscretionaryRunErrors, CreateDiscretionaryRunResponses, CreateDynamicFanOutPolicyData, CreateDynamicFanOutPolicyErrors, CreateDynamicFanOutPolicyResponses, CreateEmployeeData, CreateEmployeeErrors, CreateEmployeeResponses, CreateEmployeeTriggerData, CreateEmployeeTriggerErrors, CreateEmployeeTriggerResponses, CreateEntityVersionDraftData, CreateEntityVersionDraftErrors, CreateEntityVersionDraftResponses, CreateEvaluationCaseData, CreateEvaluationCaseErrors, CreateEvaluationCaseResponses, CreateEvaluationDatasetData, CreateEvaluationDatasetResponses, CreateEvaluationTemplateData, CreateEvaluationTemplateErrors, CreateEvaluationTemplateResponses, CreateExchangeCredentialData, CreateExchangeCredentialResponses, CreateExecutionAlgoData, CreateExecutionAlgoErrors, CreateExecutionAlgoResponses, CreateExecutionDeploymentData, CreateExecutionDeploymentErrors, CreateExecutionDeploymentResponses, CreateFinanceStrategyCostModelData, CreateFinanceStrategyCostModelErrors, CreateFinanceStrategyCostModelResponses, CreateFinanceStrategyLifecycleTransitionData, CreateFinanceStrategyLifecycleTransitionErrors, CreateFinanceStrategyLifecycleTransitionResponses, CreateFinanceStrategyRunData, CreateFinanceStrategyRunErrors, CreateFinanceStrategyRunRequestData, CreateFinanceStrategyRunRequestErrors, CreateFinanceStrategyRunRequestResponses, CreateFinanceStrategyRunResponses, CreateHoldingData, CreateHoldingErrors, CreateHoldingResponses, CreateHostMetricsData, CreateHostMetricsErrors, CreateHostMetricsResponses, CreateIntelPlatformData, CreateIntelPlatformResponses, CreateIntelSourceData, CreateIntelSourceErrors, CreateIntelSourceMonitorData, CreateIntelSourceMonitorErrors, CreateIntelSourceMonitorResponses, CreateIntelSourceResponses, CreateIntelSourceSubscriptionData, CreateIntelSourceSubscriptionErrors, CreateIntelSourceSubscriptionResponses, CreateInterventionData, CreateInterventionErrors, CreateInterventionResponses, CreateInvitationData, CreateInvitationErrors, CreateInvitationResponses, CreateLoginData, CreateLoginErrors, CreateLoginResponses, CreateLogoutData, CreateLogoutResponses, CreateMarketDataGrantsData, CreateMarketDataGrantsErrors, CreateMarketDataGrantsResponses, CreateMarketEventReactionData, CreateMarketEventReactionErrors, CreateMarketEventReactionResponses, CreateMarketplaceBundleData, CreateMarketplaceBundleResponses, CreateMcpConnectionData, CreateMcpConnectionErrors, CreateMcpConnectionResponses, CreateMemoryData, CreateMemoryErrors, CreateMemoryResponses, CreateModelRuntimePolicyData, CreateModelRuntimePolicyErrors, CreateModelRuntimePolicyResponses, CreateOrderData, CreateOrderErrors, CreateOrderResponses, CreateOrganizationData, CreateOrganizationErrors, CreateOrganizationResponses, CreateOrUpdateTemplateData, CreateOrUpdateTemplateErrors, CreateOrUpdateTemplateResponses, CreateOrUpdateToolData, CreateOrUpdateToolResponses, CreatePortfolioData, CreatePortfolioErrors, CreatePortfolioResponses, CreateProjectChangeData, CreateProjectChangeResponses, CreateProjectChangeRevisionData, CreateProjectChangeRevisionResponses, CreateProjectCodeRepositoryConnectionData, CreateProjectCodeRepositoryConnectionErrors, CreateProjectCodeRepositoryConnectionResponses, CreateProjectData, CreateProjectErrors, CreateProjectResponses, CreateProjectTeamData, CreateProjectTeamErrors, CreateProjectTeamResponses, CreateProjectThreadData, CreateProjectThreadResponses, CreateProjectWorkstreamCodeGenerationRunData, CreateProjectWorkstreamCodeGenerationRunErrors, CreateProjectWorkstreamCodeGenerationRunResponses, CreateProjectWorkstreamCodePreviewSessionData, CreateProjectWorkstreamCodePreviewSessionErrors, CreateProjectWorkstreamCodePreviewSessionResponses, CreateProjectWorkstreamCodeReviewRequestData, CreateProjectWorkstreamCodeReviewRequestErrors, CreateProjectWorkstreamCodeReviewRequestResponses, CreateRiskLimitData, CreateRiskLimitErrors, CreateRiskLimitResponses, CreateSignupData, CreateSignupErrors, CreateSignupResponses, CreateSnapshotData, CreateSnapshotErrors, CreateSnapshotResponses, CreateSourceData, CreateSourceErrors, CreateSourceResponses, CreateStrategyAdapterResolutionData, CreateStrategyAdapterResolutionErrors, CreateStrategyAdapterResolutionResponses, CreateStrategyBucketEvaluationData, CreateStrategyBucketEvaluationErrors, CreateStrategyBucketEvaluationResponses, CreateStrategyDefinitionEvaluationData, CreateStrategyDefinitionEvaluationErrors, CreateStrategyDefinitionEvaluationResponses, CreateStrategyDefinitionRunData, CreateStrategyDefinitionRunErrors, CreateStrategyDefinitionRunResponses, CreateStrategyDefinitionValidationRunData, CreateStrategyDefinitionValidationRunErrors, CreateStrategyDefinitionValidationRunResponses, CreateSystematicForwardRunData, CreateSystematicForwardRunErrors, CreateSystematicForwardRunResponses, CreateTaskData, CreateTaskErrors, CreateTaskResponses, CreateTeamData, CreateTeamErrors, CreateTeamResponses, CreateTemplateData, CreateTemplateErrors, CreateTemplateResponses, CreateTemplateUpgradeProposalData, CreateTemplateUpgradeProposalErrors, CreateTemplateUpgradeProposalResponses, CreateTickerResearchNoteData, CreateTickerResearchNoteErrors, CreateTickerResearchNoteResponses, CreateToolData, CreateToolErrors, CreateToolLibraryData, CreateToolLibraryErrors, CreateToolLibraryResponses, CreateToolResponses, CreateWalletWatchData, CreateWalletWatchErrors, CreateWalletWatchResponses, CreateWidgetData, CreateWidgetResponses, CreateWithdrawalData, CreateWithdrawalErrors, CreateWithdrawalResponses, CreateWorkerRunData, CreateWorkerRunErrors, CreateWorkerRunResponses, CreateWorkflowData, CreateWorkflowInstanceData, CreateWorkflowInstanceResponses, CreateWorkflowResponses, CreateWorkstreamData, CreateWorkstreamErrors, CreateWorkstreamResponses, DecideGateData, DecideGateErrors, DecideGateResponses, DecideImprovementProposalData, DecideImprovementProposalDesignData, DecideImprovementProposalDesignErrors, DecideImprovementProposalDesignResponses, DecideImprovementProposalErrors, DecideImprovementProposalResponses, DecideProjectWorkstreamCodeReviewRequestData, DecideProjectWorkstreamCodeReviewRequestErrors, DecideProjectWorkstreamCodeReviewRequestResponses, DeferCatalogCandidateData, DeferCatalogCandidateErrors, DeferCatalogCandidateResponses, DeferDaemonDecisionData, DeferDaemonDecisionErrors, DeferDaemonDecisionResponses, DeleteAlertData, DeleteAlertErrors, DeleteAlertResponses, DeleteAlertRuleData, DeleteAlertRuleErrors, DeleteAlertRuleResponses, DeleteAnalysisTemplateData, DeleteAnalysisTemplateErrors, DeleteAnalysisTemplateResponses, DeleteArtifactData, DeleteArtifactErrors, DeleteArtifactResponses, DeleteBrokerCredentialData, DeleteBrokerCredentialResponses, DeleteConversationData, DeleteConversationErrors, DeleteConversationGroupData, DeleteConversationGroupErrors, DeleteConversationGroupResponses, DeleteConversationResponses, DeleteDaemonData, DeleteDaemonErrors, DeleteDaemonResponses, DeleteDaemonTriggerData, DeleteDaemonTriggerErrors, DeleteDaemonTriggerResponses, DeleteDashboardData, DeleteDashboardErrors, DeleteDashboardResponses, DeleteDocumentData, DeleteDocumentResponses, DeleteEmployeeData, DeleteEmployeeErrors, DeleteEmployeeResponses, DeleteEmployeeTriggerData, DeleteEmployeeTriggerErrors, DeleteEmployeeTriggerResponses, DeleteEvaluationCaseData, DeleteEvaluationCaseErrors, DeleteEvaluationCaseResponses, DeleteEvaluationDatasetData, DeleteEvaluationDatasetErrors, DeleteEvaluationDatasetResponses, DeleteExchangeCredentialData, DeleteExchangeCredentialErrors, DeleteExchangeCredentialResponses, DeleteHoldingData, DeleteHoldingErrors, DeleteHoldingResponses, DeleteIntelSourceData, DeleteIntelSourceErrors, DeleteIntelSourceResponses, DeleteMarketEventReactionData, DeleteMarketEventReactionErrors, DeleteMarketEventReactionResponses, DeleteMarketplaceListingData, DeleteMarketplaceListingErrors, DeleteMarketplaceListingResponses, DeleteMcpConnectionData, DeleteMcpConnectionErrors, DeleteMcpConnectionResponses, DeleteMemoryData, DeleteMemoryErrors, DeleteMemoryResponses, DeleteProjectTeamData, DeleteProjectTeamErrors, DeleteProjectTeamResponses, DeleteProjectWorkstreamCodePreviewSessionData, DeleteProjectWorkstreamCodePreviewSessionResponses, DeleteRiskLimitData, DeleteRiskLimitErrors, DeleteRiskLimitResponses, DeleteSnapshotData, DeleteSnapshotErrors, DeleteSnapshotResponses, DeleteTaskData, DeleteTaskErrors, DeleteTaskResponses, DeleteTemplateData, DeleteTemplateErrors, DeleteTemplateResponses, DeleteToolData, DeleteToolErrors, DeleteToolLibraryData, DeleteToolLibraryErrors, DeleteToolLibraryResponses, DeleteToolResponses, DeleteUploadData, DeleteUploadErrors, DeleteUploadResponses, DeleteWalletWatchData, DeleteWalletWatchErrors, DeleteWalletWatchResponses, DeployStrategyData, DeployStrategyErrors, DeployStrategyResponses, DetachFromConversationData, DetachFromConversationErrors, DetachFromConversationResponses, DiffAgentTemplateVersionsData, DiffAgentTemplateVersionsErrors, DiffAgentTemplateVersionsResponses, DiffWorkflowVersionsData, DiffWorkflowVersionsErrors, DiffWorkflowVersionsResponses, DisableConversationIntentData, DisableConversationIntentErrors, DisableConversationIntentResponses, DisableDaemonData, DisableDaemonErrors, DisableDaemonResponses, DisableEmployeeData, DisableEmployeeErrors, DisableEmployeeResponses, DisambiguateConversationIntentData, DisambiguateConversationIntentErrors, DisambiguateConversationIntentResponses, DisconnectMcpConnectionData, DisconnectMcpConnectionErrors, DisconnectMcpConnectionResponses, DiscoverIntelSourceData, DiscoverIntelSourceResponses, DispatchStrategyBucketBacktestData, DispatchStrategyBucketBacktestErrors, DispatchStrategyBucketBacktestResponses, DownloadOutputData, DownloadOutputErrors, DownloadOutputResponses, DtiOperatorKillSwitchData, DtiOperatorKillSwitchErrors, DtiOperatorKillSwitchResponses, DtiOperatorResumeData, DtiOperatorResumeErrors, DtiOperatorResumeResponses, EnableConversationIntentData, EnableConversationIntentErrors, EnableConversationIntentResponses, EnableDaemonData, EnableDaemonErrors, EnableDaemonResponses, EnableEmployeeData, EnableEmployeeErrors, EnableEmployeeResponses, EnableProjectCodeWorkspaceData, EnableProjectCodeWorkspaceErrors, EnableProjectCodeWorkspaceResponses, EnableProjectWorkstreamCodeWorkforceData, EnableProjectWorkstreamCodeWorkforceErrors, EnableProjectWorkstreamCodeWorkforceResponses, EnqueueFinanceIndicatorDecisionData, EnqueueFinanceIndicatorDecisionErrors, EnqueueFinanceIndicatorDecisionResponses, EnqueueFinanceStrategyTemplateRunData, EnqueueFinanceStrategyTemplateRunErrors, EnqueueFinanceStrategyTemplateRunResponses, EscalateRiskBreachData, EscalateRiskBreachErrors, EscalateRiskBreachResponses, EvaluateFinanceStrategyDecisionData, EvaluateFinanceStrategyDecisionErrors, EvaluateFinanceStrategyDecisionResponses, EvaluateFinanceStrategyDefinitionData, EvaluateFinanceStrategyDefinitionErrors, EvaluateFinanceStrategyDefinitionResponses, ExecuteAgentData, ExecuteAgentErrors, ExecuteAgentResponses, ExecuteStepData, ExecuteStepResponses, ExecuteStepStreamData, ExecuteStepStreamErrors, ExecuteStepStreamResponse, ExecuteStepStreamResponses, ExpandImprovementTierData, ExpandImprovementTierErrors, ExpandImprovementTierResponses, ExportInstructionsData, ExportInstructionsResponses, ExportWorkflowInstructionsData, ExportWorkflowInstructionsResponses, ExtendApprovalTimeoutData, ExtendApprovalTimeoutErrors, ExtendApprovalTimeoutResponses, FetchAiWorkerDataResultData, FetchAiWorkerDataResultErrors, FetchAiWorkerDataResultResponses, FetchIntelSourceData, FetchIntelSourceErrors, FetchIntelSourceMonitorData, FetchIntelSourceMonitorErrors, FetchIntelSourceMonitorResponses, FetchIntelSourceResponses, FillTemplateData, FillTemplateErrors, FillTemplateResponses, FinalizeUploadData, FinalizeUploadErrors, FinalizeUploadResponses, FollowUpWorkerRunData, FollowUpWorkerRunErrors, FollowUpWorkerRunResponses, ForkMarketplaceListingData, ForkMarketplaceListingErrors, ForkMarketplaceListingResponses, ForkStrategyDefinitionData, ForkStrategyDefinitionErrors, ForkStrategyDefinitionResponses, GenerateOrderBookHeatmapData, GenerateOrderBookHeatmapResponses, GeneratePineScriptData, GeneratePineScriptResponses, GenerateStrategyDocsData, GenerateStrategyDocsErrors, GenerateStrategyDocsResponses, GetAccountFxCashData, GetAccountFxCashErrors, GetAccountFxCashResponses, GetActiveRunData, GetActiveRunResponses, GetActiveStrategyData, GetActiveStrategyErrors, GetActiveStrategyResponses, GetAdminUserData, GetAdminUserErrors, GetAdminUserResponses, GetAgentHealthData, GetAgentHealthResponses, GetAgentStatusData, GetAgentStatusResponses, GetAgentTemplateVersionComparisonData, GetAgentTemplateVersionComparisonErrors, GetAgentTemplateVersionComparisonResponses, GetAgentWorkflowRunData, GetAgentWorkflowRunDebuggerData, GetAgentWorkflowRunDebuggerErrors, GetAgentWorkflowRunDebuggerResponses, GetAgentWorkflowRunErrors, GetAgentWorkflowRunResponses, GetAlertRuleData, GetAlertRuleErrors, GetAlertRuleResponses, GetAnalysisData, GetAnalysisErrors, GetAnalysisResponses, GetAnalysisTemplateData, GetAnalysisTemplateErrors, GetAnalysisTemplateResponses, GetApiKeyData, GetApiKeyErrors, GetApiKeyResponses, GetArtifactData, GetArtifactErrors, GetArtifactResponses, GetAssetSentimentData, GetAssetSentimentResponses, GetAttributionRunData, GetAttributionRunErrors, GetAttributionRunResponses, GetBrokerCredentialData, GetBrokerCredentialResponses, GetCapacityCurveData, GetCapacityCurveErrors, GetCapacityCurveResponses, GetCapitalAllocationData, GetCapitalAllocationErrors, GetCapitalAllocationResponses, GetCatalogCandidateData, GetCatalogCandidateErrors, GetCatalogCandidateResponses, GetContentDetailsData, GetContentDetailsErrors, GetContentDetailsResponses, GetContentStatsData, GetContentStatsResponses, GetContractHealthData, GetContractHealthResponses, GetConversationContextData, GetConversationContextErrors, GetConversationContextResponses, GetConversationData, GetConversationErrors, GetConversationMessageByIdData, GetConversationMessageByIdErrors, GetConversationMessageByIdResponses, GetConversationResponses, GetCurrentSessionData, GetCurrentSessionResponses, GetDaemonData, GetDaemonDecisionData, GetDaemonDecisionErrors, GetDaemonDecisionResponses, GetDaemonErrors, GetDaemonReadinessData, GetDaemonReadinessErrors, GetDaemonReadinessResponses, GetDaemonResponses, GetDaemonRunAuditData, GetDaemonRunAuditErrors, GetDaemonRunAuditResponses, GetDaemonRunData, GetDaemonRunErrors, GetDaemonRunResponses, GetDaemonsSummaryData, GetDaemonsSummaryResponses, GetDaemonTrendData, GetDaemonTrendErrors, GetDaemonTrendResponses, GetDashboardData, GetDashboardErrors, GetDashboardResponses, GetDebugStepOutputsData, GetDebugStepOutputsResponses, GetDecisionData, GetDecisionErrors, GetDecisionResponses, GetDecisionStatsData, GetDecisionStatsResponses, GetDiscoveredStrategyData, GetDiscoveredStrategyErrors, GetDiscoveredStrategyResponses, GetDiscoverySummaryData, GetDiscoverySummaryResponses, GetDocumentData, GetDocumentResponses, GetDynamicFanOutPolicyData, GetDynamicFanOutPolicyErrors, GetDynamicFanOutPolicyResponses, GetEmployeeData, GetEmployeeErrors, GetEmployeeReadinessData, GetEmployeeReadinessErrors, GetEmployeeReadinessResponses, GetEmployeeResponses, GetEmployeeRunAuditData, GetEmployeeRunAuditErrors, GetEmployeeRunAuditResponses, GetEmployeeRunData, GetEmployeeRunErrors, GetEmployeeRunResponses, GetEmployeeTrendData, GetEmployeeTrendErrors, GetEmployeeTrendResponses, GetEvaluationRunData, GetEvaluationRunErrors, GetEvaluationRunResponses, GetEvaluationTemplateData, GetEvaluationTemplateErrors, GetEvaluationTemplateResponses, GetExecutionAlgoData, GetExecutionAlgoErrors, GetExecutionAlgoResponses, GetExecutionDeploymentData, GetExecutionDeploymentErrors, GetExecutionDeploymentResponses, GetExecutionStatusData, GetExecutionStatusResponses, GetFinanceArtifactPreviewData, GetFinanceArtifactPreviewErrors, GetFinanceArtifactPreviewResponses, GetFinanceAuditLedgerChainData, GetFinanceAuditLedgerChainErrors, GetFinanceAuditLedgerChainResponses, GetFinanceAuditLedgerHeadData, GetFinanceAuditLedgerHeadErrors, GetFinanceAuditLedgerHeadResponses, GetFinanceAuditLedgerOrderHistoryData, GetFinanceAuditLedgerOrderHistoryErrors, GetFinanceAuditLedgerOrderHistoryResponses, GetFinanceBucketCompositionData, GetFinanceBucketCompositionErrors, GetFinanceBucketCompositionResponses, GetFinanceIndicatorDecisionData, GetFinanceIndicatorDecisionErrors, GetFinanceIndicatorDecisionResponses, GetFinanceKgNodeEdgesData, GetFinanceKgNodeEdgesErrors, GetFinanceKgNodeEdgesResponses, GetFinanceKgRegimeProfileData, GetFinanceKgRegimeProfileErrors, GetFinanceKgRegimeProfileResponses, GetFinanceModelLineageData, GetFinanceModelLineageErrors, GetFinanceModelLineageGraphData, GetFinanceModelLineageGraphErrors, GetFinanceModelLineageGraphResponses, GetFinanceModelLineageHistoryData, GetFinanceModelLineageHistoryErrors, GetFinanceModelLineageHistoryResponses, GetFinanceModelLineageResponses, GetFinanceOperationsSummaryData, GetFinanceOperationsSummaryErrors, GetFinanceOperationsSummaryResponses, GetFinanceProviderUnlockPromptData, GetFinanceProviderUnlockPromptErrors, GetFinanceProviderUnlockPromptResponses, GetFinanceStrategyCostModelData, GetFinanceStrategyCostModelErrors, GetFinanceStrategyCostModelResponses, GetFinanceStrategyDecisionData, GetFinanceStrategyDecisionErrors, GetFinanceStrategyDecisionResponses, GetFinanceStrategyRunData, GetFinanceStrategyRunErrors, GetFinanceStrategyRunRequestData, GetFinanceStrategyRunRequestErrors, GetFinanceStrategyRunRequestResponses, GetFinanceStrategyRunResponses, GetFinanceStrategyTemplateData, GetFinanceStrategyTemplateErrors, GetFinanceStrategyTemplateResponses, GetForwardRunData, GetForwardRunErrors, GetForwardRunResponses, GetImprovementMetricsData, GetImprovementMetricsErrors, GetImprovementMetricsResponses, GetImprovementProposalData, GetImprovementProposalErrors, GetImprovementProposalResponses, GetImprovementTierStatusData, GetImprovementTierStatusErrors, GetImprovementTierStatusResponses, GetIntelPlatformUsageData, GetIntelPlatformUsageErrors, GetIntelPlatformUsageResponses, GetIntelSourceData, GetIntelSourceErrors, GetIntelSourceHarvestedData, GetIntelSourceHarvestedErrors, GetIntelSourceHarvestedResponses, GetIntelSourceResponses, GetIntelSourceStyleProfileData, GetIntelSourceStyleProfileErrors, GetIntelSourceStyleProfileResponses, GetIntelSourceViewConfirmationData, GetIntelSourceViewConfirmationErrors, GetIntelSourceViewConfirmationResponses, GetInterventionData, GetInterventionErrors, GetInterventionResponses, GetLatestOutputData, GetLatestOutputResponses, GetMarketDataBackupData, GetMarketDataBackupErrors, GetMarketDataBackupResponses, GetMarketDataCoverageData, GetMarketDataCoverageErrors, GetMarketDataCoverageResponses, GetMarketDataStatusData, GetMarketDataStatusErrors, GetMarketplaceBundleData, GetMarketplaceBundleErrors, GetMarketplaceBundleResponses, GetMarketplaceEntityVersionsData, GetMarketplaceEntityVersionsErrors, GetMarketplaceEntityVersionsResponses, GetMcpConnectionData, GetMcpConnectionErrors, GetMcpConnectionResponses, GetMeData, GetMeErrors, GetMemoryData, GetMemoryErrors, GetMemoryResponses, GetMeResponses, GetMlHealthData, GetMlHealthErrors, GetMlHealthResponses, GetMlRegimeData, GetMlRegimeErrors, GetMlRegimeResponses, GetMlStrategyScoresData, GetMlStrategyScoresErrors, GetMlStrategyScoresResponses, GetModelData, GetModelErrors, GetModelResponses, GetModelRuntimePolicyData, GetModelRuntimePolicyErrors, GetModelRuntimePolicyResponses, GetMyOrganizationsData, GetMyOrganizationsResponses, GetMyTeamsInOrgData, GetMyTeamsInOrgResponses, GetNotificationConfigData, GetNotificationConfigResponses, GetOrderBookData, GetOrderBookErrors, GetOrderBookResponses, GetOrderData, GetOrderErrors, GetOrderResponses, GetOrganizationData, GetOrganizationErrors, GetOrganizationResponses, GetOutputData, GetOutputErrors, GetOutputMetricsData, GetOutputMetricsResponses, GetOutputResponses, GetPerformanceMetricsData, GetPerformanceMetricsErrors, GetPerformanceMetricsResponses, GetPortfolioData, GetPortfolioErrors, GetPortfolioResponses, GetPortfolioSnapshotData, GetPortfolioSnapshotErrors, GetPortfolioSnapshotResponses, GetPortfolioValuationData, GetPortfolioValuationErrors, GetPortfolioValuationResponses, GetPortTypeColorsData, GetPortTypeColorsResponses, GetPortTypeData, GetPortTypeErrors, GetPortTypeResponses, GetPositionData, GetPositionErrors, GetPositionResponses, GetPositionValuationData, GetPositionValuationErrors, GetPositionValuationResponses, GetPriceData, GetPriceErrors, GetPriceResponses, GetProjectChangeData, GetProjectChangeErrors, GetProjectChangeResponses, GetProjectCodeClientDatabaseData, GetProjectCodeClientDatabaseErrors, GetProjectCodeClientDatabaseResponses, GetProjectCodeOperationalMetricsData, GetProjectCodeOperationalMetricsErrors, GetProjectCodeOperationalMetricsResponses, GetProjectCodeWorkspaceData, GetProjectCodeWorkspaceErrors, GetProjectCodeWorkspaceResponses, GetProjectCommandCenterData, GetProjectCommandCenterErrors, GetProjectCommandCenterResponses, GetProjectData, GetProjectErrors, GetProjectLogData, GetProjectLogErrors, GetProjectLogResponses, GetProjectResponses, GetProjectStateData, GetProjectStateErrors, GetProjectStateResponses, GetProjectSummaryData, GetProjectSummaryErrors, GetProjectSummaryResponses, GetProjectTeamData, GetProjectTeamErrors, GetProjectTeamResponses, GetProjectWorkstreamCodeReviewRequestData, GetProjectWorkstreamCodeReviewRequestErrors, GetProjectWorkstreamCodeReviewRequestResponses, GetProjectWorkstreamCodeTuningViewData, GetProjectWorkstreamCodeTuningViewErrors, GetProjectWorkstreamCodeTuningViewResponses, GetPromotionCandidateData, GetPromotionCandidateErrors, GetPromotionCandidateResponses, GetReasoningCallSummaryData, GetReasoningCallSummaryResponses, GetReasoningPrincipleSummaryData, GetReasoningPrincipleSummaryResponses, GetRecentMessagesData, GetRecentMessagesResponses, GetRecommendationData, GetRecommendationErrors, GetRecommendationResponses, GetRiskProfilesData, GetRiskProfilesResponses, GetRiskStatusData, GetRiskStatusResponses, GetRunHealthAggregatesData, GetRunHealthAggregatesResponses, GetSessionStatsData, GetSessionStatsResponses, GetSessionTimesData, GetSessionTimesResponses, GetShadowModeDaemonData, GetShadowModeDaemonErrors, GetShadowModeDaemonResponses, GetSignalAccuracyData, GetSignalAccuracyResponses, GetSignalActivityData, GetSignalActivityResponses, GetSkillData, GetSkillErrors, GetSkillResponses, GetSnapshotData, GetSnapshotErrors, GetSnapshotResponses, GetSourceData, GetSourceErrors, GetSourceResponses, GetStepBuilderContextData, GetStepBuilderContextErrors, GetStepBuilderContextResponses, GetStrategyBucketDefinitionData, GetStrategyBucketDefinitionErrors, GetStrategyBucketDefinitionResponses, GetStrategyData, GetStrategyDefinitionData, GetStrategyDefinitionErrors, GetStrategyDefinitionResponses, GetStrategyDeploymentStatusData, GetStrategyDeploymentStatusErrors, GetStrategyDeploymentStatusResponses, GetStrategyDiscoveryStatsData, GetStrategyDiscoveryStatsResponses, GetStrategyErrors, GetStrategyResponses, GetStrategyRunAnalyticsData, GetStrategyRunAnalyticsErrors, GetStrategyRunAnalyticsResponses, GetStrategyRunArtifactData, GetStrategyRunArtifactErrors, GetStrategyRunArtifactResponses, GetStrategyRunResultData, GetStrategyRunResultErrors, GetStrategyRunResultResponses, GetStressResultData, GetStressResultErrors, GetStressResultResponses, GetStressScenarioData, GetStressScenarioErrors, GetStressScenarioResponses, GetSubjectEvaluationsData, GetSubjectEvaluationsResponses, GetSystemDatabaseData, GetSystemDatabaseErrors, GetSystemDatabaseResponses, GetSystemDatabaseSeriesData, GetSystemDatabaseSeriesErrors, GetSystemDatabaseSeriesResponses, GetSystemHealthData, GetSystemHealthErrors, GetSystemHealthResponses, GetSystemHostData, GetSystemHostErrors, GetSystemHostResponses, GetSystemHostSeriesData, GetSystemHostSeriesErrors, GetSystemHostSeriesResponses, GetSystemOverviewData, GetSystemOverviewResponses, GetSystemRedisData, GetSystemRedisResponses, GetSystemRedisSeriesData, GetSystemRedisSeriesErrors, GetSystemRedisSeriesResponses, GetTaskData, GetTaskErrors, GetTaskResponses, GetTemplateData, GetTemplateErrors, GetTemplateResponses, GetToolData, GetToolErrors, GetToolGapsData, GetToolGapsResponses, GetToolLibraryData, GetToolLibraryErrors, GetToolLibraryResponses, GetToolResponses, GetTradeStatsData, GetTradeStatsResponses, GetTradingAccountData, GetTradingAccountErrors, GetTradingAccountResponses, GetTradingViewConfigData, GetTradingViewConfigResponses, GetUploadContentData, GetUploadContentErrors, GetUploadContentResponses, GetUserAuditLogData, GetUserAuditLogErrors, GetUserAuditLogResponses, GetVarEstimateData, GetVarEstimateErrors, GetVarEstimateResponses, GetWaitingOnMeData, GetWaitingOnMeErrors, GetWaitingOnMeResponses, GetWalletWatchData, GetWalletWatchErrors, GetWalletWatchResponses, GetWatchlistEntryData, GetWatchlistEntryErrors, GetWatchlistEntryResponses, GetWidgetData, GetWidgetErrors, GetWidgetResponses, GetWorkerRunData, GetWorkerRunErrors, GetWorkerRunResponses, GetWorkflowCloseSummaryData, GetWorkflowCloseSummaryErrors, GetWorkflowCloseSummaryResponses, GetWorkflowData, GetWorkflowErrors, GetWorkflowGateData, GetWorkflowGateErrors, GetWorkflowGateResponses, GetWorkflowInstanceData, GetWorkflowInstanceErrors, GetWorkflowInstanceResponses, GetWorkflowResponses, GetWorkflowVersionData, GetWorkflowVersionErrors, GetWorkflowVersionResponses, GetWorkforceSummaryData, GetWorkforceSummaryResponses, GetWorkstreamData, GetWorkstreamErrors, GetWorkstreamResponses, GraduateShadowModeDaemonData, GraduateShadowModeDaemonErrors, GraduateShadowModeDaemonResponses, GrantDaemonRunExecutionEnvelopePermissionData, GrantDaemonRunExecutionEnvelopePermissionErrors, GrantDaemonRunExecutionEnvelopePermissionResponses, GrantEmployeeRunExecutionEnvelopePermissionData, GrantEmployeeRunExecutionEnvelopePermissionErrors, GrantEmployeeRunExecutionEnvelopePermissionResponses, HandleGitHubCodeWorkspaceWebhookData, HandleGitHubCodeWorkspaceWebhookErrors, HandleGitHubCodeWorkspaceWebhookResponses, HeartbeatAiWorkerData, HeartbeatAiWorkerErrors, HeartbeatAiWorkerResponses, HeartbeatProjectWorkstreamCodePreviewSessionData, HeartbeatProjectWorkstreamCodePreviewSessionErrors, HeartbeatProjectWorkstreamCodePreviewSessionResponses, ImportFinanceStrategyCorpusData, ImportFinanceStrategyCorpusErrors, ImportFinanceStrategyCorpusResponses, InstallMarketplaceListingData, InstallMarketplaceListingErrors, InstallMarketplaceListingResponses, InviteToConversationData, InviteToConversationErrors, InviteToConversationResponses, LinkAccountData, LinkAccountErrors, LinkAccountResponses, LinkProjectThreadResourceData, LinkProjectThreadResourceResponses, ListActionQueueData, ListActionQueueResponses, ListActiveAgentsData, ListActiveAgentsResponses, ListActiveStrategiesData, ListActiveStrategiesResponses, ListAdminDaemonFindingsData, ListAdminDaemonFindingsResponses, ListAdminUsersData, ListAdminUsersResponses, ListAgentTemplateVersionsData, ListAgentTemplateVersionsResponses, ListAgentWorkflowRunsData, ListAgentWorkflowRunsResponses, ListAgentWorkflowsData, ListAgentWorkflowsResponses, ListAlertRulesData, ListAlertRulesResponses, ListAlertsBySymbolData, ListAlertsBySymbolResponses, ListAlertsData, ListAlertsResponses, ListAnalysesData, ListAnalysesResponses, ListAnalysisTemplatesData, ListAnalysisTemplatesResponses, ListApiKeyGrantablePermissionsData, ListApiKeyGrantablePermissionsErrors, ListApiKeyGrantablePermissionsResponses, ListApiKeysData, ListApiKeysErrors, ListApiKeysResponses, ListApprovedStrategiesData, ListApprovedStrategiesResponses, ListApproverDelegationsData, ListApproverDelegationsErrors, ListApproverDelegationsResponses, ListArtifactsData, ListArtifactsResponses, ListAttributionEffectsData, ListAttributionEffectsErrors, ListAttributionEffectsResponses, ListAttributionRunsData, ListAttributionRunsErrors, ListAttributionRunsResponses, ListBookSnapshotsData, ListBookSnapshotsErrors, ListBookSnapshotsResponses, ListBrokerCredentialsData, ListBrokerCredentialsResponses, ListCandlesData, ListCandlesResponses, ListCapacityCurvesData, ListCapacityCurvesErrors, ListCapacityCurvesResponses, ListCapitalAllocationsData, ListCapitalAllocationsErrors, ListCapitalAllocationSleevesData, ListCapitalAllocationSleevesErrors, ListCapitalAllocationSleevesResponses, ListCapitalAllocationsResponses, ListCatalogCandidatesData, ListCatalogCandidatesErrors, ListCatalogCandidatesResponses, ListCatalogItemVersionsData, ListCatalogItemVersionsErrors, ListCatalogItemVersionsResponses, ListCatalogReviewQueueData, ListCatalogReviewQueueErrors, ListCatalogReviewQueueResponses, ListCatalogSourcesData, ListCatalogSourcesErrors, ListCatalogSourcesResponses, ListCatalogVersionAdoptionsData, ListCatalogVersionAdoptionsErrors, ListCatalogVersionAdoptionsResponses, ListContractEventsData, ListContractEventsResponses, ListConversationArtifactsData, ListConversationArtifactsErrors, ListConversationArtifactsResponses, ListConversationAttachmentsData, ListConversationAttachmentsErrors, ListConversationAttachmentsResponses, ListConversationEntitiesData, ListConversationEntitiesErrors, ListConversationEntitiesResponses, ListConversationGroupsData, ListConversationGroupsResponses, ListConversationIntentsData, ListConversationIntentsErrors, ListConversationIntentsResponses, ListConversationMembersData, ListConversationMembersErrors, ListConversationMembersResponses, ListConversationMessagesData, ListConversationMessagesErrors, ListConversationMessagesResponses, ListConversationsData, ListConversationsResponses, ListCrowdingScoresData, ListCrowdingScoresErrors, ListCrowdingScoresResponses, ListDaemonFindingsData, ListDaemonFindingsErrors, ListDaemonFindingsResponses, ListDaemonPermissionGrantsData, ListDaemonPermissionGrantsErrors, ListDaemonPermissionGrantsResponses, ListDaemonReflectionsData, ListDaemonReflectionsErrors, ListDaemonReflectionsResponses, ListDaemonRunDecisionsData, ListDaemonRunDecisionsErrors, ListDaemonRunDecisionsResponses, ListDaemonRunExecutionEnvelopesData, ListDaemonRunExecutionEnvelopesErrors, ListDaemonRunExecutionEnvelopesResponses, ListDaemonRunReportsData, ListDaemonRunReportsErrors, ListDaemonRunReportsResponses, ListDaemonRunsData, ListDaemonRunsErrors, ListDaemonRunsResponses, ListDaemonsAssignmentsData, ListDaemonsAssignmentsResponses, ListDaemonsData, ListDaemonsEventCatalogData, ListDaemonsEventCatalogResponses, ListDaemonsResponses, ListDaemonTriggersData, ListDaemonTriggersErrors, ListDaemonTriggersResponses, ListDaemonWorkflowsData, ListDaemonWorkflowsErrors, ListDaemonWorkflowsResponses, ListDashboardsData, ListDashboardsResponses, ListDeadLetterEntriesData, ListDeadLetterEntriesResponses, ListDepartmentsData, ListDepartmentsResponses, ListDiscoveredStrategiesData, ListDiscoveredStrategiesResponses, ListDocumentsData, ListDocumentsResponses, ListDynamicFanOutPoliciesData, ListDynamicFanOutPoliciesResponses, ListEconomicEventsData, ListEconomicEventsResponses, ListEmployeeFindingsData, ListEmployeeFindingsErrors, ListEmployeeFindingsResponses, ListEmployeePermissionGrantsData, ListEmployeePermissionGrantsErrors, ListEmployeePermissionGrantsResponses, ListEmployeeReflectionsData, ListEmployeeReflectionsErrors, ListEmployeeReflectionsResponses, ListEmployeeRunDecisionsData, ListEmployeeRunDecisionsErrors, ListEmployeeRunDecisionsResponses, ListEmployeeRunExecutionEnvelopesData, ListEmployeeRunExecutionEnvelopesErrors, ListEmployeeRunExecutionEnvelopesResponses, ListEmployeeRunReportsData, ListEmployeeRunReportsErrors, ListEmployeeRunReportsResponses, ListEmployeeRunsData, ListEmployeeRunsErrors, ListEmployeeRunsResponses, ListEmployeesData, ListEmployeesResponses, ListEmployeeTriggersData, ListEmployeeTriggersErrors, ListEmployeeTriggersResponses, ListEmployeeWorkflowsData, ListEmployeeWorkflowsErrors, ListEmployeeWorkflowsResponses, ListEntityVersionsData, ListEntityVersionsErrors, ListEntityVersionsResponses, ListEvaluationCasesData, ListEvaluationCasesErrors, ListEvaluationCasesResponses, ListEvaluationDatasetsData, ListEvaluationDatasetsResponses, ListEvaluationTemplatesData, ListEvaluationTemplatesResponses, ListExchangeCredentialsData, ListExchangeCredentialsResponses, ListExecutionAlgosData, ListExecutionAlgosErrors, ListExecutionAlgosResponses, ListExecutionDeploymentsData, ListExecutionDeploymentsErrors, ListExecutionDeploymentsResponses, ListFinanceConversationPersonasData, ListFinanceConversationPersonasErrors, ListFinanceConversationPersonasResponses, ListFinanceDataBlockersData, ListFinanceDataBlockersErrors, ListFinanceDataBlockersResponses, ListFinanceIndicatorDecisionsData, ListFinanceIndicatorDecisionsErrors, ListFinanceIndicatorDecisionsResponses, ListFinanceIndicatorsData, ListFinanceIndicatorsErrors, ListFinanceIndicatorsResponses, ListFinanceModelLineageData, ListFinanceModelLineageErrors, ListFinanceModelLineageResponses, ListFinancePlannerRecommendationsData, ListFinancePlannerRecommendationsErrors, ListFinancePlannerRecommendationsResponses, ListFinanceProviderUnlockPromptsData, ListFinanceProviderUnlockPromptsErrors, ListFinanceProviderUnlockPromptsResponses, ListFinanceResearchWorkflowsData, ListFinanceResearchWorkflowsErrors, ListFinanceResearchWorkflowsResponses, ListFinanceStrategyCostModelsData, ListFinanceStrategyCostModelsErrors, ListFinanceStrategyCostModelsResponses, ListFinanceStrategyDecisionsData, ListFinanceStrategyDecisionsErrors, ListFinanceStrategyDecisionsResponses, ListFinanceStrategyLifecycleTransitionsData, ListFinanceStrategyLifecycleTransitionsErrors, ListFinanceStrategyLifecycleTransitionsResponses, ListFinanceStrategyRunRequestsData, ListFinanceStrategyRunRequestsErrors, ListFinanceStrategyRunRequestsResponses, ListFinanceStrategyRunsData, ListFinanceStrategyRunsErrors, ListFinanceStrategyRunsResponses, ListFinanceStrategyTemplatesData, ListFinanceStrategyTemplatesErrors, ListFinanceStrategyTemplatesResponses, ListForwardRunsData, ListForwardRunsErrors, ListForwardRunsResponses, ListHarvestedContentData, ListHarvestedContentResponses, ListHoldingsData, ListHoldingsErrors, ListHoldingsResponses, ListImprovementProposalsData, ListImprovementProposalsErrors, ListImprovementProposalsResponses, ListIngestionJobsData, ListIngestionJobsResponses, ListIntelPlatformsData, ListIntelPlatformsResponses, ListIntelSourceFetchRunsData, ListIntelSourceFetchRunsErrors, ListIntelSourceFetchRunsResponses, ListIntelSourceItemInsightsData, ListIntelSourceItemInsightsErrors, ListIntelSourceItemInsightsResponses, ListIntelSourceMonitorFetchRunsData, ListIntelSourceMonitorFetchRunsErrors, ListIntelSourceMonitorFetchRunsResponses, ListIntelSourceMonitorsData, ListIntelSourceMonitorsResponses, ListIntelSourcesData, ListIntelSourcesResponses, ListIntelSourceSubscriptionsData, ListIntelSourceSubscriptionsResponses, ListInterventionsData, ListInterventionsResponses, ListJourneyEventsData, ListJourneyEventsErrors, ListJourneyEventsResponses, ListJourneyRawEventsData, ListJourneyRawEventsErrors, ListJourneyRawEventsResponses, ListJourneysData, ListJourneysResponses, ListLinkedAccountsData, ListLinkedAccountsResponses, ListLlmCallCostOutliersData, ListLlmCallCostOutliersResponses, ListLlmCallLatencyOutliersData, ListLlmCallLatencyOutliersResponses, ListLotDisposalsData, ListLotDisposalsErrors, ListLotDisposalsResponses, ListMarketEventReactionsData, ListMarketEventReactionsResponses, ListMarketEventReactionTypesData, ListMarketEventReactionTypesResponses, ListMarketplaceInstallationsData, ListMarketplaceInstallationsResponses, ListMarketplaceListingsData, ListMarketplaceListingsResponses, ListMarketplaceNeedsSetupData, ListMarketplaceNeedsSetupResponses, ListMarketplaceUpdatesData, ListMarketplaceUpdatesErrors, ListMarketplaceUpdatesResponses, ListMcpConnectionsData, ListMcpConnectionsResponses, ListMcpConnectionToolsData, ListMcpConnectionToolsErrors, ListMcpConnectionToolsResponses, ListMemoriesData, ListMemoriesResponses, ListModelRuntimePoliciesData, ListModelRuntimePoliciesResponses, ListModelsData, ListModelsResponses, ListMyModulesData, ListMyModulesErrors, ListMyModulesResponses, ListOrdersData, ListOrdersResponses, ListOrganizationRuntimeFlagsData, ListOrganizationRuntimeFlagsErrors, ListOrganizationRuntimeFlagsResponses, ListOrganizationsData, ListOrganizationsResponses, ListOrgInvitationsData, ListOrgInvitationsErrors, ListOrgInvitationsResponses, ListOrgMembersData, ListOrgMembersErrors, ListOrgMembersResponses, ListOutputPartKindsData, ListOutputPartKindsResponses, ListPendingDecisionsData, ListPendingDecisionsResponses, ListPinnedWidgetsData, ListPinnedWidgetsErrors, ListPinnedWidgetsResponses, ListPlatformRuntimeFlagsData, ListPlatformRuntimeFlagsErrors, ListPlatformRuntimeFlagsResponses, ListPortfoliosData, ListPortfoliosErrors, ListPortfolioSnapshotsData, ListPortfolioSnapshotsErrors, ListPortfolioSnapshotsResponses, ListPortfoliosResponses, ListPortTypesData, ListPortTypesErrors, ListPortTypesResponses, ListPositionLotsData, ListPositionLotsErrors, ListPositionLotsResponses, ListPositionsData, ListPositionsResponses, ListPricesData, ListPricesErrors, ListPricesResponses, ListProjectChangesData, ListProjectChangesErrors, ListProjectChangesResponses, ListProjectCodeCheckpointsData, ListProjectCodeCheckpointsErrors, ListProjectCodeCheckpointsResponses, ListProjectCodeRepositoryConnectionsData, ListProjectCodeRepositoryConnectionsErrors, ListProjectCodeRepositoryConnectionsResponses, ListProjectCodeWorkspaceOperationsData, ListProjectCodeWorkspaceOperationsErrors, ListProjectCodeWorkspaceOperationsResponses, ListProjectMembersData, ListProjectMembersErrors, ListProjectMembersResponses, ListProjectsData, ListProjectsResponses, ListProjectStateEventsData, ListProjectStateEventsErrors, ListProjectStateEventsResponses, ListProjectTeamMembersData, ListProjectTeamMembersErrors, ListProjectTeamMembersResponses, ListProjectTeamsData, ListProjectTeamsErrors, ListProjectTeamsResponses, ListProjectThreadsData, ListProjectThreadsResponses, ListProjectWorkModeTemplatesData, ListProjectWorkModeTemplatesErrors, ListProjectWorkModeTemplatesResponses, ListProjectWorkstreamCodeReviewRequestsData, ListProjectWorkstreamCodeReviewRequestsErrors, ListProjectWorkstreamCodeReviewRequestsResponses, ListPromotionCandidatesData, ListPromotionCandidatesResponses, ListPromptTemplatesData, ListPromptTemplatesResponses, ListReasoningEvaluationsData, ListReasoningEvaluationsResponses, ListRiskBreachesData, ListRiskBreachesResponses, ListRiskHaltsData, ListRiskHaltsResponses, ListRiskLimitsData, ListRiskLimitsResponses, ListRunsData, ListRunsResponses, ListRuntimePolicyOptionsData, ListRuntimePolicyOptionsResponses, ListRuntimePolicySurfaceRulesData, ListRuntimePolicySurfaceRulesResponses, ListShadowModeDaemonsData, ListShadowModeDaemonsErrors, ListShadowModeDaemonsResponses, ListSignalsData, ListSignalsResponses, ListSkillsData, ListSkillsResponses, ListSnapshotsData, ListSnapshotsErrors, ListSnapshotsResponses, ListSourcesData, ListSourcesResponses, ListStrategiesData, ListStrategiesResponses, ListStrategyAdapterResolutionsData, ListStrategyAdapterResolutionsErrors, ListStrategyAdapterResolutionsResponses, ListStrategyBucketDefinitionsData, ListStrategyBucketDefinitionsErrors, ListStrategyBucketDefinitionsResponses, ListStrategyBucketEvaluationsData, ListStrategyBucketEvaluationsErrors, ListStrategyBucketEvaluationsResponses, ListStrategyDefinitionEvaluationsData, ListStrategyDefinitionEvaluationsErrors, ListStrategyDefinitionEvaluationsResponses, ListStrategyDefinitionGroupsData, ListStrategyDefinitionGroupsErrors, ListStrategyDefinitionGroupsResponses, ListStrategyDefinitionRunsData, ListStrategyDefinitionRunsErrors, ListStrategyDefinitionRunsResponses, ListStrategyDefinitionsData, ListStrategyDefinitionsErrors, ListStrategyDefinitionsResponses, ListStrategyDefinitionSummariesData, ListStrategyDefinitionSummariesErrors, ListStrategyDefinitionSummariesResponses, ListStrategyExtensionDescriptorsData, ListStrategyExtensionDescriptorsErrors, ListStrategyExtensionDescriptorsResponses, ListStressResultsData, ListStressResultsErrors, ListStressResultsResponses, ListStressScenariosData, ListStressScenariosErrors, ListStressScenariosResponses, ListSystemDatabaseStatementsData, ListSystemDatabaseStatementsErrors, ListSystemDatabaseStatementsResponses, ListTaskDecisionsData, ListTaskDecisionsErrors, ListTaskDecisionsResponses, ListTasksData, ListTasksResponses, ListTcaScorecardsData, ListTcaScorecardsErrors, ListTcaScorecardsResponses, ListTeamMembersData, ListTeamMembersErrors, ListTeamMembersResponses, ListTeamsData, ListTeamsResponses, ListTemplatesData, ListTemplatesResponses, ListToolLibrariesData, ListToolLibrariesResponses, ListToolLibraryToolsData, ListToolLibraryToolsErrors, ListToolLibraryToolsResponses, ListToolsData, ListToolsResponses, ListTopSourcesData, ListTopSourcesResponses, ListTradesData, ListTradesResponses, ListVarBacktestsData, ListVarBacktestsErrors, ListVarBacktestsResponses, ListVarComponentsData, ListVarComponentsErrors, ListVarComponentsResponses, ListVarEstimatesData, ListVarEstimatesErrors, ListVarEstimatesResponses, ListWalletWatchesData, ListWalletWatchesResponses, ListWatchlistData, ListWatchlistResponses, ListWidgetsData, ListWidgetsResponses, ListWorkflowExecutionObservationsData, ListWorkflowExecutionObservationsErrors, ListWorkflowExecutionObservationsResponses, ListWorkflowGatesData, ListWorkflowGatesErrors, ListWorkflowGatesResponses, ListWorkflowInstancesData, ListWorkflowInstancesResponses, ListWorkflowRunsData, ListWorkflowRunsResponses, ListWorkflowsData, ListWorkflowsResponses, ListWorkflowVersionsData, ListWorkflowVersionsErrors, ListWorkflowVersionsResponses, ListWorkforceAssignmentsData, ListWorkforceAssignmentsResponses, ListWorkforceEventCatalogData, ListWorkforceEventCatalogResponses, ListWorkstreamDecisionsData, ListWorkstreamDecisionsErrors, ListWorkstreamDecisionsResponses, ListWorkstreamMembersData, ListWorkstreamMembersErrors, ListWorkstreamMembersResponses, ListWorkstreamsData, ListWorkstreamsResponses, LookupFinanceCommandOptionsData, LookupFinanceCommandOptionsErrors, LookupFinanceCommandOptionsResponses, MaterializeProjectChangeCodeData, MaterializeProjectChangeCodeErrors, MaterializeProjectChangeCodeResponses, ModifyDecisionData, ModifyDecisionResponses, OpenProjectChangeCodeReviewData, OpenProjectChangeCodeReviewErrors, OpenProjectChangeCodeReviewResponses, OptimizePromptData, OptimizePromptErrors, OptimizePromptResponses, PatchConversationSettingsData, PatchConversationSettingsErrors, PatchConversationSettingsResponses, PatchStrategyBucketDefinitionData, PatchStrategyBucketDefinitionErrors, PatchStrategyBucketDefinitionResponses, PauseExecutionAlgoData, PauseExecutionAlgoErrors, PauseExecutionAlgoResponses, PauseExecutionData, PauseExecutionErrors, PauseExecutionResponses, PinDashboardData, PinDashboardErrors, PinDashboardResponses, PinWidgetData, PinWidgetErrors, PinWidgetResponses, PollAiWorkerCommandsData, PollAiWorkerCommandsErrors, PollAiWorkerCommandsResponses, PollAiWorkerControlCommandsData, PollAiWorkerControlCommandsErrors, PollAiWorkerControlCommandsResponses, PreflightTemplateUpgradeData, PreflightTemplateUpgradeErrors, PreflightTemplateUpgradeResponses, PresignUploadData, PresignUploadErrors, PresignUploadResponses, PreviewFinanceIndicatorImportData, PreviewFinanceIndicatorImportErrors, PreviewFinanceIndicatorImportResponses, PreviewFinanceStrategyTemplateData, PreviewFinanceStrategyTemplateErrors, PreviewFinanceStrategyTemplateResponses, PreviewInvitationData, PreviewInvitationErrors, PreviewInvitationResponses, PreviewPromptData, PreviewPromptErrors, PreviewPromptResponses, ProcessCatalogReviewQueueData, ProcessCatalogReviewQueueErrors, ProcessCatalogReviewQueueResponses, PromoteAgentTemplateVersionData, PromoteAgentTemplateVersionErrors, PromoteAgentTemplateVersionResponses, PromoteCatalogCandidateData, PromoteCatalogCandidateErrors, PromoteCatalogCandidateResponses, PromoteMemoryData, PromoteMemoryErrors, PromoteMemoryResponses, ProposeFinanceBucketReweightData, ProposeFinanceBucketReweightErrors, ProposeFinanceBucketReweightResponses, PublishAiWorkerEventsData, PublishAiWorkerEventsErrors, PublishAiWorkerEventsResponses, PublishEvaluationTemplateVersionData, PublishEvaluationTemplateVersionErrors, PublishEvaluationTemplateVersionResponses, PublishMarketplaceListingData, PublishMarketplaceListingErrors, PublishMarketplaceListingResponses, PurgeSnapshotsData, PurgeSnapshotsErrors, PurgeSnapshotsResponses, QueryAiWorkerDataData, QueryAiWorkerDataErrors, QueryAiWorkerDataResponses, QueryOutputsData, QueryOutputsResponses, ReactivateProjectData, ReactivateProjectErrors, ReactivateProjectResponses, ReassignTaskData, ReassignTaskErrors, ReassignTaskResponses, ReceiveTradingViewAlertData, ReceiveTradingViewAlertErrors, ReceiveTradingViewAlertResponses, RecommendAgentTemplatesData, RecommendAgentTemplatesResponses, RecommendDaemonsData, RecommendDaemonsResponses, RecommendWorkflowDefinitionsData, RecommendWorkflowDefinitionsResponses, RecommendWorkforceData, RecommendWorkforceResponses, ReconnectToRunData, ReconnectToRunErrors, ReconnectToRunResponse, ReconnectToRunResponses, RecordIntelSourceConsentData, RecordIntelSourceConsentErrors, RecordIntelSourceConsentResponses, RefreshTokenData, RefreshTokenErrors, RefreshTokenResponses, RegisterAiWorkerData, RegisterAiWorkerErrors, RegisterAiWorkerResponses, RejectCatalogCandidateData, RejectCatalogCandidateErrors, RejectCatalogCandidateResponses, RejectDaemonDecisionData, RejectDaemonDecisionErrors, RejectDaemonDecisionResponses, RejectDecisionData, RejectDecisionResponses, RejectInterventionData, RejectInterventionErrors, RejectInterventionResponses, RejectPromotionCandidateData, RejectPromotionCandidateErrors, RejectPromotionCandidateResponses, RejectRecommendationData, RejectRecommendationErrors, RejectRecommendationResponses, RejectTaskActionData, RejectTaskActionErrors, RejectTaskActionResponses, RejectWorkflowGateData, RejectWorkflowGateErrors, RejectWorkflowGateResponses, RemoveActiveStrategyData, RemoveActiveStrategyErrors, RemoveActiveStrategyResponses, RemoveConversationMemberData, RemoveConversationMemberErrors, RemoveConversationMemberResponses, RemoveDaemonWorkflowData, RemoveDaemonWorkflowErrors, RemoveDaemonWorkflowResponses, RemoveEmployeeWorkflowData, RemoveEmployeeWorkflowErrors, RemoveEmployeeWorkflowResponses, RemoveFromWatchlistData, RemoveFromWatchlistResponses, RemoveMarketplaceBundleEntityData, RemoveMarketplaceBundleEntityErrors, RemoveMarketplaceBundleEntityResponses, RemoveProjectMemberData, RemoveProjectMemberErrors, RemoveProjectMemberResponses, RemoveProjectTeamMemberData, RemoveProjectTeamMemberErrors, RemoveProjectTeamMemberResponses, RemoveTeamMemberData, RemoveTeamMemberErrors, RemoveTeamMemberResponses, RemoveUserRoleData, RemoveUserRoleErrors, RemoveUserRoleResponses, RemoveWidgetData, RemoveWidgetErrors, RemoveWidgetResponses, RemoveWorkflowStepData, RemoveWorkflowStepErrors, RemoveWorkflowStepResponses, RemoveWorkstreamMemberData, RemoveWorkstreamMemberErrors, RemoveWorkstreamMemberResponses, ReorderWidgetsData, ReorderWidgetsResponses, ReorderWorkflowStepsData, ReorderWorkflowStepsErrors, ReorderWorkflowStepsResponses, ReplaceProjectWorkModeTemplatesData, ReplaceProjectWorkModeTemplatesErrors, ReplaceProjectWorkModeTemplatesResponses, ReplayDeadLetterEntryData, ReplayDeadLetterEntryErrors, ReplayDeadLetterEntryResponses, ReplyToConversationData, ReplyToConversationErrors, ReplyToConversationResponses, ResendInvitationData, ResendInvitationErrors, ResendInvitationResponses, ResetAlertData, ResetAlertErrors, ResetAlertResponses, ResetDaemonGovernanceData, ResetDaemonGovernanceErrors, ResetDaemonGovernanceResponses, ResetEmployeeGovernanceData, ResetEmployeeGovernanceErrors, ResetEmployeeGovernanceResponses, ResetPasswordData, ResetPasswordResponses, ResetUserPasswordData, ResetUserPasswordErrors, ResetUserPasswordResponses, ResolveActionQueueItemData, ResolveActionQueueItemErrors, ResolveActionQueueItemResponses, ResolveDynamicFanOutPolicyData, ResolveDynamicFanOutPolicyErrors, ResolveDynamicFanOutPolicyResponses, ResolveInterventionData, ResolveInterventionErrors, ResolveInterventionResponses, ResolveModelRuntimePolicyData, ResolveModelRuntimePolicyErrors, ResolveModelRuntimePolicyResponses, ResolveRiskBreachData, ResolveRiskBreachErrors, ResolveRiskBreachResponses, ResolveStrategyAdaptersData, ResolveStrategyAdaptersErrors, ResolveStrategyAdaptersResponses, RestoreCatalogItemVersionData, RestoreCatalogItemVersionErrors, RestoreCatalogItemVersionResponses, RestoreWorkflowData, RestoreWorkflowErrors, RestoreWorkflowResponses, RestoreWorkflowVersionData, RestoreWorkflowVersionErrors, RestoreWorkflowVersionResponses, ResumeAllDaemonsData, ResumeAllDaemonsResponses, ResumeAllEmployeesData, ResumeAllEmployeesResponses, ResumeExecutionAlgoData, ResumeExecutionAlgoErrors, ResumeExecutionAlgoResponses, ResumeExecutionData, ResumeExecutionErrors, ResumeExecutionResponses, ResumeRiskHaltData, ResumeRiskHaltErrors, ResumeRiskHaltResponses, RetryCatalogCandidateReviewData, RetryCatalogCandidateReviewErrors, RetryCatalogCandidateReviewResponses, RetryCatalogReviewQueueData, RetryCatalogReviewQueueErrors, RetryCatalogReviewQueueItemData, RetryCatalogReviewQueueItemErrors, RetryCatalogReviewQueueItemResponses, RetryCatalogReviewQueueResponses, RetryTaskData, RetryTaskErrors, RetryTaskResponses, RevertCatalogVersionAdoptionData, RevertCatalogVersionAdoptionErrors, RevertCatalogVersionAdoptionResponses, ReviewDaemonsFindingData, ReviewDaemonsFindingErrors, ReviewDaemonsFindingResponses, ReviewIntelSourceApprovalData, ReviewIntelSourceApprovalErrors, ReviewIntelSourceApprovalResponses, ReviewWorkforceFindingData, ReviewWorkforceFindingErrors, ReviewWorkforceFindingResponses, RevokeApiKeyData, RevokeApiKeyErrors, RevokeApiKeyResponses, RevokeApproverDelegationData, RevokeApproverDelegationErrors, RevokeApproverDelegationResponses, RevokeDaemonPermissionGrantData, RevokeDaemonPermissionGrantErrors, RevokeDaemonPermissionGrantResponses, RevokeEmployeePermissionGrantData, RevokeEmployeePermissionGrantErrors, RevokeEmployeePermissionGrantResponses, RevokeInvitationData, RevokeInvitationErrors, RevokeInvitationResponses, RollbackAgentTemplateVersionData, RollbackAgentTemplateVersionErrors, RollbackAgentTemplateVersionResponses, RollbackProjectCodeCheckpointData, RollbackProjectCodeCheckpointErrors, RollbackProjectCodeCheckpointResponses, RotateApiKeyData, RotateApiKeyErrors, RotateApiKeyResponses, RotateTradingViewTokenData, RotateTradingViewTokenResponses, RouteInterventionData, RouteInterventionErrors, RouteInterventionResponses, RunAgentWorkflowRunActionData, RunAgentWorkflowRunActionErrors, RunAgentWorkflowRunActionResponses, RunAiWorkerDatasetData, RunAiWorkerDatasetErrors, RunAiWorkerDatasetResponses, RunAnalysisAgentsData, RunAnalysisAgentsResponses, RunBacktestData, RunBacktestErrors, RunBacktestResponses, RunDaemonData, RunDaemonErrors, RunDaemonResponses, RunEmployeeData, RunEmployeeErrors, RunEmployeeResponses, RunEvaluationDatasetData, RunEvaluationDatasetErrors, RunEvaluationDatasetResponses, RunIngestionJobData, RunIngestionJobErrors, RunIngestionJobResponses, RunStrategyDiscoveryWorkflowData, RunStrategyDiscoveryWorkflowErrors, RunStrategyDiscoveryWorkflowResponses, SaveDebugStepOutputData, SaveDebugStepOutputErrors, SaveDebugStepOutputResponses, SaveWorkflowDefinitionGraphData, SaveWorkflowDefinitionGraphErrors, SaveWorkflowDefinitionGraphResponses, SearchAgentTemplatesData, SearchAgentTemplatesResponses, SearchArtifactsData, SearchArtifactsResponses, SearchDaemonsData, SearchDaemonsResponses, SearchFinanceKgData, SearchFinanceKgErrors, SearchFinanceKgResponses, SearchMemoriesData, SearchMemoriesResponses, SearchWorkflowDefinitionsData, SearchWorkflowDefinitionsResponses, SearchWorkforceData, SearchWorkforceResponses, SendFollowUpMessageData, SendFollowUpMessageErrors, SendFollowUpMessageResponse, SendFollowUpMessageResponses, SendNotificationData, SendNotificationResponses, SetAgentEnabledData, SetAgentEnabledErrors, SetAgentEnabledResponses, SetAlertEnabledData, SetAlertEnabledErrors, SetAlertEnabledResponses, SetConversationLeadData, SetConversationLeadErrors, SetConversationLeadResponses, SetConversationRuntimePolicyData, SetConversationRuntimePolicyErrors, SetConversationRuntimePolicyResponses, SetConversationTypingData, SetConversationTypingErrors, SetConversationTypingResponses, SetDaemonRuntimePolicyData, SetDaemonRuntimePolicyErrors, SetDaemonRuntimePolicyResponses, SetDecisionRuntimePolicyData, SetDecisionRuntimePolicyErrors, SetDecisionRuntimePolicyResponses, SetEmployeeRuntimePolicyData, SetEmployeeRuntimePolicyErrors, SetEmployeeRuntimePolicyResponses, SetOrganizationRuntimeFlagData, SetOrganizationRuntimeFlagErrors, SetOrganizationRuntimeFlagResponses, SetOrganizationRuntimePolicySurfaceRuleData, SetOrganizationRuntimePolicySurfaceRuleErrors, SetOrganizationRuntimePolicySurfaceRuleResponses, SetPlatformRuntimeFlagData, SetPlatformRuntimeFlagErrors, SetPlatformRuntimeFlagResponses, SetSystemRuntimePolicySurfaceRuleData, SetSystemRuntimePolicySurfaceRuleErrors, SetSystemRuntimePolicySurfaceRuleResponses, SetTemplateAutoUpgradeData, SetTemplateAutoUpgradeErrors, SetTemplateAutoUpgradeResponses, SetTemplateStatusData, SetTemplateStatusErrors, SetTemplateStatusResponses, SetToolStatusData, SetToolStatusErrors, SetToolStatusResponses, SetWorkflowRuntimePolicyData, SetWorkflowRuntimePolicyErrors, SetWorkflowRuntimePolicyResponses, SetWorkflowScheduleData, SetWorkflowScheduleResponses, SoftDeleteProjectData, SoftDeleteProjectErrors, SoftDeleteProjectResponses, SpawnAgentData, SpawnAgentErrors, SpawnAgentResponses, StartConversationFromMessageData, StartConversationFromMessageErrors, StartConversationFromMessageResponses, StartFinanceResearchWorkflowRunData, StartFinanceResearchWorkflowRunErrors, StartFinanceResearchWorkflowRunResponses, StartMarketDataData, StartMarketDataErrors, StartStrategyData, StartStrategyErrors, StartStrategyResponses, StartTaskData, StartTaskErrors, StartTaskResponses, StopExecutionData, StopExecutionErrors, StopExecutionResponses, StopMarketDataData, StopMarketDataErrors, StopStrategyData, StopStrategyErrors, StopStrategyResponses, StreamDaemonRunsData, StreamDaemonRunsResponse, StreamDaemonRunsResponses, StreamEmployeeRunsData, StreamEmployeeRunsResponse, StreamEmployeeRunsResponses, StreamProjectWorkstreamCodePreviewSessionEventsData, StreamProjectWorkstreamCodePreviewSessionEventsErrors, StreamProjectWorkstreamCodePreviewSessionEventsResponse, StreamProjectWorkstreamCodePreviewSessionEventsResponses, SubmitCapitalAllocationData, SubmitCapitalAllocationErrors, SubmitCapitalAllocationResponses, SubmitConversationInteractionData, SubmitConversationInteractionErrors, SubmitConversationInteractionResponses, SubscribeConversationEventsData, SubscribeConversationEventsErrors, SubscribeConversationEventsResponse, SubscribeConversationEventsResponses, SuggestConnectionsData, SuggestConnectionsResponses, SwitchAccountData, SwitchAccountErrors, SwitchAccountResponses, SyncToolLibraryData, SyncToolLibraryErrors, SyncToolLibraryResponses, TerminateAgentData, TerminateAgentErrors, TerminateAgentResponses, TerminateAllDaemonsData, TerminateAllDaemonsResponses, TerminateAllEmployeesData, TerminateAllEmployeesResponses, TestAgentTemplateVersionData, TestAgentTemplateVersionErrors, TestAgentTemplateVersionResponses, TestIntelPlatformData, TestIntelPlatformErrors, TestIntelPlatformResponses, TestMcpConnectionData, TestMcpConnectionErrors, TestMcpConnectionResponses, TestNotificationData, TestNotificationResponses, TestTradingViewWebhookData, TestTradingViewWebhookResponses, TransferTaskTeamData, TransferTaskTeamErrors, TransferTaskTeamResponses, TransitionBlockerData, TransitionBlockerErrors, TransitionBlockerResponses, TransitionHandoffData, TransitionHandoffErrors, TransitionHandoffResponses, TranspileFinanceIndicatorImportData, TranspileFinanceIndicatorImportErrors, TranspileFinanceIndicatorImportResponses, TriggerAgentWorkflowData, TriggerAgentWorkflowErrors, TriggerAgentWorkflowResponses, TriggerWorkflowData, TriggerWorkflowErrors, TriggerWorkflowInstanceData, TriggerWorkflowInstanceErrors, TriggerWorkflowInstanceResponses, TriggerWorkflowResponses, UnbindMarketplaceEntityConnectionData, UnbindMarketplaceEntityConnectionErrors, UnbindMarketplaceEntityConnectionResponses, UndeployStrategyData, UndeployStrategyErrors, UndeployStrategyResponses, UnlinkAccountData, UnlinkAccountResponses, UnpinDashboardData, UnpinDashboardErrors, UnpinDashboardResponses, UnpinWidgetData, UnpinWidgetErrors, UnpinWidgetResponses, UpdateAdminUserData, UpdateAdminUserErrors, UpdateAdminUserResponses, UpdateAlertRuleData, UpdateAlertRuleErrors, UpdateAlertRuleResponses, UpdateAnalysisTemplateData, UpdateAnalysisTemplateErrors, UpdateAnalysisTemplateResponses, UpdateApiKeyData, UpdateApiKeyErrors, UpdateApiKeyResponses, UpdateArtifactData, UpdateArtifactErrors, UpdateArtifactResponses, UpdateBrokerCredentialData, UpdateBrokerCredentialResponses, UpdateConversationData, UpdateConversationErrors, UpdateConversationResponses, UpdateDaemonData, UpdateDaemonErrors, UpdateDaemonResponses, UpdateDaemonTriggerData, UpdateDaemonTriggerErrors, UpdateDaemonTriggerResponses, UpdateDashboardData, UpdateDashboardErrors, UpdateDashboardResponses, UpdateDiscoveredStrategyStatusData, UpdateDiscoveredStrategyStatusErrors, UpdateDiscoveredStrategyStatusResponses, UpdateDynamicFanOutPolicyData, UpdateDynamicFanOutPolicyErrors, UpdateDynamicFanOutPolicyResponses, UpdateEmployeeData, UpdateEmployeeErrors, UpdateEmployeeResponses, UpdateEmployeeTriggerData, UpdateEmployeeTriggerErrors, UpdateEmployeeTriggerResponses, UpdateEvaluationTemplateData, UpdateEvaluationTemplateErrors, UpdateEvaluationTemplateResponses, UpdateHoldingData, UpdateHoldingErrors, UpdateHoldingResponses, UpdateIntelPlatformData, UpdateIntelPlatformErrors, UpdateIntelPlatformResponses, UpdateIntelSourceData, UpdateIntelSourceErrors, UpdateIntelSourceMonitorData, UpdateIntelSourceMonitorErrors, UpdateIntelSourceMonitorResponses, UpdateIntelSourceResponses, UpdateIntelSourceSubscriptionData, UpdateIntelSourceSubscriptionErrors, UpdateIntelSourceSubscriptionResponses, UpdateMarketplaceEntityData, UpdateMarketplaceEntityErrors, UpdateMarketplaceEntityResponses, UpdateMcpConnectionData, UpdateMcpConnectionErrors, UpdateMcpConnectionResponses, UpdateMeData, UpdateMeErrors, UpdateMemoryData, UpdateMemoryErrors, UpdateMemoryResponses, UpdateMeResponses, UpdateModelRuntimePolicyData, UpdateModelRuntimePolicyErrors, UpdateModelRuntimePolicyResponses, UpdateNotificationConfigData, UpdateNotificationConfigResponses, UpdateOrganizationData, UpdateOrganizationErrors, UpdateOrganizationResponses, UpdatePinnedWidgetData, UpdatePinnedWidgetErrors, UpdatePinnedWidgetResponses, UpdatePortfolioData, UpdatePortfolioErrors, UpdatePortfolioResponses, UpdateProjectChangeData, UpdateProjectChangeResponses, UpdateProjectData, UpdateProjectErrors, UpdateProjectMemberRoleData, UpdateProjectMemberRoleErrors, UpdateProjectMemberRoleResponses, UpdateProjectResponses, UpdateProjectTeamData, UpdateProjectTeamErrors, UpdateProjectTeamMemberData, UpdateProjectTeamMemberErrors, UpdateProjectTeamMemberResponses, UpdateProjectTeamResponses, UpdateProjectThreadData, UpdateProjectThreadResponses, UpdateRiskLimitData, UpdateRiskLimitErrors, UpdateRiskLimitResponses, UpdateShadowModeDaemonEnrollmentData, UpdateShadowModeDaemonEnrollmentErrors, UpdateShadowModeDaemonEnrollmentResponses, UpdateSnapshotData, UpdateSnapshotErrors, UpdateSnapshotResponses, UpdateStrategyParametersData, UpdateStrategyParametersErrors, UpdateStrategyParametersResponses, UpdateTaskData, UpdateTaskErrors, UpdateTaskResponses, UpdateToolLibraryData, UpdateToolLibraryErrors, UpdateToolLibraryResponses, UpdateWidgetData, UpdateWidgetErrors, UpdateWidgetResponses, UpdateWorkflowData, UpdateWorkflowErrors, UpdateWorkflowInstanceData, UpdateWorkflowInstanceErrors, UpdateWorkflowInstanceResponses, UpdateWorkflowResponses, UpdateWorkflowStepData, UpdateWorkflowStepErrors, UpdateWorkflowStepResponses, UpdateWorkstreamData, UpdateWorkstreamErrors, UpdateWorkstreamResponses, UpgradeCatalogVersionAdoptionData, UpgradeCatalogVersionAdoptionErrors, UpgradeCatalogVersionAdoptionResponses, UploadDocumentData, UploadDocumentResponses, UpsertFinanceDataBlockerData, UpsertFinanceDataBlockerErrors, UpsertFinanceDataBlockerResponses, UpsertStrategyBucketDefinitionData, UpsertStrategyBucketDefinitionErrors, UpsertStrategyBucketDefinitionResponses, UpsertStrategyDefinitionData, UpsertStrategyDefinitionErrors, UpsertStrategyDefinitionResponses, UpsertStrategyExtensionDescriptorData, UpsertStrategyExtensionDescriptorErrors, UpsertStrategyExtensionDescriptorResponses, ValidateStepData, ValidateStepResponses, ValidateStrategyBucketDefinitionData, ValidateStrategyBucketDefinitionResponses, ValidateStrategyDefinitionData, ValidateStrategyDefinitionResponses, ValidateStrategyExtensionDescriptorData, ValidateStrategyExtensionDescriptorResponses, ValidateWorkflowData, ValidateWorkflowErrors, ValidateWorkflowResponses, VerifyBrokerCredentialData, VerifyBrokerCredentialResponses, VerifyEmailData, VerifyEmailResponses, VerifyFinanceAuditLedgerChainData, VerifyFinanceAuditLedgerChainErrors, VerifyFinanceAuditLedgerChainResponses, VerifyUserData, VerifyUserErrors, VerifyUserResponses, ViewProjectWorkstreamCodePreviewSessionData, ViewProjectWorkstreamCodePreviewSessionErrors, ViewProjectWorkstreamCodePreviewSessionResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * System health (readiness: database and Redis)
 */
export const getSystemHealth = <ThrowOnError extends boolean = false>(options?: Options<GetSystemHealthData, ThrowOnError>): RequestResult<GetSystemHealthResponses, GetSystemHealthErrors, ThrowOnError> => (options?.client ?? client).get<GetSystemHealthResponses, GetSystemHealthErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/health',
    ...options
});

export const createSignup = <ThrowOnError extends boolean = false>(options?: Options<CreateSignupData, ThrowOnError>): RequestResult<CreateSignupResponses, CreateSignupErrors, ThrowOnError> => (options?.client ?? client).post<CreateSignupResponses, CreateSignupErrors, ThrowOnError>({
    url: '/api/v1/auth/signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const createLogin = <ThrowOnError extends boolean = false>(options?: Options<CreateLoginData, ThrowOnError>): RequestResult<CreateLoginResponses, CreateLoginErrors, ThrowOnError> => (options?.client ?? client).post<CreateLoginResponses, CreateLoginErrors, ThrowOnError>({
    url: '/api/v1/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> => (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me',
    ...options
});

export const updateMe = <ThrowOnError extends boolean = false>(options?: Options<UpdateMeData, ThrowOnError>): RequestResult<UpdateMeResponses, UpdateMeErrors, ThrowOnError> => (options?.client ?? client).put<UpdateMeResponses, UpdateMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const createLogout = <ThrowOnError extends boolean = false>(options?: Options<CreateLogoutData, ThrowOnError>): RequestResult<CreateLogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CreateLogoutResponses, unknown, ThrowOnError>({ url: '/api/v1/auth/logout', ...options });

export const refreshToken = <ThrowOnError extends boolean = false>(options?: Options<RefreshTokenData, ThrowOnError>): RequestResult<RefreshTokenResponses, RefreshTokenErrors, ThrowOnError> => (options?.client ?? client).post<RefreshTokenResponses, RefreshTokenErrors, ThrowOnError>({ url: '/api/v1/auth/refresh', ...options });

export const verifyEmail = <ThrowOnError extends boolean = false>(options?: Options<VerifyEmailData, ThrowOnError>): RequestResult<VerifyEmailResponses, unknown, ThrowOnError> => (options?.client ?? client).post<VerifyEmailResponses, unknown, ThrowOnError>({
    url: '/api/v1/auth/verify-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const resetPassword = <ThrowOnError extends boolean = false>(options?: Options<ResetPasswordData, ThrowOnError>): RequestResult<ResetPasswordResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ResetPasswordResponses, unknown, ThrowOnError>({
    url: '/api/v1/auth/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const unlinkAccount = <ThrowOnError extends boolean = false>(options?: Options<UnlinkAccountData, ThrowOnError>): RequestResult<UnlinkAccountResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<UnlinkAccountResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/linked-accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listLinkedAccounts = <ThrowOnError extends boolean = false>(options?: Options<ListLinkedAccountsData, ThrowOnError>): RequestResult<ListLinkedAccountsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListLinkedAccountsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/linked-accounts',
    ...options
});

export const linkAccount = <ThrowOnError extends boolean = false>(options?: Options<LinkAccountData, ThrowOnError>): RequestResult<LinkAccountResponses, LinkAccountErrors, ThrowOnError> => (options?.client ?? client).post<LinkAccountResponses, LinkAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/linked-accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const switchAccount = <ThrowOnError extends boolean = false>(options?: Options<SwitchAccountData, ThrowOnError>): RequestResult<SwitchAccountResponses, SwitchAccountErrors, ThrowOnError> => (options?.client ?? client).post<SwitchAccountResponses, SwitchAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/switch-account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const previewInvitation = <ThrowOnError extends boolean = false>(options: Options<PreviewInvitationData, ThrowOnError>): RequestResult<PreviewInvitationResponses, PreviewInvitationErrors, ThrowOnError> => (options.client ?? client).get<PreviewInvitationResponses, PreviewInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/invitations/{token}/preview',
    ...options
});

export const acceptInvitation = <ThrowOnError extends boolean = false>(options: Options<AcceptInvitationData, ThrowOnError>): RequestResult<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError> => (options.client ?? client).post<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/invitations/{token}/accept',
    ...options
});

export const resendInvitation = <ThrowOnError extends boolean = false>(options: Options<ResendInvitationData, ThrowOnError>): RequestResult<ResendInvitationResponses, ResendInvitationErrors, ThrowOnError> => (options.client ?? client).post<ResendInvitationResponses, ResendInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/invitations/{id}/resend',
    ...options
});

export const revokeInvitation = <ThrowOnError extends boolean = false>(options: Options<RevokeInvitationData, ThrowOnError>): RequestResult<RevokeInvitationResponses, RevokeInvitationErrors, ThrowOnError> => (options.client ?? client).post<RevokeInvitationResponses, RevokeInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/invitations/{id}/revoke',
    ...options
});

export const listAdminUsers = <ThrowOnError extends boolean = false>(options?: Options<ListAdminUsersData, ThrowOnError>): RequestResult<ListAdminUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAdminUsersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users',
    ...options
});

export const bulkUpdateUserStatus = <ThrowOnError extends boolean = false>(options?: Options<BulkUpdateUserStatusData, ThrowOnError>): RequestResult<BulkUpdateUserStatusResponses, BulkUpdateUserStatusErrors, ThrowOnError> => (options?.client ?? client).post<BulkUpdateUserStatusResponses, BulkUpdateUserStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/bulk-status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getAdminUser = <ThrowOnError extends boolean = false>(options: Options<GetAdminUserData, ThrowOnError>): RequestResult<GetAdminUserResponses, GetAdminUserErrors, ThrowOnError> => (options.client ?? client).get<GetAdminUserResponses, GetAdminUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{id}',
    ...options
});

export const updateAdminUser = <ThrowOnError extends boolean = false>(options: Options<UpdateAdminUserData, ThrowOnError>): RequestResult<UpdateAdminUserResponses, UpdateAdminUserErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAdminUserResponses, UpdateAdminUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const resetUserPassword = <ThrowOnError extends boolean = false>(options: Options<ResetUserPasswordData, ThrowOnError>): RequestResult<ResetUserPasswordResponses, ResetUserPasswordErrors, ThrowOnError> => (options.client ?? client).post<ResetUserPasswordResponses, ResetUserPasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{id}/reset-password',
    ...options
});

export const verifyUser = <ThrowOnError extends boolean = false>(options: Options<VerifyUserData, ThrowOnError>): RequestResult<VerifyUserResponses, VerifyUserErrors, ThrowOnError> => (options.client ?? client).post<VerifyUserResponses, VerifyUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{id}/verify',
    ...options
});

export const assignUserRole = <ThrowOnError extends boolean = false>(options: Options<AssignUserRoleData, ThrowOnError>): RequestResult<AssignUserRoleResponses, AssignUserRoleErrors, ThrowOnError> => (options.client ?? client).post<AssignUserRoleResponses, AssignUserRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{id}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const removeUserRole = <ThrowOnError extends boolean = false>(options: Options<RemoveUserRoleData, ThrowOnError>): RequestResult<RemoveUserRoleResponses, RemoveUserRoleErrors, ThrowOnError> => (options.client ?? client).delete<RemoveUserRoleResponses, RemoveUserRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{id}/roles/{roleId}',
    ...options
});

export const getUserAuditLog = <ThrowOnError extends boolean = false>(options: Options<GetUserAuditLogData, ThrowOnError>): RequestResult<GetUserAuditLogResponses, GetUserAuditLogErrors, ThrowOnError> => (options.client ?? client).get<GetUserAuditLogResponses, GetUserAuditLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{id}/audit',
    ...options
});

export const listExchangeCredentials = <ThrowOnError extends boolean = false>(options?: Options<ListExchangeCredentialsData, ThrowOnError>): RequestResult<ListExchangeCredentialsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListExchangeCredentialsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/keys',
    ...options
});

export const createExchangeCredential = <ThrowOnError extends boolean = false>(options?: Options<CreateExchangeCredentialData, ThrowOnError>): RequestResult<CreateExchangeCredentialResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CreateExchangeCredentialResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteExchangeCredential = <ThrowOnError extends boolean = false>(options: Options<DeleteExchangeCredentialData, ThrowOnError>): RequestResult<DeleteExchangeCredentialResponses, DeleteExchangeCredentialErrors, ThrowOnError> => (options.client ?? client).delete<DeleteExchangeCredentialResponses, DeleteExchangeCredentialErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/keys/{id}',
    ...options
});

export const getNotificationConfig = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationConfigData, ThrowOnError>): RequestResult<GetNotificationConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetNotificationConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/webhooks/notifications/config',
    ...options
});

export const updateNotificationConfig = <ThrowOnError extends boolean = false>(options?: Options<UpdateNotificationConfigData, ThrowOnError>): RequestResult<UpdateNotificationConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).patch<UpdateNotificationConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/webhooks/notifications/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const sendNotification = <ThrowOnError extends boolean = false>(options?: Options<SendNotificationData, ThrowOnError>): RequestResult<SendNotificationResponses, unknown, ThrowOnError> => (options?.client ?? client).post<SendNotificationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/webhooks/notifications/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const testNotification = <ThrowOnError extends boolean = false>(options?: Options<TestNotificationData, ThrowOnError>): RequestResult<TestNotificationResponses, unknown, ThrowOnError> => (options?.client ?? client).post<TestNotificationResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/webhooks/notifications/test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listActiveAgents = <ThrowOnError extends boolean = false>(options?: Options<ListActiveAgentsData, ThrowOnError>): RequestResult<ListActiveAgentsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListActiveAgentsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/instances',
    ...options
});

export const spawnAgent = <ThrowOnError extends boolean = false>(options?: Options<SpawnAgentData, ThrowOnError>): RequestResult<SpawnAgentResponses, SpawnAgentErrors, ThrowOnError> => (options?.client ?? client).post<SpawnAgentResponses, SpawnAgentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/instances/spawn',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const terminateAgent = <ThrowOnError extends boolean = false>(options: Options<TerminateAgentData, ThrowOnError>): RequestResult<TerminateAgentResponses, TerminateAgentErrors, ThrowOnError> => (options.client ?? client).post<TerminateAgentResponses, TerminateAgentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/instances/{agentId}/terminate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const executeAgent = <ThrowOnError extends boolean = false>(options: Options<ExecuteAgentData, ThrowOnError>): RequestResult<ExecuteAgentResponses, ExecuteAgentErrors, ThrowOnError> => (options.client ?? client).post<ExecuteAgentResponses, ExecuteAgentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/instances/{agentId}/execute',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAgentHealth = <ThrowOnError extends boolean = false>(options?: Options<GetAgentHealthData, ThrowOnError>): RequestResult<GetAgentHealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAgentHealthResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/instances/health',
    ...options
});

export const listPendingDecisions = <ThrowOnError extends boolean = false>(options?: Options<ListPendingDecisionsData, ThrowOnError>): RequestResult<ListPendingDecisionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListPendingDecisionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/decisions/pending',
    ...options
});

export const getDecisionStats = <ThrowOnError extends boolean = false>(options?: Options<GetDecisionStatsData, ThrowOnError>): RequestResult<GetDecisionStatsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetDecisionStatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/decisions/stats',
    ...options
});

export const getDecision = <ThrowOnError extends boolean = false>(options: Options<GetDecisionData, ThrowOnError>): RequestResult<GetDecisionResponses, GetDecisionErrors, ThrowOnError> => (options.client ?? client).get<GetDecisionResponses, GetDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/decisions/{requestId}',
    ...options
});

export const approveDecision = <ThrowOnError extends boolean = false>(options: Options<ApproveDecisionData, ThrowOnError>): RequestResult<ApproveDecisionResponses, unknown, ThrowOnError> => (options.client ?? client).post<ApproveDecisionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/decisions/{requestId}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const rejectDecision = <ThrowOnError extends boolean = false>(options: Options<RejectDecisionData, ThrowOnError>): RequestResult<RejectDecisionResponses, unknown, ThrowOnError> => (options.client ?? client).post<RejectDecisionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/decisions/{requestId}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const modifyDecision = <ThrowOnError extends boolean = false>(options: Options<ModifyDecisionData, ThrowOnError>): RequestResult<ModifyDecisionResponses, unknown, ThrowOnError> => (options.client ?? client).post<ModifyDecisionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/decisions/{requestId}/modify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getRecentMessages = <ThrowOnError extends boolean = false>(options?: Options<GetRecentMessagesData, ThrowOnError>): RequestResult<GetRecentMessagesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRecentMessagesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/messages/recent',
    ...options
});

export const previewPrompt = <ThrowOnError extends boolean = false>(options?: Options<PreviewPromptData, ThrowOnError>): RequestResult<PreviewPromptResponses, PreviewPromptErrors, ThrowOnError> => (options?.client ?? client).post<PreviewPromptResponses, PreviewPromptErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/preview-prompt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const executeStep = <ThrowOnError extends boolean = false>(options?: Options<ExecuteStepData, ThrowOnError>): RequestResult<ExecuteStepResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ExecuteStepResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/execute-step',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const executeStepStream = <ThrowOnError extends boolean = false>(options?: Options<ExecuteStepStreamData, ThrowOnError, ExecuteStepStreamResponse>): Promise<ServerSentEventsResult<ExecuteStepStreamResponses>> => (options?.client ?? client).sse.post<ExecuteStepStreamResponses, ExecuteStepStreamErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/execute-step-stream',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const reconnectToRun = <ThrowOnError extends boolean = false>(options: Options<ReconnectToRunData, ThrowOnError, ReconnectToRunResponse>): Promise<ServerSentEventsResult<ReconnectToRunResponses>> => (options.client ?? client).sse.get<ReconnectToRunResponses, ReconnectToRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/runs/{runId}/stream',
    ...options
});

export const sendFollowUpMessage = <ThrowOnError extends boolean = false>(options: Options<SendFollowUpMessageData, ThrowOnError, SendFollowUpMessageResponse>): Promise<ServerSentEventsResult<SendFollowUpMessageResponses>> => (options.client ?? client).sse.post<SendFollowUpMessageResponses, SendFollowUpMessageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/runs/{runId}/message',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getActiveRun = <ThrowOnError extends boolean = false>(options?: Options<GetActiveRunData, ThrowOnError>): RequestResult<GetActiveRunResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetActiveRunResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/active-run',
    ...options
});

export const listRuns = <ThrowOnError extends boolean = false>(options?: Options<ListRunsData, ThrowOnError>): RequestResult<ListRunsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListRunsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/runs',
    ...options
});

export const stopExecution = <ThrowOnError extends boolean = false>(options?: Options<StopExecutionData, ThrowOnError>): RequestResult<StopExecutionResponses, StopExecutionErrors, ThrowOnError> => (options?.client ?? client).post<StopExecutionResponses, StopExecutionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/stop',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const pauseExecution = <ThrowOnError extends boolean = false>(options?: Options<PauseExecutionData, ThrowOnError>): RequestResult<PauseExecutionResponses, PauseExecutionErrors, ThrowOnError> => (options?.client ?? client).post<PauseExecutionResponses, PauseExecutionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/pause',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const resumeExecution = <ThrowOnError extends boolean = false>(options?: Options<ResumeExecutionData, ThrowOnError>): RequestResult<ResumeExecutionResponses, ResumeExecutionErrors, ThrowOnError> => (options?.client ?? client).post<ResumeExecutionResponses, ResumeExecutionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/resume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getExecutionStatus = <ThrowOnError extends boolean = false>(options?: Options<GetExecutionStatusData, ThrowOnError>): RequestResult<GetExecutionStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetExecutionStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/status',
    ...options
});

export const saveDebugStepOutput = <ThrowOnError extends boolean = false>(options?: Options<SaveDebugStepOutputData, ThrowOnError>): RequestResult<SaveDebugStepOutputResponses, SaveDebugStepOutputErrors, ThrowOnError> => (options?.client ?? client).post<SaveDebugStepOutputResponses, SaveDebugStepOutputErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/debug-step-output',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getDebugStepOutputs = <ThrowOnError extends boolean = false>(options: Options<GetDebugStepOutputsData, ThrowOnError>): RequestResult<GetDebugStepOutputsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetDebugStepOutputsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/debug-step-outputs/{templateId}',
    ...options
});

export const getStepBuilderContext = <ThrowOnError extends boolean = false>(options?: Options<GetStepBuilderContextData, ThrowOnError>): RequestResult<GetStepBuilderContextResponses, GetStepBuilderContextErrors, ThrowOnError> => (options?.client ?? client).get<GetStepBuilderContextResponses, GetStepBuilderContextErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/step-builder/context',
    ...options
});

export const validateStep = <ThrowOnError extends boolean = false>(options?: Options<ValidateStepData, ThrowOnError>): RequestResult<ValidateStepResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ValidateStepResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/step-builder/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const suggestConnections = <ThrowOnError extends boolean = false>(options?: Options<SuggestConnectionsData, ThrowOnError>): RequestResult<SuggestConnectionsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<SuggestConnectionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/step-builder/suggest-connections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const optimizePrompt = <ThrowOnError extends boolean = false>(options?: Options<OptimizePromptData, ThrowOnError>): RequestResult<OptimizePromptResponses, OptimizePromptErrors, ThrowOnError> => (options?.client ?? client).post<OptimizePromptResponses, OptimizePromptErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/prompts/optimize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listPromptTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListPromptTemplatesData, ThrowOnError>): RequestResult<ListPromptTemplatesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListPromptTemplatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/prompts/templates',
    ...options
});

export const fillTemplate = <ThrowOnError extends boolean = false>(options: Options<FillTemplateData, ThrowOnError>): RequestResult<FillTemplateResponses, FillTemplateErrors, ThrowOnError> => (options.client ?? client).post<FillTemplateResponses, FillTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/prompts/templates/{id}/fill',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getToolGaps = <ThrowOnError extends boolean = false>(options?: Options<GetToolGapsData, ThrowOnError>): RequestResult<GetToolGapsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetToolGapsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/prompts/tools/gaps',
    ...options
});

export const searchAgentTemplates = <ThrowOnError extends boolean = false>(options: Options<SearchAgentTemplatesData, ThrowOnError>): RequestResult<SearchAgentTemplatesResponses, unknown, ThrowOnError> => (options.client ?? client).get<SearchAgentTemplatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/search',
    ...options
});

export const recommendAgentTemplates = <ThrowOnError extends boolean = false>(options: Options<RecommendAgentTemplatesData, ThrowOnError>): RequestResult<RecommendAgentTemplatesResponses, unknown, ThrowOnError> => (options.client ?? client).get<RecommendAgentTemplatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/recommend',
    ...options
});

export const listAgentTemplateVersions = <ThrowOnError extends boolean = false>(options: Options<ListAgentTemplateVersionsData, ThrowOnError>): RequestResult<ListAgentTemplateVersionsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListAgentTemplateVersionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/{templateId}/versions',
    ...options
});

export const createAgentTemplateVersion = <ThrowOnError extends boolean = false>(options: Options<CreateAgentTemplateVersionData, ThrowOnError>): RequestResult<CreateAgentTemplateVersionResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateAgentTemplateVersionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/{templateId}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const promoteAgentTemplateVersion = <ThrowOnError extends boolean = false>(options: Options<PromoteAgentTemplateVersionData, ThrowOnError>): RequestResult<PromoteAgentTemplateVersionResponses, PromoteAgentTemplateVersionErrors, ThrowOnError> => (options.client ?? client).post<PromoteAgentTemplateVersionResponses, PromoteAgentTemplateVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/{templateId}/versions/{versionId}/promote',
    ...options
});

export const rollbackAgentTemplateVersion = <ThrowOnError extends boolean = false>(options: Options<RollbackAgentTemplateVersionData, ThrowOnError>): RequestResult<RollbackAgentTemplateVersionResponses, RollbackAgentTemplateVersionErrors, ThrowOnError> => (options.client ?? client).post<RollbackAgentTemplateVersionResponses, RollbackAgentTemplateVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/{templateId}/versions/{versionId}/rollback',
    ...options
});

export const diffAgentTemplateVersions = <ThrowOnError extends boolean = false>(options: Options<DiffAgentTemplateVersionsData, ThrowOnError>): RequestResult<DiffAgentTemplateVersionsResponses, DiffAgentTemplateVersionsErrors, ThrowOnError> => (options.client ?? client).get<DiffAgentTemplateVersionsResponses, DiffAgentTemplateVersionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/{templateId}/versions/{versionA}/diff/{versionB}',
    ...options
});

export const testAgentTemplateVersion = <ThrowOnError extends boolean = false>(options: Options<TestAgentTemplateVersionData, ThrowOnError>): RequestResult<TestAgentTemplateVersionResponses, TestAgentTemplateVersionErrors, ThrowOnError> => (options.client ?? client).post<TestAgentTemplateVersionResponses, TestAgentTemplateVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/{templateId}/versions/{versionId}/test',
    ...options
});

export const compareAgentTemplateVersions = <ThrowOnError extends boolean = false>(options: Options<CompareAgentTemplateVersionsData, ThrowOnError>): RequestResult<CompareAgentTemplateVersionsResponses, CompareAgentTemplateVersionsErrors, ThrowOnError> => (options.client ?? client).post<CompareAgentTemplateVersionsResponses, CompareAgentTemplateVersionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/{templateId}/versions/compare',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAgentTemplateVersionComparison = <ThrowOnError extends boolean = false>(options: Options<GetAgentTemplateVersionComparisonData, ThrowOnError>): RequestResult<GetAgentTemplateVersionComparisonResponses, GetAgentTemplateVersionComparisonErrors, ThrowOnError> => (options.client ?? client).get<GetAgentTemplateVersionComparisonResponses, GetAgentTemplateVersionComparisonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/{templateId}/versions/compare/{compareJobId}',
    ...options
});

export const preflightTemplateUpgrade = <ThrowOnError extends boolean = false>(options?: Options<PreflightTemplateUpgradeData, ThrowOnError>): RequestResult<PreflightTemplateUpgradeResponses, PreflightTemplateUpgradeErrors, ThrowOnError> => (options?.client ?? client).post<PreflightTemplateUpgradeResponses, PreflightTemplateUpgradeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/upgrades/preflight',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const createTemplateUpgradeProposal = <ThrowOnError extends boolean = false>(options?: Options<CreateTemplateUpgradeProposalData, ThrowOnError>): RequestResult<CreateTemplateUpgradeProposalResponses, CreateTemplateUpgradeProposalErrors, ThrowOnError> => (options?.client ?? client).post<CreateTemplateUpgradeProposalResponses, CreateTemplateUpgradeProposalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/upgrades/proposals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListTemplatesData, ThrowOnError>): RequestResult<ListTemplatesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListTemplatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates',
    ...options
});

export const createTemplate = <ThrowOnError extends boolean = false>(options?: Options<CreateTemplateData, ThrowOnError>): RequestResult<CreateTemplateResponses, CreateTemplateErrors, ThrowOnError> => (options?.client ?? client).post<CreateTemplateResponses, CreateTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteTemplateData, ThrowOnError>): RequestResult<DeleteTemplateResponses, DeleteTemplateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTemplateResponses, DeleteTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/{templateSlug}',
    ...options
});

export const getTemplate = <ThrowOnError extends boolean = false>(options: Options<GetTemplateData, ThrowOnError>): RequestResult<GetTemplateResponses, GetTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetTemplateResponses, GetTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/{templateSlug}',
    ...options
});

export const createOrUpdateTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateOrUpdateTemplateData, ThrowOnError>): RequestResult<CreateOrUpdateTemplateResponses, CreateOrUpdateTemplateErrors, ThrowOnError> => (options.client ?? client).put<CreateOrUpdateTemplateResponses, CreateOrUpdateTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/{templateSlug}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setTemplateStatus = <ThrowOnError extends boolean = false>(options: Options<SetTemplateStatusData, ThrowOnError>): RequestResult<SetTemplateStatusResponses, SetTemplateStatusErrors, ThrowOnError> => (options.client ?? client).patch<SetTemplateStatusResponses, SetTemplateStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/{templateSlug}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setTemplateAutoUpgrade = <ThrowOnError extends boolean = false>(options: Options<SetTemplateAutoUpgradeData, ThrowOnError>): RequestResult<SetTemplateAutoUpgradeResponses, SetTemplateAutoUpgradeErrors, ThrowOnError> => (options.client ?? client).patch<SetTemplateAutoUpgradeResponses, SetTemplateAutoUpgradeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/templates/{templateSlug}/auto-upgrade',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listSkills = <ThrowOnError extends boolean = false>(options?: Options<ListSkillsData, ThrowOnError>): RequestResult<ListSkillsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListSkillsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/skills',
    ...options
});

export const getSkill = <ThrowOnError extends boolean = false>(options: Options<GetSkillData, ThrowOnError>): RequestResult<GetSkillResponses, GetSkillErrors, ThrowOnError> => (options.client ?? client).get<GetSkillResponses, GetSkillErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/skills/{slug}',
    ...options
});

export const listToolLibraries = <ThrowOnError extends boolean = false>(options?: Options<ListToolLibrariesData, ThrowOnError>): RequestResult<ListToolLibrariesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListToolLibrariesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/tools/libraries',
    ...options
});

export const createToolLibrary = <ThrowOnError extends boolean = false>(options?: Options<CreateToolLibraryData, ThrowOnError>): RequestResult<CreateToolLibraryResponses, CreateToolLibraryErrors, ThrowOnError> => (options?.client ?? client).post<CreateToolLibraryResponses, CreateToolLibraryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/tools/libraries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteToolLibrary = <ThrowOnError extends boolean = false>(options: Options<DeleteToolLibraryData, ThrowOnError>): RequestResult<DeleteToolLibraryResponses, DeleteToolLibraryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteToolLibraryResponses, DeleteToolLibraryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/tools/libraries/{id}',
    ...options
});

export const getToolLibrary = <ThrowOnError extends boolean = false>(options: Options<GetToolLibraryData, ThrowOnError>): RequestResult<GetToolLibraryResponses, GetToolLibraryErrors, ThrowOnError> => (options.client ?? client).get<GetToolLibraryResponses, GetToolLibraryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/tools/libraries/{id}',
    ...options
});

export const updateToolLibrary = <ThrowOnError extends boolean = false>(options: Options<UpdateToolLibraryData, ThrowOnError>): RequestResult<UpdateToolLibraryResponses, UpdateToolLibraryErrors, ThrowOnError> => (options.client ?? client).patch<UpdateToolLibraryResponses, UpdateToolLibraryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/tools/libraries/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const syncToolLibrary = <ThrowOnError extends boolean = false>(options: Options<SyncToolLibraryData, ThrowOnError>): RequestResult<SyncToolLibraryResponses, SyncToolLibraryErrors, ThrowOnError> => (options.client ?? client).post<SyncToolLibraryResponses, SyncToolLibraryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/tools/libraries/{id}/sync',
    ...options
});

export const listToolLibraryTools = <ThrowOnError extends boolean = false>(options: Options<ListToolLibraryToolsData, ThrowOnError>): RequestResult<ListToolLibraryToolsResponses, ListToolLibraryToolsErrors, ThrowOnError> => (options.client ?? client).get<ListToolLibraryToolsResponses, ListToolLibraryToolsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/tools/libraries/{id}/tools',
    ...options
});

export const listTools = <ThrowOnError extends boolean = false>(options?: Options<ListToolsData, ThrowOnError>): RequestResult<ListToolsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListToolsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/tools',
    ...options
});

export const createTool = <ThrowOnError extends boolean = false>(options?: Options<CreateToolData, ThrowOnError>): RequestResult<CreateToolResponses, CreateToolErrors, ThrowOnError> => (options?.client ?? client).post<CreateToolResponses, CreateToolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/tools',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteTool = <ThrowOnError extends boolean = false>(options: Options<DeleteToolData, ThrowOnError>): RequestResult<DeleteToolResponses, DeleteToolErrors, ThrowOnError> => (options.client ?? client).delete<DeleteToolResponses, DeleteToolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/tools/{name}',
    ...options
});

export const getTool = <ThrowOnError extends boolean = false>(options: Options<GetToolData, ThrowOnError>): RequestResult<GetToolResponses, GetToolErrors, ThrowOnError> => (options.client ?? client).get<GetToolResponses, GetToolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/tools/{name}',
    ...options
});

export const createOrUpdateTool = <ThrowOnError extends boolean = false>(options: Options<CreateOrUpdateToolData, ThrowOnError>): RequestResult<CreateOrUpdateToolResponses, unknown, ThrowOnError> => (options.client ?? client).put<CreateOrUpdateToolResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/tools/{name}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setToolStatus = <ThrowOnError extends boolean = false>(options: Options<SetToolStatusData, ThrowOnError>): RequestResult<SetToolStatusResponses, SetToolStatusErrors, ThrowOnError> => (options.client ?? client).patch<SetToolStatusResponses, SetToolStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/tools/{name}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listAgentWorkflows = <ThrowOnError extends boolean = false>(options?: Options<ListAgentWorkflowsData, ThrowOnError>): RequestResult<ListAgentWorkflowsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAgentWorkflowsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/workflows',
    ...options
});

export const triggerAgentWorkflow = <ThrowOnError extends boolean = false>(options: Options<TriggerAgentWorkflowData, ThrowOnError>): RequestResult<TriggerAgentWorkflowResponses, TriggerAgentWorkflowErrors, ThrowOnError> => (options.client ?? client).post<TriggerAgentWorkflowResponses, TriggerAgentWorkflowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/workflows/{workflowId}/trigger',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAgentWorkflowRun = <ThrowOnError extends boolean = false>(options: Options<GetAgentWorkflowRunData, ThrowOnError>): RequestResult<GetAgentWorkflowRunResponses, GetAgentWorkflowRunErrors, ThrowOnError> => (options.client ?? client).get<GetAgentWorkflowRunResponses, GetAgentWorkflowRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/workflows/runs/{runId}',
    ...options
});

export const getAgentWorkflowRunDebugger = <ThrowOnError extends boolean = false>(options: Options<GetAgentWorkflowRunDebuggerData, ThrowOnError>): RequestResult<GetAgentWorkflowRunDebuggerResponses, GetAgentWorkflowRunDebuggerErrors, ThrowOnError> => (options.client ?? client).get<GetAgentWorkflowRunDebuggerResponses, GetAgentWorkflowRunDebuggerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/workflows/runs/{runId}/debug',
    ...options
});

export const runAgentWorkflowRunAction = <ThrowOnError extends boolean = false>(options: Options<RunAgentWorkflowRunActionData, ThrowOnError>): RequestResult<RunAgentWorkflowRunActionResponses, RunAgentWorkflowRunActionErrors, ThrowOnError> => (options.client ?? client).post<RunAgentWorkflowRunActionResponses, RunAgentWorkflowRunActionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/workflows/runs/{runId}/actions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listAgentWorkflowRuns = <ThrowOnError extends boolean = false>(options?: Options<ListAgentWorkflowRunsData, ThrowOnError>): RequestResult<ListAgentWorkflowRunsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAgentWorkflowRunsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/workflows/runs',
    ...options
});

export const listLlmCallCostOutliers = <ThrowOnError extends boolean = false>(options?: Options<ListLlmCallCostOutliersData, ThrowOnError>): RequestResult<ListLlmCallCostOutliersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListLlmCallCostOutliersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/monitoring/outliers/cost',
    ...options
});

export const listLlmCallLatencyOutliers = <ThrowOnError extends boolean = false>(options?: Options<ListLlmCallLatencyOutliersData, ThrowOnError>): RequestResult<ListLlmCallLatencyOutliersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListLlmCallLatencyOutliersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/monitoring/outliers/latency',
    ...options
});

export const getRunHealthAggregates = <ThrowOnError extends boolean = false>(options?: Options<GetRunHealthAggregatesData, ThrowOnError>): RequestResult<GetRunHealthAggregatesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRunHealthAggregatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/monitoring/health',
    ...options
});

export const listModels = <ThrowOnError extends boolean = false>(options?: Options<ListModelsData, ThrowOnError>): RequestResult<ListModelsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListModelsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/models',
    ...options
});

export const getModel = <ThrowOnError extends boolean = false>(options: Options<GetModelData, ThrowOnError>): RequestResult<GetModelResponses, GetModelErrors, ThrowOnError> => (options.client ?? client).get<GetModelResponses, GetModelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/models/{slug}',
    ...options
});

export const listModelRuntimePolicies = <ThrowOnError extends boolean = false>(options?: Options<ListModelRuntimePoliciesData, ThrowOnError>): RequestResult<ListModelRuntimePoliciesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListModelRuntimePoliciesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/model-runtime-policies',
    ...options
});

export const createModelRuntimePolicy = <ThrowOnError extends boolean = false>(options?: Options<CreateModelRuntimePolicyData, ThrowOnError>): RequestResult<CreateModelRuntimePolicyResponses, CreateModelRuntimePolicyErrors, ThrowOnError> => (options?.client ?? client).post<CreateModelRuntimePolicyResponses, CreateModelRuntimePolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/model-runtime-policies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const resolveModelRuntimePolicy = <ThrowOnError extends boolean = false>(options?: Options<ResolveModelRuntimePolicyData, ThrowOnError>): RequestResult<ResolveModelRuntimePolicyResponses, ResolveModelRuntimePolicyErrors, ThrowOnError> => (options?.client ?? client).post<ResolveModelRuntimePolicyResponses, ResolveModelRuntimePolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/model-runtime-policies/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getModelRuntimePolicy = <ThrowOnError extends boolean = false>(options: Options<GetModelRuntimePolicyData, ThrowOnError>): RequestResult<GetModelRuntimePolicyResponses, GetModelRuntimePolicyErrors, ThrowOnError> => (options.client ?? client).get<GetModelRuntimePolicyResponses, GetModelRuntimePolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/model-runtime-policies/{id}',
    ...options
});

export const updateModelRuntimePolicy = <ThrowOnError extends boolean = false>(options: Options<UpdateModelRuntimePolicyData, ThrowOnError>): RequestResult<UpdateModelRuntimePolicyResponses, UpdateModelRuntimePolicyErrors, ThrowOnError> => (options.client ?? client).put<UpdateModelRuntimePolicyResponses, UpdateModelRuntimePolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/model-runtime-policies/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listRuntimePolicySurfaceRules = <ThrowOnError extends boolean = false>(options?: Options<ListRuntimePolicySurfaceRulesData, ThrowOnError>): RequestResult<ListRuntimePolicySurfaceRulesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListRuntimePolicySurfaceRulesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/runtime-policy-surfaces',
    ...options
});

export const listRuntimePolicyOptions = <ThrowOnError extends boolean = false>(options: Options<ListRuntimePolicyOptionsData, ThrowOnError>): RequestResult<ListRuntimePolicyOptionsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListRuntimePolicyOptionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/runtime-policy-surfaces/{surface}/options',
    ...options
});

export const setSystemRuntimePolicySurfaceRule = <ThrowOnError extends boolean = false>(options: Options<SetSystemRuntimePolicySurfaceRuleData, ThrowOnError>): RequestResult<SetSystemRuntimePolicySurfaceRuleResponses, SetSystemRuntimePolicySurfaceRuleErrors, ThrowOnError> => (options.client ?? client).put<SetSystemRuntimePolicySurfaceRuleResponses, SetSystemRuntimePolicySurfaceRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/runtime-policy-surfaces/{surface}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const clearOrganizationRuntimePolicySurfaceRule = <ThrowOnError extends boolean = false>(options: Options<ClearOrganizationRuntimePolicySurfaceRuleData, ThrowOnError>): RequestResult<ClearOrganizationRuntimePolicySurfaceRuleResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ClearOrganizationRuntimePolicySurfaceRuleResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/runtime-policy-surfaces/{surface}/organization',
    ...options
});

export const setOrganizationRuntimePolicySurfaceRule = <ThrowOnError extends boolean = false>(options: Options<SetOrganizationRuntimePolicySurfaceRuleData, ThrowOnError>): RequestResult<SetOrganizationRuntimePolicySurfaceRuleResponses, SetOrganizationRuntimePolicySurfaceRuleErrors, ThrowOnError> => (options.client ?? client).put<SetOrganizationRuntimePolicySurfaceRuleResponses, SetOrganizationRuntimePolicySurfaceRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/runtime-policy-surfaces/{surface}/organization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listDynamicFanOutPolicies = <ThrowOnError extends boolean = false>(options?: Options<ListDynamicFanOutPoliciesData, ThrowOnError>): RequestResult<ListDynamicFanOutPoliciesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListDynamicFanOutPoliciesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dynamic-fanout-policies',
    ...options
});

export const createDynamicFanOutPolicy = <ThrowOnError extends boolean = false>(options?: Options<CreateDynamicFanOutPolicyData, ThrowOnError>): RequestResult<CreateDynamicFanOutPolicyResponses, CreateDynamicFanOutPolicyErrors, ThrowOnError> => (options?.client ?? client).post<CreateDynamicFanOutPolicyResponses, CreateDynamicFanOutPolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dynamic-fanout-policies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const resolveDynamicFanOutPolicy = <ThrowOnError extends boolean = false>(options?: Options<ResolveDynamicFanOutPolicyData, ThrowOnError>): RequestResult<ResolveDynamicFanOutPolicyResponses, ResolveDynamicFanOutPolicyErrors, ThrowOnError> => (options?.client ?? client).post<ResolveDynamicFanOutPolicyResponses, ResolveDynamicFanOutPolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dynamic-fanout-policies/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getDynamicFanOutPolicy = <ThrowOnError extends boolean = false>(options: Options<GetDynamicFanOutPolicyData, ThrowOnError>): RequestResult<GetDynamicFanOutPolicyResponses, GetDynamicFanOutPolicyErrors, ThrowOnError> => (options.client ?? client).get<GetDynamicFanOutPolicyResponses, GetDynamicFanOutPolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dynamic-fanout-policies/{slug}',
    ...options
});

export const updateDynamicFanOutPolicy = <ThrowOnError extends boolean = false>(options: Options<UpdateDynamicFanOutPolicyData, ThrowOnError>): RequestResult<UpdateDynamicFanOutPolicyResponses, UpdateDynamicFanOutPolicyErrors, ThrowOnError> => (options.client ?? client).put<UpdateDynamicFanOutPolicyResponses, UpdateDynamicFanOutPolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dynamic-fanout-policies/{slug}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const callAiWorkerMcp = <ThrowOnError extends boolean = false>(options: Options<CallAiWorkerMcpData, ThrowOnError>): RequestResult<CallAiWorkerMcpResponses, CallAiWorkerMcpErrors, ThrowOnError> => (options.client ?? client).post<CallAiWorkerMcpResponses, CallAiWorkerMcpErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai-workers/{workerId}/mcp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const queryAiWorkerData = <ThrowOnError extends boolean = false>(options: Options<QueryAiWorkerDataData, ThrowOnError>): RequestResult<QueryAiWorkerDataResponses, QueryAiWorkerDataErrors, ThrowOnError> => (options.client ?? client).post<QueryAiWorkerDataResponses, QueryAiWorkerDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai-workers/{workerId}/data/query',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const runAiWorkerDataset = <ThrowOnError extends boolean = false>(options: Options<RunAiWorkerDatasetData, ThrowOnError>): RequestResult<RunAiWorkerDatasetResponses, RunAiWorkerDatasetErrors, ThrowOnError> => (options.client ?? client).post<RunAiWorkerDatasetResponses, RunAiWorkerDatasetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai-workers/{workerId}/data/dataset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fetchAiWorkerDataResult = <ThrowOnError extends boolean = false>(options: Options<FetchAiWorkerDataResultData, ThrowOnError>): RequestResult<FetchAiWorkerDataResultResponses, FetchAiWorkerDataResultErrors, ThrowOnError> => (options.client ?? client).get<FetchAiWorkerDataResultResponses, FetchAiWorkerDataResultErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai-workers/{workerId}/data/result/{handle}',
    ...options
});

export const registerAiWorker = <ThrowOnError extends boolean = false>(options?: Options<RegisterAiWorkerData, ThrowOnError>): RequestResult<RegisterAiWorkerResponses, RegisterAiWorkerErrors, ThrowOnError> => (options?.client ?? client).post<RegisterAiWorkerResponses, RegisterAiWorkerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai-workers/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const heartbeatAiWorker = <ThrowOnError extends boolean = false>(options: Options<HeartbeatAiWorkerData, ThrowOnError>): RequestResult<HeartbeatAiWorkerResponses, HeartbeatAiWorkerErrors, ThrowOnError> => (options.client ?? client).post<HeartbeatAiWorkerResponses, HeartbeatAiWorkerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai-workers/{workerId}/heartbeat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const pollAiWorkerCommands = <ThrowOnError extends boolean = false>(options: Options<PollAiWorkerCommandsData, ThrowOnError>): RequestResult<PollAiWorkerCommandsResponses, PollAiWorkerCommandsErrors, ThrowOnError> => (options.client ?? client).post<PollAiWorkerCommandsResponses, PollAiWorkerCommandsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai-workers/{workerId}/poll',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const pollAiWorkerControlCommands = <ThrowOnError extends boolean = false>(options: Options<PollAiWorkerControlCommandsData, ThrowOnError>): RequestResult<PollAiWorkerControlCommandsResponses, PollAiWorkerControlCommandsErrors, ThrowOnError> => (options.client ?? client).post<PollAiWorkerControlCommandsResponses, PollAiWorkerControlCommandsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai-workers/{workerId}/control',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const publishAiWorkerEvents = <ThrowOnError extends boolean = false>(options: Options<PublishAiWorkerEventsData, ThrowOnError>): RequestResult<PublishAiWorkerEventsResponses, PublishAiWorkerEventsErrors, ThrowOnError> => (options.client ?? client).post<PublishAiWorkerEventsResponses, PublishAiWorkerEventsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ai-workers/{workerId}/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Push one batch of a box's host metrics (OTLP/HTTP, JSON encoding)
 *
 * Called by the monitoring agent on each box with its host_reporter key. The body is an OTLP ExportMetricsServiceRequest in JSON, optionally gzip-encoded (Content-Encoding: gzip).
 */
export const createHostMetrics = <ThrowOnError extends boolean = false>(options?: Options<CreateHostMetricsData, ThrowOnError>): RequestResult<CreateHostMetricsResponses, CreateHostMetricsErrors, ThrowOnError> => (options?.client ?? client).post<CreateHostMetricsResponses, CreateHostMetricsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/system/host-metrics',
    ...options
});

export const listSnapshots = <ThrowOnError extends boolean = false>(options: Options<ListSnapshotsData, ThrowOnError>): RequestResult<ListSnapshotsResponses, ListSnapshotsErrors, ThrowOnError> => (options.client ?? client).get<ListSnapshotsResponses, ListSnapshotsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/snapshots',
    ...options
});

export const createSnapshot = <ThrowOnError extends boolean = false>(options?: Options<CreateSnapshotData, ThrowOnError>): RequestResult<CreateSnapshotResponses, CreateSnapshotErrors, ThrowOnError> => (options?.client ?? client).post<CreateSnapshotResponses, CreateSnapshotErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/snapshots',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const purgeSnapshots = <ThrowOnError extends boolean = false>(options?: Options<PurgeSnapshotsData, ThrowOnError>): RequestResult<PurgeSnapshotsResponses, PurgeSnapshotsErrors, ThrowOnError> => (options?.client ?? client).post<PurgeSnapshotsResponses, PurgeSnapshotsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/snapshots/purge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteSnapshot = <ThrowOnError extends boolean = false>(options: Options<DeleteSnapshotData, ThrowOnError>): RequestResult<DeleteSnapshotResponses, DeleteSnapshotErrors, ThrowOnError> => (options.client ?? client).delete<DeleteSnapshotResponses, DeleteSnapshotErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/snapshots/{id}',
    ...options
});

export const getSnapshot = <ThrowOnError extends boolean = false>(options: Options<GetSnapshotData, ThrowOnError>): RequestResult<GetSnapshotResponses, GetSnapshotErrors, ThrowOnError> => (options.client ?? client).get<GetSnapshotResponses, GetSnapshotErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/snapshots/{id}',
    ...options
});

export const updateSnapshot = <ThrowOnError extends boolean = false>(options: Options<UpdateSnapshotData, ThrowOnError>): RequestResult<UpdateSnapshotResponses, UpdateSnapshotErrors, ThrowOnError> => (options.client ?? client).patch<UpdateSnapshotResponses, UpdateSnapshotErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/execution/snapshots/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listEvaluationDatasets = <ThrowOnError extends boolean = false>(options?: Options<ListEvaluationDatasetsData, ThrowOnError>): RequestResult<ListEvaluationDatasetsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListEvaluationDatasetsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/evaluations/datasets',
    ...options
});

export const createEvaluationDataset = <ThrowOnError extends boolean = false>(options?: Options<CreateEvaluationDatasetData, ThrowOnError>): RequestResult<CreateEvaluationDatasetResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CreateEvaluationDatasetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/evaluations/datasets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteEvaluationDataset = <ThrowOnError extends boolean = false>(options: Options<DeleteEvaluationDatasetData, ThrowOnError>): RequestResult<DeleteEvaluationDatasetResponses, DeleteEvaluationDatasetErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEvaluationDatasetResponses, DeleteEvaluationDatasetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/evaluations/datasets/{id}',
    ...options
});

export const listEvaluationCases = <ThrowOnError extends boolean = false>(options: Options<ListEvaluationCasesData, ThrowOnError>): RequestResult<ListEvaluationCasesResponses, ListEvaluationCasesErrors, ThrowOnError> => (options.client ?? client).get<ListEvaluationCasesResponses, ListEvaluationCasesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/evaluations/datasets/{id}/cases',
    ...options
});

export const createEvaluationCase = <ThrowOnError extends boolean = false>(options: Options<CreateEvaluationCaseData, ThrowOnError>): RequestResult<CreateEvaluationCaseResponses, CreateEvaluationCaseErrors, ThrowOnError> => (options.client ?? client).post<CreateEvaluationCaseResponses, CreateEvaluationCaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/evaluations/datasets/{id}/cases',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteEvaluationCase = <ThrowOnError extends boolean = false>(options: Options<DeleteEvaluationCaseData, ThrowOnError>): RequestResult<DeleteEvaluationCaseResponses, DeleteEvaluationCaseErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEvaluationCaseResponses, DeleteEvaluationCaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/evaluations/datasets/{id}/cases/{caseId}',
    ...options
});

export const runEvaluationDataset = <ThrowOnError extends boolean = false>(options: Options<RunEvaluationDatasetData, ThrowOnError>): RequestResult<RunEvaluationDatasetResponses, RunEvaluationDatasetErrors, ThrowOnError> => (options.client ?? client).post<RunEvaluationDatasetResponses, RunEvaluationDatasetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/evaluations/datasets/{id}/run',
    ...options
});

export const getEvaluationRun = <ThrowOnError extends boolean = false>(options: Options<GetEvaluationRunData, ThrowOnError>): RequestResult<GetEvaluationRunResponses, GetEvaluationRunErrors, ThrowOnError> => (options.client ?? client).get<GetEvaluationRunResponses, GetEvaluationRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/evaluations/runs/{runId}',
    ...options
});

export const listReasoningEvaluations = <ThrowOnError extends boolean = false>(options?: Options<ListReasoningEvaluationsData, ThrowOnError>): RequestResult<ListReasoningEvaluationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListReasoningEvaluationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/reasoning-evaluations',
    ...options
});

export const getReasoningCallSummary = <ThrowOnError extends boolean = false>(options?: Options<GetReasoningCallSummaryData, ThrowOnError>): RequestResult<GetReasoningCallSummaryResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetReasoningCallSummaryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/reasoning-evaluations/calls/summary',
    ...options
});

export const getReasoningPrincipleSummary = <ThrowOnError extends boolean = false>(options?: Options<GetReasoningPrincipleSummaryData, ThrowOnError>): RequestResult<GetReasoningPrincipleSummaryResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetReasoningPrincipleSummaryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/reasoning-evaluations/principles/summary',
    ...options
});

export const listEvaluationTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListEvaluationTemplatesData, ThrowOnError>): RequestResult<ListEvaluationTemplatesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListEvaluationTemplatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-templates',
    ...options
});

export const createEvaluationTemplate = <ThrowOnError extends boolean = false>(options?: Options<CreateEvaluationTemplateData, ThrowOnError>): RequestResult<CreateEvaluationTemplateResponses, CreateEvaluationTemplateErrors, ThrowOnError> => (options?.client ?? client).post<CreateEvaluationTemplateResponses, CreateEvaluationTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getEvaluationTemplate = <ThrowOnError extends boolean = false>(options: Options<GetEvaluationTemplateData, ThrowOnError>): RequestResult<GetEvaluationTemplateResponses, GetEvaluationTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetEvaluationTemplateResponses, GetEvaluationTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-templates/{id}',
    ...options
});

export const updateEvaluationTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateEvaluationTemplateData, ThrowOnError>): RequestResult<UpdateEvaluationTemplateResponses, UpdateEvaluationTemplateErrors, ThrowOnError> => (options.client ?? client).patch<UpdateEvaluationTemplateResponses, UpdateEvaluationTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-templates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const addEvaluationTemplateVersion = <ThrowOnError extends boolean = false>(options: Options<AddEvaluationTemplateVersionData, ThrowOnError>): RequestResult<AddEvaluationTemplateVersionResponses, AddEvaluationTemplateVersionErrors, ThrowOnError> => (options.client ?? client).post<AddEvaluationTemplateVersionResponses, AddEvaluationTemplateVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-templates/{id}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const publishEvaluationTemplateVersion = <ThrowOnError extends boolean = false>(options: Options<PublishEvaluationTemplateVersionData, ThrowOnError>): RequestResult<PublishEvaluationTemplateVersionResponses, PublishEvaluationTemplateVersionErrors, ThrowOnError> => (options.client ?? client).post<PublishEvaluationTemplateVersionResponses, PublishEvaluationTemplateVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-templates/{id}/versions/{versionId}/publish',
    ...options
});

export const applyEvaluationTemplate = <ThrowOnError extends boolean = false>(options: Options<ApplyEvaluationTemplateData, ThrowOnError>): RequestResult<ApplyEvaluationTemplateResponses, ApplyEvaluationTemplateErrors, ThrowOnError> => (options.client ?? client).post<ApplyEvaluationTemplateResponses, ApplyEvaluationTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/evaluation-templates/{id}/apply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getSubjectEvaluations = <ThrowOnError extends boolean = false>(options: Options<GetSubjectEvaluationsData, ThrowOnError>): RequestResult<GetSubjectEvaluationsResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetSubjectEvaluationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/subjects/{kind}/{subjectId}/evaluations',
    ...options
});

export const listCatalogSources = <ThrowOnError extends boolean = false>(options?: Options<ListCatalogSourcesData, ThrowOnError>): RequestResult<ListCatalogSourcesResponses, ListCatalogSourcesErrors, ThrowOnError> => (options?.client ?? client).get<ListCatalogSourcesResponses, ListCatalogSourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/sources',
    ...options
});

export const listCatalogCandidates = <ThrowOnError extends boolean = false>(options?: Options<ListCatalogCandidatesData, ThrowOnError>): RequestResult<ListCatalogCandidatesResponses, ListCatalogCandidatesErrors, ThrowOnError> => (options?.client ?? client).get<ListCatalogCandidatesResponses, ListCatalogCandidatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/candidates',
    ...options
});

export const getCatalogCandidate = <ThrowOnError extends boolean = false>(options: Options<GetCatalogCandidateData, ThrowOnError>): RequestResult<GetCatalogCandidateResponses, GetCatalogCandidateErrors, ThrowOnError> => (options.client ?? client).get<GetCatalogCandidateResponses, GetCatalogCandidateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/candidates/{id}',
    ...options
});

export const listCatalogReviewQueue = <ThrowOnError extends boolean = false>(options?: Options<ListCatalogReviewQueueData, ThrowOnError>): RequestResult<ListCatalogReviewQueueResponses, ListCatalogReviewQueueErrors, ThrowOnError> => (options?.client ?? client).get<ListCatalogReviewQueueResponses, ListCatalogReviewQueueErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/review-queue',
    ...options
});

export const processCatalogReviewQueue = <ThrowOnError extends boolean = false>(options?: Options<ProcessCatalogReviewQueueData, ThrowOnError>): RequestResult<ProcessCatalogReviewQueueResponses, ProcessCatalogReviewQueueErrors, ThrowOnError> => (options?.client ?? client).post<ProcessCatalogReviewQueueResponses, ProcessCatalogReviewQueueErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/review-queue/process',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const revertCatalogVersionAdoption = <ThrowOnError extends boolean = false>(options?: Options<RevertCatalogVersionAdoptionData, ThrowOnError>): RequestResult<RevertCatalogVersionAdoptionResponses, RevertCatalogVersionAdoptionErrors, ThrowOnError> => (options?.client ?? client).post<RevertCatalogVersionAdoptionResponses, RevertCatalogVersionAdoptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/adoptions/revert',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const retryCatalogReviewQueue = <ThrowOnError extends boolean = false>(options?: Options<RetryCatalogReviewQueueData, ThrowOnError>): RequestResult<RetryCatalogReviewQueueResponses, RetryCatalogReviewQueueErrors, ThrowOnError> => (options?.client ?? client).post<RetryCatalogReviewQueueResponses, RetryCatalogReviewQueueErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/review-queue/retry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const retryCatalogReviewQueueItem = <ThrowOnError extends boolean = false>(options: Options<RetryCatalogReviewQueueItemData, ThrowOnError>): RequestResult<RetryCatalogReviewQueueItemResponses, RetryCatalogReviewQueueItemErrors, ThrowOnError> => (options.client ?? client).post<RetryCatalogReviewQueueItemResponses, RetryCatalogReviewQueueItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/review-queue/{id}/retry',
    ...options
});

export const listCatalogItemVersions = <ThrowOnError extends boolean = false>(options?: Options<ListCatalogItemVersionsData, ThrowOnError>): RequestResult<ListCatalogItemVersionsResponses, ListCatalogItemVersionsErrors, ThrowOnError> => (options?.client ?? client).get<ListCatalogItemVersionsResponses, ListCatalogItemVersionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/versions',
    ...options
});

export const listCatalogVersionAdoptions = <ThrowOnError extends boolean = false>(options?: Options<ListCatalogVersionAdoptionsData, ThrowOnError>): RequestResult<ListCatalogVersionAdoptionsResponses, ListCatalogVersionAdoptionsErrors, ThrowOnError> => (options?.client ?? client).get<ListCatalogVersionAdoptionsResponses, ListCatalogVersionAdoptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/adoptions',
    ...options
});

export const upgradeCatalogVersionAdoption = <ThrowOnError extends boolean = false>(options?: Options<UpgradeCatalogVersionAdoptionData, ThrowOnError>): RequestResult<UpgradeCatalogVersionAdoptionResponses, UpgradeCatalogVersionAdoptionErrors, ThrowOnError> => (options?.client ?? client).post<UpgradeCatalogVersionAdoptionResponses, UpgradeCatalogVersionAdoptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/adoptions/upgrade',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const restoreCatalogItemVersion = <ThrowOnError extends boolean = false>(options: Options<RestoreCatalogItemVersionData, ThrowOnError>): RequestResult<RestoreCatalogItemVersionResponses, RestoreCatalogItemVersionErrors, ThrowOnError> => (options.client ?? client).post<RestoreCatalogItemVersionResponses, RestoreCatalogItemVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/versions/{id}/restore',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const rejectCatalogCandidate = <ThrowOnError extends boolean = false>(options: Options<RejectCatalogCandidateData, ThrowOnError>): RequestResult<RejectCatalogCandidateResponses, RejectCatalogCandidateErrors, ThrowOnError> => (options.client ?? client).post<RejectCatalogCandidateResponses, RejectCatalogCandidateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/candidates/{id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deferCatalogCandidate = <ThrowOnError extends boolean = false>(options: Options<DeferCatalogCandidateData, ThrowOnError>): RequestResult<DeferCatalogCandidateResponses, DeferCatalogCandidateErrors, ThrowOnError> => (options.client ?? client).post<DeferCatalogCandidateResponses, DeferCatalogCandidateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/candidates/{id}/defer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const retryCatalogCandidateReview = <ThrowOnError extends boolean = false>(options: Options<RetryCatalogCandidateReviewData, ThrowOnError>): RequestResult<RetryCatalogCandidateReviewResponses, RetryCatalogCandidateReviewErrors, ThrowOnError> => (options.client ?? client).post<RetryCatalogCandidateReviewResponses, RetryCatalogCandidateReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/candidates/{id}/retry-review',
    ...options
});

export const promoteCatalogCandidate = <ThrowOnError extends boolean = false>(options: Options<PromoteCatalogCandidateData, ThrowOnError>): RequestResult<PromoteCatalogCandidateResponses, PromoteCatalogCandidateErrors, ThrowOnError> => (options.client ?? client).post<PromoteCatalogCandidateResponses, PromoteCatalogCandidateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agents/catalog/candidates/{id}/promote',
    ...options
});

export const listWidgets = <ThrowOnError extends boolean = false>(options?: Options<ListWidgetsData, ThrowOnError>): RequestResult<ListWidgetsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListWidgetsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/outputs/widgets',
    ...options
});

export const createWidget = <ThrowOnError extends boolean = false>(options?: Options<CreateWidgetData, ThrowOnError>): RequestResult<CreateWidgetResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CreateWidgetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/outputs/widgets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getWidget = <ThrowOnError extends boolean = false>(options: Options<GetWidgetData, ThrowOnError>): RequestResult<GetWidgetResponses, GetWidgetErrors, ThrowOnError> => (options.client ?? client).get<GetWidgetResponses, GetWidgetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/outputs/widgets/{id}',
    ...options
});

export const listPinnedWidgets = <ThrowOnError extends boolean = false>(options: Options<ListPinnedWidgetsData, ThrowOnError>): RequestResult<ListPinnedWidgetsResponses, ListPinnedWidgetsErrors, ThrowOnError> => (options.client ?? client).get<ListPinnedWidgetsResponses, ListPinnedWidgetsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/outputs/pinned-widgets',
    ...options
});

export const pinWidget = <ThrowOnError extends boolean = false>(options?: Options<PinWidgetData, ThrowOnError>): RequestResult<PinWidgetResponses, PinWidgetErrors, ThrowOnError> => (options?.client ?? client).post<PinWidgetResponses, PinWidgetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/outputs/pinned-widgets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const unpinWidget = <ThrowOnError extends boolean = false>(options: Options<UnpinWidgetData, ThrowOnError>): RequestResult<UnpinWidgetResponses, UnpinWidgetErrors, ThrowOnError> => (options.client ?? client).delete<UnpinWidgetResponses, UnpinWidgetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/outputs/pinned-widgets/{id}',
    ...options
});

export const updatePinnedWidget = <ThrowOnError extends boolean = false>(options: Options<UpdatePinnedWidgetData, ThrowOnError>): RequestResult<UpdatePinnedWidgetResponses, UpdatePinnedWidgetErrors, ThrowOnError> => (options.client ?? client).put<UpdatePinnedWidgetResponses, UpdatePinnedWidgetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/outputs/pinned-widgets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listOutputPartKinds = <ThrowOnError extends boolean = false>(options?: Options<ListOutputPartKindsData, ThrowOnError>): RequestResult<ListOutputPartKindsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListOutputPartKindsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/outputs/part-kinds',
    ...options
});

export const queryOutputs = <ThrowOnError extends boolean = false>(options?: Options<QueryOutputsData, ThrowOnError>): RequestResult<QueryOutputsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<QueryOutputsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/outputs',
    ...options
});

export const getLatestOutput = <ThrowOnError extends boolean = false>(options?: Options<GetLatestOutputData, ThrowOnError>): RequestResult<GetLatestOutputResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetLatestOutputResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/outputs/latest',
    ...options
});

export const getOutputMetrics = <ThrowOnError extends boolean = false>(options?: Options<GetOutputMetricsData, ThrowOnError>): RequestResult<GetOutputMetricsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetOutputMetricsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/outputs/metrics',
    ...options
});

export const getOutput = <ThrowOnError extends boolean = false>(options: Options<GetOutputData, ThrowOnError>): RequestResult<GetOutputResponses, GetOutputErrors, ThrowOnError> => (options.client ?? client).get<GetOutputResponses, GetOutputErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/outputs/{id}',
    ...options
});

export const downloadOutput = <ThrowOnError extends boolean = false>(options: Options<DownloadOutputData, ThrowOnError>): RequestResult<DownloadOutputResponses, DownloadOutputErrors, ThrowOnError> => (options.client ?? client).get<DownloadOutputResponses, DownloadOutputErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/outputs/{id}/download',
    ...options
});

export const getPortTypeColors = <ThrowOnError extends boolean = false>(options?: Options<GetPortTypeColorsData, ThrowOnError>): RequestResult<GetPortTypeColorsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPortTypeColorsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/port-types/colors',
    ...options
});

export const checkPortCompatibility = <ThrowOnError extends boolean = false>(options: Options<CheckPortCompatibilityData, ThrowOnError>): RequestResult<CheckPortCompatibilityResponses, CheckPortCompatibilityErrors, ThrowOnError> => (options.client ?? client).get<CheckPortCompatibilityResponses, CheckPortCompatibilityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/port-types/compatibility/check',
    ...options
});

export const listPortTypes = <ThrowOnError extends boolean = false>(options?: Options<ListPortTypesData, ThrowOnError>): RequestResult<ListPortTypesResponses, ListPortTypesErrors, ThrowOnError> => (options?.client ?? client).get<ListPortTypesResponses, ListPortTypesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/port-types',
    ...options
});

export const getPortType = <ThrowOnError extends boolean = false>(options: Options<GetPortTypeData, ThrowOnError>): RequestResult<GetPortTypeResponses, GetPortTypeErrors, ThrowOnError> => (options.client ?? client).get<GetPortTypeResponses, GetPortTypeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/port-types/{name}',
    ...options
});

export const listDocuments = <ThrowOnError extends boolean = false>(options: Options<ListDocumentsData, ThrowOnError>): RequestResult<ListDocumentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListDocumentsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/documents',
    ...options
});

export const uploadDocument = <ThrowOnError extends boolean = false>(options: Options<UploadDocumentData, ThrowOnError>): RequestResult<UploadDocumentResponses, unknown, ThrowOnError> => (options.client ?? client).post<UploadDocumentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/documents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteDocument = <ThrowOnError extends boolean = false>(options: Options<DeleteDocumentData, ThrowOnError>): RequestResult<DeleteDocumentResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteDocumentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/documents/{docId}',
    ...options
});

export const getDocument = <ThrowOnError extends boolean = false>(options: Options<GetDocumentData, ThrowOnError>): RequestResult<GetDocumentResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetDocumentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/documents/{docId}',
    ...options
});

export const setWorkflowRuntimePolicy = <ThrowOnError extends boolean = false>(options: Options<SetWorkflowRuntimePolicyData, ThrowOnError>): RequestResult<SetWorkflowRuntimePolicyResponses, SetWorkflowRuntimePolicyErrors, ThrowOnError> => (options.client ?? client).put<SetWorkflowRuntimePolicyResponses, SetWorkflowRuntimePolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/runtime-policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const exportInstructions = <ThrowOnError extends boolean = false>(options?: Options<ExportInstructionsData, ThrowOnError>): RequestResult<ExportInstructionsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ExportInstructionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/instructions/export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listWorkflows = <ThrowOnError extends boolean = false>(options?: Options<ListWorkflowsData, ThrowOnError>): RequestResult<ListWorkflowsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListWorkflowsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows',
    ...options
});

export const createWorkflow = <ThrowOnError extends boolean = false>(options?: Options<CreateWorkflowData, ThrowOnError>): RequestResult<CreateWorkflowResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CreateWorkflowResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const exportWorkflowInstructions = <ThrowOnError extends boolean = false>(options: Options<ExportWorkflowInstructionsData, ThrowOnError>): RequestResult<ExportWorkflowInstructionsResponses, unknown, ThrowOnError> => (options.client ?? client).post<ExportWorkflowInstructionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/instructions/export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const restoreWorkflow = <ThrowOnError extends boolean = false>(options: Options<RestoreWorkflowData, ThrowOnError>): RequestResult<RestoreWorkflowResponses, RestoreWorkflowErrors, ThrowOnError> => (options.client ?? client).post<RestoreWorkflowResponses, RestoreWorkflowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/restore',
    ...options
});

export const validateWorkflow = <ThrowOnError extends boolean = false>(options: Options<ValidateWorkflowData, ThrowOnError>): RequestResult<ValidateWorkflowResponses, ValidateWorkflowErrors, ThrowOnError> => (options.client ?? client).post<ValidateWorkflowResponses, ValidateWorkflowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/validate',
    ...options
});

export const reorderWorkflowSteps = <ThrowOnError extends boolean = false>(options: Options<ReorderWorkflowStepsData, ThrowOnError>): RequestResult<ReorderWorkflowStepsResponses, ReorderWorkflowStepsErrors, ThrowOnError> => (options.client ?? client).post<ReorderWorkflowStepsResponses, ReorderWorkflowStepsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/steps/reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const addWorkflowStep = <ThrowOnError extends boolean = false>(options: Options<AddWorkflowStepData, ThrowOnError>): RequestResult<AddWorkflowStepResponses, AddWorkflowStepErrors, ThrowOnError> => (options.client ?? client).post<AddWorkflowStepResponses, AddWorkflowStepErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/steps',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const removeWorkflowStep = <ThrowOnError extends boolean = false>(options: Options<RemoveWorkflowStepData, ThrowOnError>): RequestResult<RemoveWorkflowStepResponses, RemoveWorkflowStepErrors, ThrowOnError> => (options.client ?? client).delete<RemoveWorkflowStepResponses, RemoveWorkflowStepErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/steps/{stepId}',
    ...options
});

export const updateWorkflowStep = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkflowStepData, ThrowOnError>): RequestResult<UpdateWorkflowStepResponses, UpdateWorkflowStepErrors, ThrowOnError> => (options.client ?? client).put<UpdateWorkflowStepResponses, UpdateWorkflowStepErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/steps/{stepId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setWorkflowSchedule = <ThrowOnError extends boolean = false>(options: Options<SetWorkflowScheduleData, ThrowOnError>): RequestResult<SetWorkflowScheduleResponses, unknown, ThrowOnError> => (options.client ?? client).patch<SetWorkflowScheduleResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/schedule',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listWorkflowExecutionObservations = <ThrowOnError extends boolean = false>(options: Options<ListWorkflowExecutionObservationsData, ThrowOnError>): RequestResult<ListWorkflowExecutionObservationsResponses, ListWorkflowExecutionObservationsErrors, ThrowOnError> => (options.client ?? client).get<ListWorkflowExecutionObservationsResponses, ListWorkflowExecutionObservationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/execution-observations',
    ...options
});

export const listWorkflowRuns = <ThrowOnError extends boolean = false>(options: Options<ListWorkflowRunsData, ThrowOnError>): RequestResult<ListWorkflowRunsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListWorkflowRunsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/runs',
    ...options
});

export const triggerWorkflow = <ThrowOnError extends boolean = false>(options: Options<TriggerWorkflowData, ThrowOnError>): RequestResult<TriggerWorkflowResponses, TriggerWorkflowErrors, ThrowOnError> => (options.client ?? client).post<TriggerWorkflowResponses, TriggerWorkflowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/trigger',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listWorkflowVersions = <ThrowOnError extends boolean = false>(options: Options<ListWorkflowVersionsData, ThrowOnError>): RequestResult<ListWorkflowVersionsResponses, ListWorkflowVersionsErrors, ThrowOnError> => (options.client ?? client).get<ListWorkflowVersionsResponses, ListWorkflowVersionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/versions',
    ...options
});

export const getWorkflowVersion = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowVersionData, ThrowOnError>): RequestResult<GetWorkflowVersionResponses, GetWorkflowVersionErrors, ThrowOnError> => (options.client ?? client).get<GetWorkflowVersionResponses, GetWorkflowVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/versions/{version}',
    ...options
});

export const diffWorkflowVersions = <ThrowOnError extends boolean = false>(options: Options<DiffWorkflowVersionsData, ThrowOnError>): RequestResult<DiffWorkflowVersionsResponses, DiffWorkflowVersionsErrors, ThrowOnError> => (options.client ?? client).get<DiffWorkflowVersionsResponses, DiffWorkflowVersionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/versions/{versionA}/diff/{versionB}',
    ...options
});

export const restoreWorkflowVersion = <ThrowOnError extends boolean = false>(options: Options<RestoreWorkflowVersionData, ThrowOnError>): RequestResult<RestoreWorkflowVersionResponses, RestoreWorkflowVersionErrors, ThrowOnError> => (options.client ?? client).post<RestoreWorkflowVersionResponses, RestoreWorkflowVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/versions/{version}/restore',
    ...options
});

export const saveWorkflowDefinitionGraph = <ThrowOnError extends boolean = false>(options: Options<SaveWorkflowDefinitionGraphData, ThrowOnError>): RequestResult<SaveWorkflowDefinitionGraphResponses, SaveWorkflowDefinitionGraphErrors, ThrowOnError> => (options.client ?? client).put<SaveWorkflowDefinitionGraphResponses, SaveWorkflowDefinitionGraphErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/graph',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const archiveWorkflow = <ThrowOnError extends boolean = false>(options: Options<ArchiveWorkflowData, ThrowOnError>): RequestResult<ArchiveWorkflowResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ArchiveWorkflowResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}',
    ...options
});

export const getWorkflow = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowData, ThrowOnError>): RequestResult<GetWorkflowResponses, GetWorkflowErrors, ThrowOnError> => (options.client ?? client).get<GetWorkflowResponses, GetWorkflowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}',
    ...options
});

export const updateWorkflow = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkflowData, ThrowOnError>): RequestResult<UpdateWorkflowResponses, UpdateWorkflowErrors, ThrowOnError> => (options.client ?? client).put<UpdateWorkflowResponses, UpdateWorkflowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getWorkflowCloseSummary = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowCloseSummaryData, ThrowOnError>): RequestResult<GetWorkflowCloseSummaryResponses, GetWorkflowCloseSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetWorkflowCloseSummaryResponses, GetWorkflowCloseSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/close-summary',
    ...options
});

export const listWorkflowInstances = <ThrowOnError extends boolean = false>(options?: Options<ListWorkflowInstancesData, ThrowOnError>): RequestResult<ListWorkflowInstancesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListWorkflowInstancesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflow-instances',
    ...options
});

export const createWorkflowInstance = <ThrowOnError extends boolean = false>(options?: Options<CreateWorkflowInstanceData, ThrowOnError>): RequestResult<CreateWorkflowInstanceResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CreateWorkflowInstanceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflow-instances',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getWorkflowInstance = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowInstanceData, ThrowOnError>): RequestResult<GetWorkflowInstanceResponses, GetWorkflowInstanceErrors, ThrowOnError> => (options.client ?? client).get<GetWorkflowInstanceResponses, GetWorkflowInstanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflow-instances/{id}',
    ...options
});

export const updateWorkflowInstance = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkflowInstanceData, ThrowOnError>): RequestResult<UpdateWorkflowInstanceResponses, UpdateWorkflowInstanceErrors, ThrowOnError> => (options.client ?? client).patch<UpdateWorkflowInstanceResponses, UpdateWorkflowInstanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflow-instances/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const triggerWorkflowInstance = <ThrowOnError extends boolean = false>(options: Options<TriggerWorkflowInstanceData, ThrowOnError>): RequestResult<TriggerWorkflowInstanceResponses, TriggerWorkflowInstanceErrors, ThrowOnError> => (options.client ?? client).post<TriggerWorkflowInstanceResponses, TriggerWorkflowInstanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflow-instances/{id}/trigger',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const searchWorkflowDefinitions = <ThrowOnError extends boolean = false>(options: Options<SearchWorkflowDefinitionsData, ThrowOnError>): RequestResult<SearchWorkflowDefinitionsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SearchWorkflowDefinitionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflow-definitions/search',
    ...options
});

export const recommendWorkflowDefinitions = <ThrowOnError extends boolean = false>(options: Options<RecommendWorkflowDefinitionsData, ThrowOnError>): RequestResult<RecommendWorkflowDefinitionsResponses, unknown, ThrowOnError> => (options.client ?? client).get<RecommendWorkflowDefinitionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflow-definitions/recommend',
    ...options
});

export const listOrganizations = <ThrowOnError extends boolean = false>(options?: Options<ListOrganizationsData, ThrowOnError>): RequestResult<ListOrganizationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListOrganizationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations',
    ...options
});

export const createOrganization = <ThrowOnError extends boolean = false>(options?: Options<CreateOrganizationData, ThrowOnError>): RequestResult<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError> => (options?.client ?? client).post<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getMyOrganizations = <ThrowOnError extends boolean = false>(options?: Options<GetMyOrganizationsData, ThrowOnError>): RequestResult<GetMyOrganizationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyOrganizationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/me',
    ...options
});

export const getOrganization = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationData, ThrowOnError>): RequestResult<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{id}',
    ...options
});

export const updateOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationData, ThrowOnError>): RequestResult<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listOrgMembers = <ThrowOnError extends boolean = false>(options: Options<ListOrgMembersData, ThrowOnError>): RequestResult<ListOrgMembersResponses, ListOrgMembersErrors, ThrowOnError> => (options.client ?? client).get<ListOrgMembersResponses, ListOrgMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{id}/members',
    ...options
});

export const addOrgMember = <ThrowOnError extends boolean = false>(options: Options<AddOrgMemberData, ThrowOnError>): RequestResult<AddOrgMemberResponses, AddOrgMemberErrors, ThrowOnError> => (options.client ?? client).post<AddOrgMemberResponses, AddOrgMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const acknowledgeOrgModule = <ThrowOnError extends boolean = false>(options: Options<AcknowledgeOrgModuleData, ThrowOnError>): RequestResult<AcknowledgeOrgModuleResponses, AcknowledgeOrgModuleErrors, ThrowOnError> => (options.client ?? client).post<AcknowledgeOrgModuleResponses, AcknowledgeOrgModuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{id}/modules/{moduleId}/acknowledge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listTeams = <ThrowOnError extends boolean = false>(options: Options<ListTeamsData, ThrowOnError>): RequestResult<ListTeamsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListTeamsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{id}/teams',
    ...options
});

export const createTeam = <ThrowOnError extends boolean = false>(options: Options<CreateTeamData, ThrowOnError>): RequestResult<CreateTeamResponses, CreateTeamErrors, ThrowOnError> => (options.client ?? client).post<CreateTeamResponses, CreateTeamErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{id}/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getMyTeamsInOrg = <ThrowOnError extends boolean = false>(options: Options<GetMyTeamsInOrgData, ThrowOnError>): RequestResult<GetMyTeamsInOrgResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetMyTeamsInOrgResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{orgId}/teams/@me',
    ...options
});

export const listTeamMembers = <ThrowOnError extends boolean = false>(options: Options<ListTeamMembersData, ThrowOnError>): RequestResult<ListTeamMembersResponses, ListTeamMembersErrors, ThrowOnError> => (options.client ?? client).get<ListTeamMembersResponses, ListTeamMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/teams/{teamId}/members',
    ...options
});

export const addTeamMember = <ThrowOnError extends boolean = false>(options: Options<AddTeamMemberData, ThrowOnError>): RequestResult<AddTeamMemberResponses, AddTeamMemberErrors, ThrowOnError> => (options.client ?? client).post<AddTeamMemberResponses, AddTeamMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/teams/{teamId}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const removeTeamMember = <ThrowOnError extends boolean = false>(options: Options<RemoveTeamMemberData, ThrowOnError>): RequestResult<RemoveTeamMemberResponses, RemoveTeamMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveTeamMemberResponses, RemoveTeamMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/teams/{teamId}/members/{userId}',
    ...options
});

export const listOrgInvitations = <ThrowOnError extends boolean = false>(options: Options<ListOrgInvitationsData, ThrowOnError>): RequestResult<ListOrgInvitationsResponses, ListOrgInvitationsErrors, ThrowOnError> => (options.client ?? client).get<ListOrgInvitationsResponses, ListOrgInvitationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{orgId}/invitations',
    ...options
});

export const createInvitation = <ThrowOnError extends boolean = false>(options: Options<CreateInvitationData, ThrowOnError>): RequestResult<CreateInvitationResponses, CreateInvitationErrors, ThrowOnError> => (options.client ?? client).post<CreateInvitationResponses, CreateInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/{orgId}/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listAnalysisTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListAnalysisTemplatesData, ThrowOnError>): RequestResult<ListAnalysisTemplatesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAnalysisTemplatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/analysis/templates',
    ...options
});

export const createAnalysisTemplate = <ThrowOnError extends boolean = false>(options?: Options<CreateAnalysisTemplateData, ThrowOnError>): RequestResult<CreateAnalysisTemplateResponses, CreateAnalysisTemplateErrors, ThrowOnError> => (options?.client ?? client).post<CreateAnalysisTemplateResponses, CreateAnalysisTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/analysis/templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteAnalysisTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteAnalysisTemplateData, ThrowOnError>): RequestResult<DeleteAnalysisTemplateResponses, DeleteAnalysisTemplateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAnalysisTemplateResponses, DeleteAnalysisTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/analysis/templates/{id}',
    ...options
});

export const getAnalysisTemplate = <ThrowOnError extends boolean = false>(options: Options<GetAnalysisTemplateData, ThrowOnError>): RequestResult<GetAnalysisTemplateResponses, GetAnalysisTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetAnalysisTemplateResponses, GetAnalysisTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/analysis/templates/{id}',
    ...options
});

export const updateAnalysisTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateAnalysisTemplateData, ThrowOnError>): RequestResult<UpdateAnalysisTemplateResponses, UpdateAnalysisTemplateErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAnalysisTemplateResponses, UpdateAnalysisTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/analysis/templates/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const cloneAnalysisTemplate = <ThrowOnError extends boolean = false>(options: Options<CloneAnalysisTemplateData, ThrowOnError>): RequestResult<CloneAnalysisTemplateResponses, CloneAnalysisTemplateErrors, ThrowOnError> => (options.client ?? client).post<CloneAnalysisTemplateResponses, CloneAnalysisTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/analysis/templates/{id}/clone',
    ...options
});

export const listIntelPlatforms = <ThrowOnError extends boolean = false>(options?: Options<ListIntelPlatformsData, ThrowOnError>): RequestResult<ListIntelPlatformsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListIntelPlatformsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/platforms',
    ...options
});

export const createIntelPlatform = <ThrowOnError extends boolean = false>(options?: Options<CreateIntelPlatformData, ThrowOnError>): RequestResult<CreateIntelPlatformResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CreateIntelPlatformResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/platforms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const testIntelPlatform = <ThrowOnError extends boolean = false>(options: Options<TestIntelPlatformData, ThrowOnError>): RequestResult<TestIntelPlatformResponses, TestIntelPlatformErrors, ThrowOnError> => (options.client ?? client).post<TestIntelPlatformResponses, TestIntelPlatformErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/platforms/{slug}/test',
    ...options
});

export const getIntelPlatformUsage = <ThrowOnError extends boolean = false>(options: Options<GetIntelPlatformUsageData, ThrowOnError>): RequestResult<GetIntelPlatformUsageResponses, GetIntelPlatformUsageErrors, ThrowOnError> => (options.client ?? client).get<GetIntelPlatformUsageResponses, GetIntelPlatformUsageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/platforms/{slug}/usage',
    ...options
});

export const updateIntelPlatform = <ThrowOnError extends boolean = false>(options: Options<UpdateIntelPlatformData, ThrowOnError>): RequestResult<UpdateIntelPlatformResponses, UpdateIntelPlatformErrors, ThrowOnError> => (options.client ?? client).patch<UpdateIntelPlatformResponses, UpdateIntelPlatformErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/platforms/{slug}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listIntelSources = <ThrowOnError extends boolean = false>(options?: Options<ListIntelSourcesData, ThrowOnError>): RequestResult<ListIntelSourcesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListIntelSourcesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources',
    ...options
});

export const createIntelSource = <ThrowOnError extends boolean = false>(options?: Options<CreateIntelSourceData, ThrowOnError>): RequestResult<CreateIntelSourceResponses, CreateIntelSourceErrors, ThrowOnError> => (options?.client ?? client).post<CreateIntelSourceResponses, CreateIntelSourceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const discoverIntelSource = <ThrowOnError extends boolean = false>(options?: Options<DiscoverIntelSourceData, ThrowOnError>): RequestResult<DiscoverIntelSourceResponses, unknown, ThrowOnError> => (options?.client ?? client).post<DiscoverIntelSourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/discover',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const bulkCreateIntelSources = <ThrowOnError extends boolean = false>(options?: Options<BulkCreateIntelSourcesData, ThrowOnError>): RequestResult<BulkCreateIntelSourcesResponses, BulkCreateIntelSourcesErrors, ThrowOnError> => (options?.client ?? client).post<BulkCreateIntelSourcesResponses, BulkCreateIntelSourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const batchFetchIntelSources = <ThrowOnError extends boolean = false>(options?: Options<BatchFetchIntelSourcesData, ThrowOnError>): RequestResult<BatchFetchIntelSourcesResponses, unknown, ThrowOnError> => (options?.client ?? client).post<BatchFetchIntelSourcesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/batch-fetch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const batchDeactivateIntelSources = <ThrowOnError extends boolean = false>(options?: Options<BatchDeactivateIntelSourcesData, ThrowOnError>): RequestResult<BatchDeactivateIntelSourcesResponses, unknown, ThrowOnError> => (options?.client ?? client).post<BatchDeactivateIntelSourcesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/batch-deactivate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteIntelSource = <ThrowOnError extends boolean = false>(options: Options<DeleteIntelSourceData, ThrowOnError>): RequestResult<DeleteIntelSourceResponses, DeleteIntelSourceErrors, ThrowOnError> => (options.client ?? client).delete<DeleteIntelSourceResponses, DeleteIntelSourceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/{id}',
    ...options
});

export const getIntelSource = <ThrowOnError extends boolean = false>(options: Options<GetIntelSourceData, ThrowOnError>): RequestResult<GetIntelSourceResponses, GetIntelSourceErrors, ThrowOnError> => (options.client ?? client).get<GetIntelSourceResponses, GetIntelSourceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/{id}',
    ...options
});

export const updateIntelSource = <ThrowOnError extends boolean = false>(options: Options<UpdateIntelSourceData, ThrowOnError>): RequestResult<UpdateIntelSourceResponses, UpdateIntelSourceErrors, ThrowOnError> => (options.client ?? client).patch<UpdateIntelSourceResponses, UpdateIntelSourceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fetchIntelSource = <ThrowOnError extends boolean = false>(options: Options<FetchIntelSourceData, ThrowOnError>): RequestResult<FetchIntelSourceResponses, FetchIntelSourceErrors, ThrowOnError> => (options.client ?? client).post<FetchIntelSourceResponses, FetchIntelSourceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/{id}/fetch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getIntelSourceHarvested = <ThrowOnError extends boolean = false>(options: Options<GetIntelSourceHarvestedData, ThrowOnError>): RequestResult<GetIntelSourceHarvestedResponses, GetIntelSourceHarvestedErrors, ThrowOnError> => (options.client ?? client).get<GetIntelSourceHarvestedResponses, GetIntelSourceHarvestedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/{id}/harvested',
    ...options
});

export const createIntelSourceSubscription = <ThrowOnError extends boolean = false>(options: Options<CreateIntelSourceSubscriptionData, ThrowOnError>): RequestResult<CreateIntelSourceSubscriptionResponses, CreateIntelSourceSubscriptionErrors, ThrowOnError> => (options.client ?? client).post<CreateIntelSourceSubscriptionResponses, CreateIntelSourceSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/{id}/subscriptions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const reviewIntelSourceApproval = <ThrowOnError extends boolean = false>(options: Options<ReviewIntelSourceApprovalData, ThrowOnError>): RequestResult<ReviewIntelSourceApprovalResponses, ReviewIntelSourceApprovalErrors, ThrowOnError> => (options.client ?? client).post<ReviewIntelSourceApprovalResponses, ReviewIntelSourceApprovalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/{id}/approval',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const recordIntelSourceConsent = <ThrowOnError extends boolean = false>(options: Options<RecordIntelSourceConsentData, ThrowOnError>): RequestResult<RecordIntelSourceConsentResponses, RecordIntelSourceConsentErrors, ThrowOnError> => (options.client ?? client).post<RecordIntelSourceConsentResponses, RecordIntelSourceConsentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/{id}/consent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createIntelSourceMonitor = <ThrowOnError extends boolean = false>(options: Options<CreateIntelSourceMonitorData, ThrowOnError>): RequestResult<CreateIntelSourceMonitorResponses, CreateIntelSourceMonitorErrors, ThrowOnError> => (options.client ?? client).post<CreateIntelSourceMonitorResponses, CreateIntelSourceMonitorErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/{id}/monitors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listIntelSourceItemInsights = <ThrowOnError extends boolean = false>(options: Options<ListIntelSourceItemInsightsData, ThrowOnError>): RequestResult<ListIntelSourceItemInsightsResponses, ListIntelSourceItemInsightsErrors, ThrowOnError> => (options.client ?? client).get<ListIntelSourceItemInsightsResponses, ListIntelSourceItemInsightsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/sources/{id}/data/{dataId}/insights',
    ...options
});

export const listIntelSourceSubscriptions = <ThrowOnError extends boolean = false>(options?: Options<ListIntelSourceSubscriptionsData, ThrowOnError>): RequestResult<ListIntelSourceSubscriptionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListIntelSourceSubscriptionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/source-subscriptions',
    ...options
});

export const updateIntelSourceSubscription = <ThrowOnError extends boolean = false>(options: Options<UpdateIntelSourceSubscriptionData, ThrowOnError>): RequestResult<UpdateIntelSourceSubscriptionResponses, UpdateIntelSourceSubscriptionErrors, ThrowOnError> => (options.client ?? client).patch<UpdateIntelSourceSubscriptionResponses, UpdateIntelSourceSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/source-subscriptions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listIntelSourceFetchRuns = <ThrowOnError extends boolean = false>(options: Options<ListIntelSourceFetchRunsData, ThrowOnError>): RequestResult<ListIntelSourceFetchRunsResponses, ListIntelSourceFetchRunsErrors, ThrowOnError> => (options.client ?? client).get<ListIntelSourceFetchRunsResponses, ListIntelSourceFetchRunsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/source-subscriptions/{id}/fetch-runs',
    ...options
});

export const backfillIntelSourceSubscription = <ThrowOnError extends boolean = false>(options: Options<BackfillIntelSourceSubscriptionData, ThrowOnError>): RequestResult<BackfillIntelSourceSubscriptionResponses, BackfillIntelSourceSubscriptionErrors, ThrowOnError> => (options.client ?? client).post<BackfillIntelSourceSubscriptionResponses, BackfillIntelSourceSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/source-subscriptions/{id}/backfill',
    ...options
});

export const listIntelSourceMonitors = <ThrowOnError extends boolean = false>(options?: Options<ListIntelSourceMonitorsData, ThrowOnError>): RequestResult<ListIntelSourceMonitorsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListIntelSourceMonitorsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/source-monitors',
    ...options
});

export const updateIntelSourceMonitor = <ThrowOnError extends boolean = false>(options: Options<UpdateIntelSourceMonitorData, ThrowOnError>): RequestResult<UpdateIntelSourceMonitorResponses, UpdateIntelSourceMonitorErrors, ThrowOnError> => (options.client ?? client).patch<UpdateIntelSourceMonitorResponses, UpdateIntelSourceMonitorErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/source-monitors/{workflowInstanceId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const fetchIntelSourceMonitor = <ThrowOnError extends boolean = false>(options: Options<FetchIntelSourceMonitorData, ThrowOnError>): RequestResult<FetchIntelSourceMonitorResponses, FetchIntelSourceMonitorErrors, ThrowOnError> => (options.client ?? client).post<FetchIntelSourceMonitorResponses, FetchIntelSourceMonitorErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/source-monitors/{workflowInstanceId}/fetch',
    ...options
});

export const listIntelSourceMonitorFetchRuns = <ThrowOnError extends boolean = false>(options: Options<ListIntelSourceMonitorFetchRunsData, ThrowOnError>): RequestResult<ListIntelSourceMonitorFetchRunsResponses, ListIntelSourceMonitorFetchRunsErrors, ThrowOnError> => (options.client ?? client).get<ListIntelSourceMonitorFetchRunsResponses, ListIntelSourceMonitorFetchRunsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel/source-monitors/{workflowInstanceId}/fetch-runs',
    ...options
});

export const listDashboards = <ThrowOnError extends boolean = false>(options?: Options<ListDashboardsData, ThrowOnError>): RequestResult<ListDashboardsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListDashboardsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboards',
    ...options
});

export const createDashboard = <ThrowOnError extends boolean = false>(options?: Options<CreateDashboardData, ThrowOnError>): RequestResult<CreateDashboardResponses, CreateDashboardErrors, ThrowOnError> => (options?.client ?? client).post<CreateDashboardResponses, CreateDashboardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteDashboard = <ThrowOnError extends boolean = false>(options: Options<DeleteDashboardData, ThrowOnError>): RequestResult<DeleteDashboardResponses, DeleteDashboardErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDashboardResponses, DeleteDashboardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboards/{id}',
    ...options
});

export const getDashboard = <ThrowOnError extends boolean = false>(options: Options<GetDashboardData, ThrowOnError>): RequestResult<GetDashboardResponses, GetDashboardErrors, ThrowOnError> => (options.client ?? client).get<GetDashboardResponses, GetDashboardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboards/{id}',
    ...options
});

export const updateDashboard = <ThrowOnError extends boolean = false>(options: Options<UpdateDashboardData, ThrowOnError>): RequestResult<UpdateDashboardResponses, UpdateDashboardErrors, ThrowOnError> => (options.client ?? client).put<UpdateDashboardResponses, UpdateDashboardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboards/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const addWidget = <ThrowOnError extends boolean = false>(options: Options<AddWidgetData, ThrowOnError>): RequestResult<AddWidgetResponses, AddWidgetErrors, ThrowOnError> => (options.client ?? client).post<AddWidgetResponses, AddWidgetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboards/{id}/widgets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const reorderWidgets = <ThrowOnError extends boolean = false>(options: Options<ReorderWidgetsData, ThrowOnError>): RequestResult<ReorderWidgetsResponses, unknown, ThrowOnError> => (options.client ?? client).put<ReorderWidgetsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboards/{id}/widgets/reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const removeWidget = <ThrowOnError extends boolean = false>(options: Options<RemoveWidgetData, ThrowOnError>): RequestResult<RemoveWidgetResponses, RemoveWidgetErrors, ThrowOnError> => (options.client ?? client).delete<RemoveWidgetResponses, RemoveWidgetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboards/{id}/widgets/{widgetId}',
    ...options
});

export const updateWidget = <ThrowOnError extends boolean = false>(options: Options<UpdateWidgetData, ThrowOnError>): RequestResult<UpdateWidgetResponses, UpdateWidgetErrors, ThrowOnError> => (options.client ?? client).put<UpdateWidgetResponses, UpdateWidgetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboards/{id}/widgets/{widgetId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a dashboard from the current user's landing rail
 */
export const unpinDashboard = <ThrowOnError extends boolean = false>(options: Options<UnpinDashboardData, ThrowOnError>): RequestResult<UnpinDashboardResponses, UnpinDashboardErrors, ThrowOnError> => (options.client ?? client).delete<UnpinDashboardResponses, UnpinDashboardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboards/{id}/pin',
    ...options
});

/**
 * Pin a dashboard to the current user's landing rail
 */
export const pinDashboard = <ThrowOnError extends boolean = false>(options: Options<PinDashboardData, ThrowOnError>): RequestResult<PinDashboardResponses, PinDashboardErrors, ThrowOnError> => (options.client ?? client).post<PinDashboardResponses, PinDashboardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboards/{id}/pin',
    ...options
});

export const listMcpConnections = <ThrowOnError extends boolean = false>(options?: Options<ListMcpConnectionsData, ThrowOnError>): RequestResult<ListMcpConnectionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMcpConnectionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mcp/connections',
    ...options
});

export const createMcpConnection = <ThrowOnError extends boolean = false>(options?: Options<CreateMcpConnectionData, ThrowOnError>): RequestResult<CreateMcpConnectionResponses, CreateMcpConnectionErrors, ThrowOnError> => (options?.client ?? client).post<CreateMcpConnectionResponses, CreateMcpConnectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mcp/connections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteMcpConnection = <ThrowOnError extends boolean = false>(options: Options<DeleteMcpConnectionData, ThrowOnError>): RequestResult<DeleteMcpConnectionResponses, DeleteMcpConnectionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMcpConnectionResponses, DeleteMcpConnectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mcp/connections/{id}',
    ...options
});

export const getMcpConnection = <ThrowOnError extends boolean = false>(options: Options<GetMcpConnectionData, ThrowOnError>): RequestResult<GetMcpConnectionResponses, GetMcpConnectionErrors, ThrowOnError> => (options.client ?? client).get<GetMcpConnectionResponses, GetMcpConnectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mcp/connections/{id}',
    ...options
});

export const updateMcpConnection = <ThrowOnError extends boolean = false>(options: Options<UpdateMcpConnectionData, ThrowOnError>): RequestResult<UpdateMcpConnectionResponses, UpdateMcpConnectionErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMcpConnectionResponses, UpdateMcpConnectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mcp/connections/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const connectMcpConnection = <ThrowOnError extends boolean = false>(options: Options<ConnectMcpConnectionData, ThrowOnError>): RequestResult<ConnectMcpConnectionResponses, ConnectMcpConnectionErrors, ThrowOnError> => (options.client ?? client).post<ConnectMcpConnectionResponses, ConnectMcpConnectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mcp/connections/{id}/connect',
    ...options
});

export const disconnectMcpConnection = <ThrowOnError extends boolean = false>(options: Options<DisconnectMcpConnectionData, ThrowOnError>): RequestResult<DisconnectMcpConnectionResponses, DisconnectMcpConnectionErrors, ThrowOnError> => (options.client ?? client).post<DisconnectMcpConnectionResponses, DisconnectMcpConnectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mcp/connections/{id}/disconnect',
    ...options
});

export const listMcpConnectionTools = <ThrowOnError extends boolean = false>(options: Options<ListMcpConnectionToolsData, ThrowOnError>): RequestResult<ListMcpConnectionToolsResponses, ListMcpConnectionToolsErrors, ThrowOnError> => (options.client ?? client).get<ListMcpConnectionToolsResponses, ListMcpConnectionToolsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mcp/connections/{id}/tools',
    ...options
});

export const testMcpConnection = <ThrowOnError extends boolean = false>(options: Options<TestMcpConnectionData, ThrowOnError>): RequestResult<TestMcpConnectionResponses, TestMcpConnectionErrors, ThrowOnError> => (options.client ?? client).post<TestMcpConnectionResponses, TestMcpConnectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mcp/connections/{id}/test',
    ...options
});

export const searchDaemons = <ThrowOnError extends boolean = false>(options: Options<SearchDaemonsData, ThrowOnError>): RequestResult<SearchDaemonsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SearchDaemonsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/search',
    ...options
});

export const recommendDaemons = <ThrowOnError extends boolean = false>(options: Options<RecommendDaemonsData, ThrowOnError>): RequestResult<RecommendDaemonsResponses, unknown, ThrowOnError> => (options.client ?? client).get<RecommendDaemonsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/recommend',
    ...options
});

export const searchWorkforce = <ThrowOnError extends boolean = false>(options: Options<SearchWorkforceData, ThrowOnError>): RequestResult<SearchWorkforceResponses, unknown, ThrowOnError> => (options.client ?? client).get<SearchWorkforceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/search',
    ...options
});

export const recommendWorkforce = <ThrowOnError extends boolean = false>(options: Options<RecommendWorkforceData, ThrowOnError>): RequestResult<RecommendWorkforceResponses, unknown, ThrowOnError> => (options.client ?? client).get<RecommendWorkforceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/recommend',
    ...options
});

export const listDaemonsEventCatalog = <ThrowOnError extends boolean = false>(options?: Options<ListDaemonsEventCatalogData, ThrowOnError>): RequestResult<ListDaemonsEventCatalogResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListDaemonsEventCatalogResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/events/catalog',
    ...options
});

export const getDaemonsSummary = <ThrowOnError extends boolean = false>(options?: Options<GetDaemonsSummaryData, ThrowOnError>): RequestResult<GetDaemonsSummaryResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetDaemonsSummaryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/summary',
    ...options
});

export const listDaemonsAssignments = <ThrowOnError extends boolean = false>(options?: Options<ListDaemonsAssignmentsData, ThrowOnError>): RequestResult<ListDaemonsAssignmentsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListDaemonsAssignmentsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/assignments',
    ...options
});

export const resumeAllDaemons = <ThrowOnError extends boolean = false>(options?: Options<ResumeAllDaemonsData, ThrowOnError>): RequestResult<ResumeAllDaemonsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ResumeAllDaemonsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/resume-all',
    ...options
});

export const terminateAllDaemons = <ThrowOnError extends boolean = false>(options?: Options<TerminateAllDaemonsData, ThrowOnError>): RequestResult<TerminateAllDaemonsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<TerminateAllDaemonsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/terminate-all',
    ...options
});

export const reviewDaemonsFinding = <ThrowOnError extends boolean = false>(options: Options<ReviewDaemonsFindingData, ThrowOnError>): RequestResult<ReviewDaemonsFindingResponses, ReviewDaemonsFindingErrors, ThrowOnError> => (options.client ?? client).patch<ReviewDaemonsFindingResponses, ReviewDaemonsFindingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/findings/{id}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listDaemonPermissionGrants = <ThrowOnError extends boolean = false>(options: Options<ListDaemonPermissionGrantsData, ThrowOnError>): RequestResult<ListDaemonPermissionGrantsResponses, ListDaemonPermissionGrantsErrors, ThrowOnError> => (options.client ?? client).get<ListDaemonPermissionGrantsResponses, ListDaemonPermissionGrantsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/permission-grants',
    ...options
});

export const revokeDaemonPermissionGrant = <ThrowOnError extends boolean = false>(options: Options<RevokeDaemonPermissionGrantData, ThrowOnError>): RequestResult<RevokeDaemonPermissionGrantResponses, RevokeDaemonPermissionGrantErrors, ThrowOnError> => (options.client ?? client).post<RevokeDaemonPermissionGrantResponses, RevokeDaemonPermissionGrantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/permission-grants/{grantId}/revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const runDaemon = <ThrowOnError extends boolean = false>(options: Options<RunDaemonData, ThrowOnError>): RequestResult<RunDaemonResponses, RunDaemonErrors, ThrowOnError> => (options.client ?? client).post<RunDaemonResponses, RunDaemonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/run',
    ...options
});

export const listDaemonRuns = <ThrowOnError extends boolean = false>(options: Options<ListDaemonRunsData, ThrowOnError>): RequestResult<ListDaemonRunsResponses, ListDaemonRunsErrors, ThrowOnError> => (options.client ?? client).get<ListDaemonRunsResponses, ListDaemonRunsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/runs',
    ...options
});

export const streamDaemonRuns = <ThrowOnError extends boolean = false>(options: Options<StreamDaemonRunsData, ThrowOnError, StreamDaemonRunsResponse>): Promise<ServerSentEventsResult<StreamDaemonRunsResponses>> => (options.client ?? client).sse.get<StreamDaemonRunsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/runs/stream',
    ...options
});

export const getDaemonRun = <ThrowOnError extends boolean = false>(options: Options<GetDaemonRunData, ThrowOnError>): RequestResult<GetDaemonRunResponses, GetDaemonRunErrors, ThrowOnError> => (options.client ?? client).get<GetDaemonRunResponses, GetDaemonRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/runs/{runId}',
    ...options
});

export const listDaemonRunReports = <ThrowOnError extends boolean = false>(options: Options<ListDaemonRunReportsData, ThrowOnError>): RequestResult<ListDaemonRunReportsResponses, ListDaemonRunReportsErrors, ThrowOnError> => (options.client ?? client).get<ListDaemonRunReportsResponses, ListDaemonRunReportsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/runs/{runId}/reports',
    ...options
});

export const listDaemonRunDecisions = <ThrowOnError extends boolean = false>(options: Options<ListDaemonRunDecisionsData, ThrowOnError>): RequestResult<ListDaemonRunDecisionsResponses, ListDaemonRunDecisionsErrors, ThrowOnError> => (options.client ?? client).get<ListDaemonRunDecisionsResponses, ListDaemonRunDecisionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/runs/{runId}/decisions',
    ...options
});

export const listDaemonRunExecutionEnvelopes = <ThrowOnError extends boolean = false>(options: Options<ListDaemonRunExecutionEnvelopesData, ThrowOnError>): RequestResult<ListDaemonRunExecutionEnvelopesResponses, ListDaemonRunExecutionEnvelopesErrors, ThrowOnError> => (options.client ?? client).get<ListDaemonRunExecutionEnvelopesResponses, ListDaemonRunExecutionEnvelopesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/runs/{runId}/execution-envelopes',
    ...options
});

export const getDaemonRunAudit = <ThrowOnError extends boolean = false>(options: Options<GetDaemonRunAuditData, ThrowOnError>): RequestResult<GetDaemonRunAuditResponses, GetDaemonRunAuditErrors, ThrowOnError> => (options.client ?? client).get<GetDaemonRunAuditResponses, GetDaemonRunAuditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/runs/{runId}/audit',
    ...options
});

export const grantDaemonRunExecutionEnvelopePermission = <ThrowOnError extends boolean = false>(options: Options<GrantDaemonRunExecutionEnvelopePermissionData, ThrowOnError>): RequestResult<GrantDaemonRunExecutionEnvelopePermissionResponses, GrantDaemonRunExecutionEnvelopePermissionErrors, ThrowOnError> => (options.client ?? client).post<GrantDaemonRunExecutionEnvelopePermissionResponses, GrantDaemonRunExecutionEnvelopePermissionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/runs/{runId}/execution-envelopes/{envelopeId}/grant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listDaemonTriggers = <ThrowOnError extends boolean = false>(options: Options<ListDaemonTriggersData, ThrowOnError>): RequestResult<ListDaemonTriggersResponses, ListDaemonTriggersErrors, ThrowOnError> => (options.client ?? client).get<ListDaemonTriggersResponses, ListDaemonTriggersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/triggers',
    ...options
});

export const createDaemonTrigger = <ThrowOnError extends boolean = false>(options: Options<CreateDaemonTriggerData, ThrowOnError>): RequestResult<CreateDaemonTriggerResponses, CreateDaemonTriggerErrors, ThrowOnError> => (options.client ?? client).post<CreateDaemonTriggerResponses, CreateDaemonTriggerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/triggers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteDaemonTrigger = <ThrowOnError extends boolean = false>(options: Options<DeleteDaemonTriggerData, ThrowOnError>): RequestResult<DeleteDaemonTriggerResponses, DeleteDaemonTriggerErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDaemonTriggerResponses, DeleteDaemonTriggerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/triggers/{triggerId}',
    ...options
});

export const updateDaemonTrigger = <ThrowOnError extends boolean = false>(options: Options<UpdateDaemonTriggerData, ThrowOnError>): RequestResult<UpdateDaemonTriggerResponses, UpdateDaemonTriggerErrors, ThrowOnError> => (options.client ?? client).patch<UpdateDaemonTriggerResponses, UpdateDaemonTriggerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/triggers/{triggerId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listDaemons = <ThrowOnError extends boolean = false>(options?: Options<ListDaemonsData, ThrowOnError>): RequestResult<ListDaemonsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListDaemonsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons',
    ...options
});

export const createDaemon = <ThrowOnError extends boolean = false>(options?: Options<CreateDaemonData, ThrowOnError>): RequestResult<CreateDaemonResponses, CreateDaemonErrors, ThrowOnError> => (options?.client ?? client).post<CreateDaemonResponses, CreateDaemonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getDaemonReadiness = <ThrowOnError extends boolean = false>(options: Options<GetDaemonReadinessData, ThrowOnError>): RequestResult<GetDaemonReadinessResponses, GetDaemonReadinessErrors, ThrowOnError> => (options.client ?? client).get<GetDaemonReadinessResponses, GetDaemonReadinessErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/readiness',
    ...options
});

export const deleteDaemon = <ThrowOnError extends boolean = false>(options: Options<DeleteDaemonData, ThrowOnError>): RequestResult<DeleteDaemonResponses, DeleteDaemonErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDaemonResponses, DeleteDaemonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}',
    ...options
});

export const getDaemon = <ThrowOnError extends boolean = false>(options: Options<GetDaemonData, ThrowOnError>): RequestResult<GetDaemonResponses, GetDaemonErrors, ThrowOnError> => (options.client ?? client).get<GetDaemonResponses, GetDaemonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}',
    ...options
});

export const updateDaemon = <ThrowOnError extends boolean = false>(options: Options<UpdateDaemonData, ThrowOnError>): RequestResult<UpdateDaemonResponses, UpdateDaemonErrors, ThrowOnError> => (options.client ?? client).patch<UpdateDaemonResponses, UpdateDaemonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const enableDaemon = <ThrowOnError extends boolean = false>(options: Options<EnableDaemonData, ThrowOnError>): RequestResult<EnableDaemonResponses, EnableDaemonErrors, ThrowOnError> => (options.client ?? client).post<EnableDaemonResponses, EnableDaemonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/enable',
    ...options
});

export const disableDaemon = <ThrowOnError extends boolean = false>(options: Options<DisableDaemonData, ThrowOnError>): RequestResult<DisableDaemonResponses, DisableDaemonErrors, ThrowOnError> => (options.client ?? client).post<DisableDaemonResponses, DisableDaemonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/disable',
    ...options
});

export const resetDaemonGovernance = <ThrowOnError extends boolean = false>(options: Options<ResetDaemonGovernanceData, ThrowOnError>): RequestResult<ResetDaemonGovernanceResponses, ResetDaemonGovernanceErrors, ThrowOnError> => (options.client ?? client).post<ResetDaemonGovernanceResponses, ResetDaemonGovernanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/governance/reset',
    ...options
});

export const setDaemonRuntimePolicy = <ThrowOnError extends boolean = false>(options: Options<SetDaemonRuntimePolicyData, ThrowOnError>): RequestResult<SetDaemonRuntimePolicyResponses, SetDaemonRuntimePolicyErrors, ThrowOnError> => (options.client ?? client).put<SetDaemonRuntimePolicyResponses, SetDaemonRuntimePolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/runtime-policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listDaemonReflections = <ThrowOnError extends boolean = false>(options: Options<ListDaemonReflectionsData, ThrowOnError>): RequestResult<ListDaemonReflectionsResponses, ListDaemonReflectionsErrors, ThrowOnError> => (options.client ?? client).get<ListDaemonReflectionsResponses, ListDaemonReflectionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/reflections',
    ...options
});

export const getDaemonTrend = <ThrowOnError extends boolean = false>(options: Options<GetDaemonTrendData, ThrowOnError>): RequestResult<GetDaemonTrendResponses, GetDaemonTrendErrors, ThrowOnError> => (options.client ?? client).get<GetDaemonTrendResponses, GetDaemonTrendErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/trend',
    ...options
});

export const listDaemonFindings = <ThrowOnError extends boolean = false>(options: Options<ListDaemonFindingsData, ThrowOnError>): RequestResult<ListDaemonFindingsResponses, ListDaemonFindingsErrors, ThrowOnError> => (options.client ?? client).get<ListDaemonFindingsResponses, ListDaemonFindingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/findings',
    ...options
});

export const listDaemonWorkflows = <ThrowOnError extends boolean = false>(options: Options<ListDaemonWorkflowsData, ThrowOnError>): RequestResult<ListDaemonWorkflowsResponses, ListDaemonWorkflowsErrors, ThrowOnError> => (options.client ?? client).get<ListDaemonWorkflowsResponses, ListDaemonWorkflowsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/workflows',
    ...options
});

export const assignDaemonWorkflow = <ThrowOnError extends boolean = false>(options: Options<AssignDaemonWorkflowData, ThrowOnError>): RequestResult<AssignDaemonWorkflowResponses, AssignDaemonWorkflowErrors, ThrowOnError> => (options.client ?? client).post<AssignDaemonWorkflowResponses, AssignDaemonWorkflowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/workflows',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const removeDaemonWorkflow = <ThrowOnError extends boolean = false>(options: Options<RemoveDaemonWorkflowData, ThrowOnError>): RequestResult<RemoveDaemonWorkflowResponses, RemoveDaemonWorkflowErrors, ThrowOnError> => (options.client ?? client).delete<RemoveDaemonWorkflowResponses, RemoveDaemonWorkflowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemons/{id}/workflows/{workflowId}',
    ...options
});

export const listWorkforceEventCatalog = <ThrowOnError extends boolean = false>(options?: Options<ListWorkforceEventCatalogData, ThrowOnError>): RequestResult<ListWorkforceEventCatalogResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListWorkforceEventCatalogResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/events/catalog',
    ...options
});

export const getWorkforceSummary = <ThrowOnError extends boolean = false>(options?: Options<GetWorkforceSummaryData, ThrowOnError>): RequestResult<GetWorkforceSummaryResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetWorkforceSummaryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/summary',
    ...options
});

export const listWorkforceAssignments = <ThrowOnError extends boolean = false>(options?: Options<ListWorkforceAssignmentsData, ThrowOnError>): RequestResult<ListWorkforceAssignmentsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListWorkforceAssignmentsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/assignments',
    ...options
});

export const resumeAllEmployees = <ThrowOnError extends boolean = false>(options?: Options<ResumeAllEmployeesData, ThrowOnError>): RequestResult<ResumeAllEmployeesResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ResumeAllEmployeesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/resume-all',
    ...options
});

export const terminateAllEmployees = <ThrowOnError extends boolean = false>(options?: Options<TerminateAllEmployeesData, ThrowOnError>): RequestResult<TerminateAllEmployeesResponses, unknown, ThrowOnError> => (options?.client ?? client).post<TerminateAllEmployeesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/terminate-all',
    ...options
});

export const reviewWorkforceFinding = <ThrowOnError extends boolean = false>(options: Options<ReviewWorkforceFindingData, ThrowOnError>): RequestResult<ReviewWorkforceFindingResponses, ReviewWorkforceFindingErrors, ThrowOnError> => (options.client ?? client).patch<ReviewWorkforceFindingResponses, ReviewWorkforceFindingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/findings/{id}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listEmployeePermissionGrants = <ThrowOnError extends boolean = false>(options: Options<ListEmployeePermissionGrantsData, ThrowOnError>): RequestResult<ListEmployeePermissionGrantsResponses, ListEmployeePermissionGrantsErrors, ThrowOnError> => (options.client ?? client).get<ListEmployeePermissionGrantsResponses, ListEmployeePermissionGrantsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/permission-grants',
    ...options
});

export const revokeEmployeePermissionGrant = <ThrowOnError extends boolean = false>(options: Options<RevokeEmployeePermissionGrantData, ThrowOnError>): RequestResult<RevokeEmployeePermissionGrantResponses, RevokeEmployeePermissionGrantErrors, ThrowOnError> => (options.client ?? client).post<RevokeEmployeePermissionGrantResponses, RevokeEmployeePermissionGrantErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/permission-grants/{grantId}/revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const runEmployee = <ThrowOnError extends boolean = false>(options: Options<RunEmployeeData, ThrowOnError>): RequestResult<RunEmployeeResponses, RunEmployeeErrors, ThrowOnError> => (options.client ?? client).post<RunEmployeeResponses, RunEmployeeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/run',
    ...options
});

export const listEmployeeRuns = <ThrowOnError extends boolean = false>(options: Options<ListEmployeeRunsData, ThrowOnError>): RequestResult<ListEmployeeRunsResponses, ListEmployeeRunsErrors, ThrowOnError> => (options.client ?? client).get<ListEmployeeRunsResponses, ListEmployeeRunsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/runs',
    ...options
});

export const streamEmployeeRuns = <ThrowOnError extends boolean = false>(options: Options<StreamEmployeeRunsData, ThrowOnError, StreamEmployeeRunsResponse>): Promise<ServerSentEventsResult<StreamEmployeeRunsResponses>> => (options.client ?? client).sse.get<StreamEmployeeRunsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/runs/stream',
    ...options
});

export const getEmployeeRun = <ThrowOnError extends boolean = false>(options: Options<GetEmployeeRunData, ThrowOnError>): RequestResult<GetEmployeeRunResponses, GetEmployeeRunErrors, ThrowOnError> => (options.client ?? client).get<GetEmployeeRunResponses, GetEmployeeRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/runs/{runId}',
    ...options
});

export const listEmployeeRunReports = <ThrowOnError extends boolean = false>(options: Options<ListEmployeeRunReportsData, ThrowOnError>): RequestResult<ListEmployeeRunReportsResponses, ListEmployeeRunReportsErrors, ThrowOnError> => (options.client ?? client).get<ListEmployeeRunReportsResponses, ListEmployeeRunReportsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/runs/{runId}/reports',
    ...options
});

export const listEmployeeRunDecisions = <ThrowOnError extends boolean = false>(options: Options<ListEmployeeRunDecisionsData, ThrowOnError>): RequestResult<ListEmployeeRunDecisionsResponses, ListEmployeeRunDecisionsErrors, ThrowOnError> => (options.client ?? client).get<ListEmployeeRunDecisionsResponses, ListEmployeeRunDecisionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/runs/{runId}/decisions',
    ...options
});

export const listEmployeeRunExecutionEnvelopes = <ThrowOnError extends boolean = false>(options: Options<ListEmployeeRunExecutionEnvelopesData, ThrowOnError>): RequestResult<ListEmployeeRunExecutionEnvelopesResponses, ListEmployeeRunExecutionEnvelopesErrors, ThrowOnError> => (options.client ?? client).get<ListEmployeeRunExecutionEnvelopesResponses, ListEmployeeRunExecutionEnvelopesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/runs/{runId}/execution-envelopes',
    ...options
});

export const getEmployeeRunAudit = <ThrowOnError extends boolean = false>(options: Options<GetEmployeeRunAuditData, ThrowOnError>): RequestResult<GetEmployeeRunAuditResponses, GetEmployeeRunAuditErrors, ThrowOnError> => (options.client ?? client).get<GetEmployeeRunAuditResponses, GetEmployeeRunAuditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/runs/{runId}/audit',
    ...options
});

export const grantEmployeeRunExecutionEnvelopePermission = <ThrowOnError extends boolean = false>(options: Options<GrantEmployeeRunExecutionEnvelopePermissionData, ThrowOnError>): RequestResult<GrantEmployeeRunExecutionEnvelopePermissionResponses, GrantEmployeeRunExecutionEnvelopePermissionErrors, ThrowOnError> => (options.client ?? client).post<GrantEmployeeRunExecutionEnvelopePermissionResponses, GrantEmployeeRunExecutionEnvelopePermissionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/runs/{runId}/execution-envelopes/{envelopeId}/grant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listEmployeeTriggers = <ThrowOnError extends boolean = false>(options: Options<ListEmployeeTriggersData, ThrowOnError>): RequestResult<ListEmployeeTriggersResponses, ListEmployeeTriggersErrors, ThrowOnError> => (options.client ?? client).get<ListEmployeeTriggersResponses, ListEmployeeTriggersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/triggers',
    ...options
});

export const createEmployeeTrigger = <ThrowOnError extends boolean = false>(options: Options<CreateEmployeeTriggerData, ThrowOnError>): RequestResult<CreateEmployeeTriggerResponses, CreateEmployeeTriggerErrors, ThrowOnError> => (options.client ?? client).post<CreateEmployeeTriggerResponses, CreateEmployeeTriggerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/triggers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteEmployeeTrigger = <ThrowOnError extends boolean = false>(options: Options<DeleteEmployeeTriggerData, ThrowOnError>): RequestResult<DeleteEmployeeTriggerResponses, DeleteEmployeeTriggerErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEmployeeTriggerResponses, DeleteEmployeeTriggerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/triggers/{triggerId}',
    ...options
});

export const updateEmployeeTrigger = <ThrowOnError extends boolean = false>(options: Options<UpdateEmployeeTriggerData, ThrowOnError>): RequestResult<UpdateEmployeeTriggerResponses, UpdateEmployeeTriggerErrors, ThrowOnError> => (options.client ?? client).patch<UpdateEmployeeTriggerResponses, UpdateEmployeeTriggerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/triggers/{triggerId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listEmployees = <ThrowOnError extends boolean = false>(options?: Options<ListEmployeesData, ThrowOnError>): RequestResult<ListEmployeesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListEmployeesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees',
    ...options
});

export const createEmployee = <ThrowOnError extends boolean = false>(options?: Options<CreateEmployeeData, ThrowOnError>): RequestResult<CreateEmployeeResponses, CreateEmployeeErrors, ThrowOnError> => (options?.client ?? client).post<CreateEmployeeResponses, CreateEmployeeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getEmployeeReadiness = <ThrowOnError extends boolean = false>(options: Options<GetEmployeeReadinessData, ThrowOnError>): RequestResult<GetEmployeeReadinessResponses, GetEmployeeReadinessErrors, ThrowOnError> => (options.client ?? client).get<GetEmployeeReadinessResponses, GetEmployeeReadinessErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/readiness',
    ...options
});

export const deleteEmployee = <ThrowOnError extends boolean = false>(options: Options<DeleteEmployeeData, ThrowOnError>): RequestResult<DeleteEmployeeResponses, DeleteEmployeeErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEmployeeResponses, DeleteEmployeeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}',
    ...options
});

export const getEmployee = <ThrowOnError extends boolean = false>(options: Options<GetEmployeeData, ThrowOnError>): RequestResult<GetEmployeeResponses, GetEmployeeErrors, ThrowOnError> => (options.client ?? client).get<GetEmployeeResponses, GetEmployeeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}',
    ...options
});

export const updateEmployee = <ThrowOnError extends boolean = false>(options: Options<UpdateEmployeeData, ThrowOnError>): RequestResult<UpdateEmployeeResponses, UpdateEmployeeErrors, ThrowOnError> => (options.client ?? client).patch<UpdateEmployeeResponses, UpdateEmployeeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const enableEmployee = <ThrowOnError extends boolean = false>(options: Options<EnableEmployeeData, ThrowOnError>): RequestResult<EnableEmployeeResponses, EnableEmployeeErrors, ThrowOnError> => (options.client ?? client).post<EnableEmployeeResponses, EnableEmployeeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/enable',
    ...options
});

export const disableEmployee = <ThrowOnError extends boolean = false>(options: Options<DisableEmployeeData, ThrowOnError>): RequestResult<DisableEmployeeResponses, DisableEmployeeErrors, ThrowOnError> => (options.client ?? client).post<DisableEmployeeResponses, DisableEmployeeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/disable',
    ...options
});

export const resetEmployeeGovernance = <ThrowOnError extends boolean = false>(options: Options<ResetEmployeeGovernanceData, ThrowOnError>): RequestResult<ResetEmployeeGovernanceResponses, ResetEmployeeGovernanceErrors, ThrowOnError> => (options.client ?? client).post<ResetEmployeeGovernanceResponses, ResetEmployeeGovernanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/governance/reset',
    ...options
});

export const setEmployeeRuntimePolicy = <ThrowOnError extends boolean = false>(options: Options<SetEmployeeRuntimePolicyData, ThrowOnError>): RequestResult<SetEmployeeRuntimePolicyResponses, SetEmployeeRuntimePolicyErrors, ThrowOnError> => (options.client ?? client).put<SetEmployeeRuntimePolicyResponses, SetEmployeeRuntimePolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/runtime-policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listEmployeeReflections = <ThrowOnError extends boolean = false>(options: Options<ListEmployeeReflectionsData, ThrowOnError>): RequestResult<ListEmployeeReflectionsResponses, ListEmployeeReflectionsErrors, ThrowOnError> => (options.client ?? client).get<ListEmployeeReflectionsResponses, ListEmployeeReflectionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/reflections',
    ...options
});

export const getEmployeeTrend = <ThrowOnError extends boolean = false>(options: Options<GetEmployeeTrendData, ThrowOnError>): RequestResult<GetEmployeeTrendResponses, GetEmployeeTrendErrors, ThrowOnError> => (options.client ?? client).get<GetEmployeeTrendResponses, GetEmployeeTrendErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/trend',
    ...options
});

export const listEmployeeFindings = <ThrowOnError extends boolean = false>(options: Options<ListEmployeeFindingsData, ThrowOnError>): RequestResult<ListEmployeeFindingsResponses, ListEmployeeFindingsErrors, ThrowOnError> => (options.client ?? client).get<ListEmployeeFindingsResponses, ListEmployeeFindingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/findings',
    ...options
});

export const listEmployeeWorkflows = <ThrowOnError extends boolean = false>(options: Options<ListEmployeeWorkflowsData, ThrowOnError>): RequestResult<ListEmployeeWorkflowsResponses, ListEmployeeWorkflowsErrors, ThrowOnError> => (options.client ?? client).get<ListEmployeeWorkflowsResponses, ListEmployeeWorkflowsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/workflows',
    ...options
});

export const assignEmployeeWorkflow = <ThrowOnError extends boolean = false>(options: Options<AssignEmployeeWorkflowData, ThrowOnError>): RequestResult<AssignEmployeeWorkflowResponses, AssignEmployeeWorkflowErrors, ThrowOnError> => (options.client ?? client).post<AssignEmployeeWorkflowResponses, AssignEmployeeWorkflowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/workflows',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const removeEmployeeWorkflow = <ThrowOnError extends boolean = false>(options: Options<RemoveEmployeeWorkflowData, ThrowOnError>): RequestResult<RemoveEmployeeWorkflowResponses, RemoveEmployeeWorkflowErrors, ThrowOnError> => (options.client ?? client).delete<RemoveEmployeeWorkflowResponses, RemoveEmployeeWorkflowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workforce/employees/{id}/workflows/{workflowId}',
    ...options
});

export const setDecisionRuntimePolicy = <ThrowOnError extends boolean = false>(options: Options<SetDecisionRuntimePolicyData, ThrowOnError>): RequestResult<SetDecisionRuntimePolicyResponses, SetDecisionRuntimePolicyErrors, ThrowOnError> => (options.client ?? client).put<SetDecisionRuntimePolicyResponses, SetDecisionRuntimePolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/daemon-decisions/{id}/runtime-policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a decision, with who raised it and whether the viewer may decide it
 */
export const getDaemonDecision = <ThrowOnError extends boolean = false>(options: Options<GetDaemonDecisionData, ThrowOnError>): RequestResult<GetDaemonDecisionResponses, GetDaemonDecisionErrors, ThrowOnError> => (options.client ?? client).get<GetDaemonDecisionResponses, GetDaemonDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/daemon-decisions/{id}',
    ...options
});

/**
 * Approve a pending daemon decision
 */
export const approveDaemonDecision = <ThrowOnError extends boolean = false>(options: Options<ApproveDaemonDecisionData, ThrowOnError>): RequestResult<ApproveDaemonDecisionResponses, ApproveDaemonDecisionErrors, ThrowOnError> => (options.client ?? client).post<ApproveDaemonDecisionResponses, ApproveDaemonDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/daemon-decisions/{id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject a pending daemon decision
 */
export const rejectDaemonDecision = <ThrowOnError extends boolean = false>(options: Options<RejectDaemonDecisionData, ThrowOnError>): RequestResult<RejectDaemonDecisionResponses, RejectDaemonDecisionErrors, ThrowOnError> => (options.client ?? client).post<RejectDaemonDecisionResponses, RejectDaemonDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/daemon-decisions/{id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Defer a pending daemon decision
 */
export const deferDaemonDecision = <ThrowOnError extends boolean = false>(options: Options<DeferDaemonDecisionData, ThrowOnError>): RequestResult<DeferDaemonDecisionResponses, DeferDaemonDecisionErrors, ThrowOnError> => (options.client ?? client).post<DeferDaemonDecisionResponses, DeferDaemonDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/daemon-decisions/{id}/defer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List self-improvement proposals for the org
 */
export const listImprovementProposals = <ThrowOnError extends boolean = false>(options?: Options<ListImprovementProposalsData, ThrowOnError>): RequestResult<ListImprovementProposalsResponses, ListImprovementProposalsErrors, ThrowOnError> => (options?.client ?? client).get<ListImprovementProposalsResponses, ListImprovementProposalsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/improvements/proposals',
    ...options
});

/**
 * Get a self-improvement proposal (full detail)
 */
export const getImprovementProposal = <ThrowOnError extends boolean = false>(options: Options<GetImprovementProposalData, ThrowOnError>): RequestResult<GetImprovementProposalResponses, GetImprovementProposalErrors, ThrowOnError> => (options.client ?? client).get<GetImprovementProposalResponses, GetImprovementProposalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/improvements/proposals/{id}',
    ...options
});

/**
 * Approve or reject a self-improvement proposal at the human gate
 */
export const decideImprovementProposal = <ThrowOnError extends boolean = false>(options: Options<DecideImprovementProposalData, ThrowOnError>): RequestResult<DecideImprovementProposalResponses, DecideImprovementProposalErrors, ThrowOnError> => (options.client ?? client).post<DecideImprovementProposalResponses, DecideImprovementProposalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/improvements/proposals/{id}/decision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve or reject the early design-review checkpoint of a high-risk specced proposal
 */
export const decideImprovementProposalDesign = <ThrowOnError extends boolean = false>(options: Options<DecideImprovementProposalDesignData, ThrowOnError>): RequestResult<DecideImprovementProposalDesignResponses, DecideImprovementProposalDesignErrors, ThrowOnError> => (options.client ?? client).post<DecideImprovementProposalDesignResponses, DecideImprovementProposalDesignErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/improvements/proposals/{id}/design-decision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Self-improvement pipeline OBS metrics (flow/quality/learning/cost/human-load)
 */
export const getImprovementMetrics = <ThrowOnError extends boolean = false>(options?: Options<GetImprovementMetricsData, ThrowOnError>): RequestResult<GetImprovementMetricsResponses, GetImprovementMetricsErrors, ThrowOnError> => (options?.client ?? client).get<GetImprovementMetricsResponses, GetImprovementMetricsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/improvements/metrics',
    ...options
});

/**
 * Per-lane autonomy tier + expand-eligibility (T0/T1/T2)
 */
export const getImprovementTierStatus = <ThrowOnError extends boolean = false>(options?: Options<GetImprovementTierStatusData, ThrowOnError>): RequestResult<GetImprovementTierStatusResponses, GetImprovementTierStatusErrors, ThrowOnError> => (options?.client ?? client).get<GetImprovementTierStatusResponses, GetImprovementTierStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/improvements/tier',
    ...options
});

/**
 * Apply a human autonomy-tier expansion (superadmin, re-verified at apply-time)
 */
export const expandImprovementTier = <ThrowOnError extends boolean = false>(options?: Options<ExpandImprovementTierData, ThrowOnError>): RequestResult<ExpandImprovementTierResponses, ExpandImprovementTierErrors, ThrowOnError> => (options?.client ?? client).post<ExpandImprovementTierResponses, ExpandImprovementTierErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/improvements/tier/expand',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List workflow human-gate decisions for the org
 */
export const listWorkflowGates = <ThrowOnError extends boolean = false>(options?: Options<ListWorkflowGatesData, ThrowOnError>): RequestResult<ListWorkflowGatesResponses, ListWorkflowGatesErrors, ThrowOnError> => (options?.client ?? client).get<ListWorkflowGatesResponses, ListWorkflowGatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflow-gates',
    ...options
});

/**
 * Get a workflow gate decision by id
 */
export const getWorkflowGate = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowGateData, ThrowOnError>): RequestResult<GetWorkflowGateResponses, GetWorkflowGateErrors, ThrowOnError> => (options.client ?? client).get<GetWorkflowGateResponses, GetWorkflowGateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflow-gates/{id}',
    ...options
});

/**
 * Approve a pending workflow gate (resumes the paused run)
 */
export const approveWorkflowGate = <ThrowOnError extends boolean = false>(options: Options<ApproveWorkflowGateData, ThrowOnError>): RequestResult<ApproveWorkflowGateResponses, ApproveWorkflowGateErrors, ThrowOnError> => (options.client ?? client).post<ApproveWorkflowGateResponses, ApproveWorkflowGateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflow-gates/{id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reject a pending workflow gate (finalizes the run as failed)
 */
export const rejectWorkflowGate = <ThrowOnError extends boolean = false>(options: Options<RejectWorkflowGateData, ThrowOnError>): RequestResult<RejectWorkflowGateResponses, RejectWorkflowGateErrors, ThrowOnError> => (options.client ?? client).post<RejectWorkflowGateResponses, RejectWorkflowGateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflow-gates/{id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listMarketplaceListings = <ThrowOnError extends boolean = false>(options?: Options<ListMarketplaceListingsData, ThrowOnError>): RequestResult<ListMarketplaceListingsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMarketplaceListingsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/listings',
    ...options
});

export const publishMarketplaceListing = <ThrowOnError extends boolean = false>(options?: Options<PublishMarketplaceListingData, ThrowOnError>): RequestResult<PublishMarketplaceListingResponses, PublishMarketplaceListingErrors, ThrowOnError> => (options?.client ?? client).post<PublishMarketplaceListingResponses, PublishMarketplaceListingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/listings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteMarketplaceListing = <ThrowOnError extends boolean = false>(options?: Options<DeleteMarketplaceListingData, ThrowOnError>): RequestResult<DeleteMarketplaceListingResponses, DeleteMarketplaceListingErrors, ThrowOnError> => (options?.client ?? client).delete<DeleteMarketplaceListingResponses, DeleteMarketplaceListingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/listings/{id}',
    ...options
});

export const installMarketplaceListing = <ThrowOnError extends boolean = false>(options?: Options<InstallMarketplaceListingData, ThrowOnError>): RequestResult<InstallMarketplaceListingResponses, InstallMarketplaceListingErrors, ThrowOnError> => (options?.client ?? client).post<InstallMarketplaceListingResponses, InstallMarketplaceListingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/listings/{id}/install',
    ...options
});

export const forkMarketplaceListing = <ThrowOnError extends boolean = false>(options?: Options<ForkMarketplaceListingData, ThrowOnError>): RequestResult<ForkMarketplaceListingResponses, ForkMarketplaceListingErrors, ThrowOnError> => (options?.client ?? client).post<ForkMarketplaceListingResponses, ForkMarketplaceListingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/listings/{id}/fork',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listMarketplaceInstallations = <ThrowOnError extends boolean = false>(options?: Options<ListMarketplaceInstallationsData, ThrowOnError>): RequestResult<ListMarketplaceInstallationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMarketplaceInstallationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/installations',
    ...options
});

export const listMarketplaceUpdates = <ThrowOnError extends boolean = false>(options?: Options<ListMarketplaceUpdatesData, ThrowOnError>): RequestResult<ListMarketplaceUpdatesResponses, ListMarketplaceUpdatesErrors, ThrowOnError> => (options?.client ?? client).get<ListMarketplaceUpdatesResponses, ListMarketplaceUpdatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/updates',
    ...options
});

export const applyMarketplaceUpdates = <ThrowOnError extends boolean = false>(options?: Options<ApplyMarketplaceUpdatesData, ThrowOnError>): RequestResult<ApplyMarketplaceUpdatesResponses, ApplyMarketplaceUpdatesErrors, ThrowOnError> => (options?.client ?? client).post<ApplyMarketplaceUpdatesResponses, ApplyMarketplaceUpdatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/updates/apply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getMarketplaceEntityVersions = <ThrowOnError extends boolean = false>(options: Options<GetMarketplaceEntityVersionsData, ThrowOnError>): RequestResult<GetMarketplaceEntityVersionsResponses, GetMarketplaceEntityVersionsErrors, ThrowOnError> => (options.client ?? client).get<GetMarketplaceEntityVersionsResponses, GetMarketplaceEntityVersionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/entities/{entityId}/versions',
    ...options
});

export const updateMarketplaceEntity = <ThrowOnError extends boolean = false>(options: Options<UpdateMarketplaceEntityData, ThrowOnError>): RequestResult<UpdateMarketplaceEntityResponses, UpdateMarketplaceEntityErrors, ThrowOnError> => (options.client ?? client).post<UpdateMarketplaceEntityResponses, UpdateMarketplaceEntityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/entities/{entityId}/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listMarketplaceNeedsSetup = <ThrowOnError extends boolean = false>(options?: Options<ListMarketplaceNeedsSetupData, ThrowOnError>): RequestResult<ListMarketplaceNeedsSetupResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMarketplaceNeedsSetupResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/needs-setup',
    ...options
});

export const unbindMarketplaceEntityConnection = <ThrowOnError extends boolean = false>(options?: Options<UnbindMarketplaceEntityConnectionData, ThrowOnError>): RequestResult<UnbindMarketplaceEntityConnectionResponses, UnbindMarketplaceEntityConnectionErrors, ThrowOnError> => (options?.client ?? client).delete<UnbindMarketplaceEntityConnectionResponses, UnbindMarketplaceEntityConnectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/entities/{entityId}/connection',
    ...options
});

export const bindMarketplaceEntityConnection = <ThrowOnError extends boolean = false>(options?: Options<BindMarketplaceEntityConnectionData, ThrowOnError>): RequestResult<BindMarketplaceEntityConnectionResponses, BindMarketplaceEntityConnectionErrors, ThrowOnError> => (options?.client ?? client).post<BindMarketplaceEntityConnectionResponses, BindMarketplaceEntityConnectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/entities/{entityId}/connection',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getMarketplaceBundle = <ThrowOnError extends boolean = false>(options: Options<GetMarketplaceBundleData, ThrowOnError>): RequestResult<GetMarketplaceBundleResponses, GetMarketplaceBundleErrors, ThrowOnError> => (options.client ?? client).get<GetMarketplaceBundleResponses, GetMarketplaceBundleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/bundles/{id}',
    ...options
});

export const createMarketplaceBundle = <ThrowOnError extends boolean = false>(options?: Options<CreateMarketplaceBundleData, ThrowOnError>): RequestResult<CreateMarketplaceBundleResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CreateMarketplaceBundleResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/bundles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const addMarketplaceBundleEntity = <ThrowOnError extends boolean = false>(options?: Options<AddMarketplaceBundleEntityData, ThrowOnError>): RequestResult<AddMarketplaceBundleEntityResponses, AddMarketplaceBundleEntityErrors, ThrowOnError> => (options?.client ?? client).post<AddMarketplaceBundleEntityResponses, AddMarketplaceBundleEntityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/bundles/{id}/entities',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const removeMarketplaceBundleEntity = <ThrowOnError extends boolean = false>(options?: Options<RemoveMarketplaceBundleEntityData, ThrowOnError>): RequestResult<RemoveMarketplaceBundleEntityResponses, RemoveMarketplaceBundleEntityErrors, ThrowOnError> => (options?.client ?? client).delete<RemoveMarketplaceBundleEntityResponses, RemoveMarketplaceBundleEntityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/marketplace/bundles/{id}/entities/{entityId}',
    ...options
});

export const listEntityVersions = <ThrowOnError extends boolean = false>(options: Options<ListEntityVersionsData, ThrowOnError>): RequestResult<ListEntityVersionsResponses, ListEntityVersionsErrors, ThrowOnError> => (options.client ?? client).get<ListEntityVersionsResponses, ListEntityVersionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/entities/{entityId}/versions',
    ...options
});

export const createEntityVersionDraft = <ThrowOnError extends boolean = false>(options: Options<CreateEntityVersionDraftData, ThrowOnError>): RequestResult<CreateEntityVersionDraftResponses, CreateEntityVersionDraftErrors, ThrowOnError> => (options.client ?? client).post<CreateEntityVersionDraftResponses, CreateEntityVersionDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/entities/{entityId}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const activateEntityVersion = <ThrowOnError extends boolean = false>(options: Options<ActivateEntityVersionData, ThrowOnError>): RequestResult<ActivateEntityVersionResponses, ActivateEntityVersionErrors, ThrowOnError> => (options.client ?? client).post<ActivateEntityVersionResponses, ActivateEntityVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/entities/{entityId}/versions/{versionId}/activate',
    ...options
});

export const getMlHealth = <ThrowOnError extends boolean = false>(options?: Options<GetMlHealthData, ThrowOnError>): RequestResult<GetMlHealthResponses, GetMlHealthErrors, ThrowOnError> => (options?.client ?? client).get<GetMlHealthResponses, GetMlHealthErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ml/health',
    ...options
});

export const getMlRegime = <ThrowOnError extends boolean = false>(options?: Options<GetMlRegimeData, ThrowOnError>): RequestResult<GetMlRegimeResponses, GetMlRegimeErrors, ThrowOnError> => (options?.client ?? client).get<GetMlRegimeResponses, GetMlRegimeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ml/regime',
    ...options
});

export const getMlStrategyScores = <ThrowOnError extends boolean = false>(options?: Options<GetMlStrategyScoresData, ThrowOnError>): RequestResult<GetMlStrategyScoresResponses, GetMlStrategyScoresErrors, ThrowOnError> => (options?.client ?? client).get<GetMlStrategyScoresResponses, GetMlStrategyScoresErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ml/strategy-scores',
    ...options
});

export const createWorkerRun = <ThrowOnError extends boolean = false>(options?: Options<CreateWorkerRunData, ThrowOnError>): RequestResult<CreateWorkerRunResponses, CreateWorkerRunErrors, ThrowOnError> => (options?.client ?? client).post<CreateWorkerRunResponses, CreateWorkerRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/worker/v1/runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const cancelWorkerRun = <ThrowOnError extends boolean = false>(options: Options<CancelWorkerRunData, ThrowOnError>): RequestResult<CancelWorkerRunResponses, CancelWorkerRunErrors, ThrowOnError> => (options.client ?? client).delete<CancelWorkerRunResponses, CancelWorkerRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/worker/v1/runs/{runId}',
    ...options
});

export const getWorkerRun = <ThrowOnError extends boolean = false>(options: Options<GetWorkerRunData, ThrowOnError>): RequestResult<GetWorkerRunResponses, GetWorkerRunErrors, ThrowOnError> => (options.client ?? client).get<GetWorkerRunResponses, GetWorkerRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/worker/v1/runs/{runId}',
    ...options
});

export const followUpWorkerRun = <ThrowOnError extends boolean = false>(options: Options<FollowUpWorkerRunData, ThrowOnError>): RequestResult<FollowUpWorkerRunResponses, FollowUpWorkerRunErrors, ThrowOnError> => (options.client ?? client).post<FollowUpWorkerRunResponses, FollowUpWorkerRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/worker/v1/runs/{runId}/follow-up',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const callPlatformMcp = <ThrowOnError extends boolean = false>(options?: Options<CallPlatformMcpData, ThrowOnError>): RequestResult<CallPlatformMcpResponses, CallPlatformMcpErrors, ThrowOnError> => (options?.client ?? client).post<CallPlatformMcpResponses, CallPlatformMcpErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/mcp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listApiKeys = <ThrowOnError extends boolean = false>(options?: Options<ListApiKeysData, ThrowOnError>): RequestResult<ListApiKeysResponses, ListApiKeysErrors, ThrowOnError> => (options?.client ?? client).get<ListApiKeysResponses, ListApiKeysErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/api-keys',
    ...options
});

export const createApiKey = <ThrowOnError extends boolean = false>(options?: Options<CreateApiKeyData, ThrowOnError>): RequestResult<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError> => (options?.client ?? client).post<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/api-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listApiKeyGrantablePermissions = <ThrowOnError extends boolean = false>(options?: Options<ListApiKeyGrantablePermissionsData, ThrowOnError>): RequestResult<ListApiKeyGrantablePermissionsResponses, ListApiKeyGrantablePermissionsErrors, ThrowOnError> => (options?.client ?? client).get<ListApiKeyGrantablePermissionsResponses, ListApiKeyGrantablePermissionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/api-keys/grantable-permissions',
    ...options
});

export const getApiKey = <ThrowOnError extends boolean = false>(options: Options<GetApiKeyData, ThrowOnError>): RequestResult<GetApiKeyResponses, GetApiKeyErrors, ThrowOnError> => (options.client ?? client).get<GetApiKeyResponses, GetApiKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/api-keys/{id}',
    ...options
});

export const updateApiKey = <ThrowOnError extends boolean = false>(options: Options<UpdateApiKeyData, ThrowOnError>): RequestResult<UpdateApiKeyResponses, UpdateApiKeyErrors, ThrowOnError> => (options.client ?? client).patch<UpdateApiKeyResponses, UpdateApiKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/api-keys/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const revokeApiKey = <ThrowOnError extends boolean = false>(options: Options<RevokeApiKeyData, ThrowOnError>): RequestResult<RevokeApiKeyResponses, RevokeApiKeyErrors, ThrowOnError> => (options.client ?? client).post<RevokeApiKeyResponses, RevokeApiKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/api-keys/{id}/revoke',
    ...options
});

export const rotateApiKey = <ThrowOnError extends boolean = false>(options: Options<RotateApiKeyData, ThrowOnError>): RequestResult<RotateApiKeyResponses, RotateApiKeyErrors, ThrowOnError> => (options.client ?? client).post<RotateApiKeyResponses, RotateApiKeyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/api-keys/{id}/rotate',
    ...options
});

export const listJourneys = <ThrowOnError extends boolean = false>(options?: Options<ListJourneysData, ThrowOnError>): RequestResult<ListJourneysResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListJourneysResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/journeys',
    ...options
});

export const listJourneyEvents = <ThrowOnError extends boolean = false>(options: Options<ListJourneyEventsData, ThrowOnError>): RequestResult<ListJourneyEventsResponses, ListJourneyEventsErrors, ThrowOnError> => (options.client ?? client).get<ListJourneyEventsResponses, ListJourneyEventsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/journeys/{journeyId}/events',
    ...options
});

export const listJourneyRawEvents = <ThrowOnError extends boolean = false>(options: Options<ListJourneyRawEventsData, ThrowOnError>): RequestResult<ListJourneyRawEventsResponses, ListJourneyRawEventsErrors, ThrowOnError> => (options.client ?? client).get<ListJourneyRawEventsResponses, ListJourneyRawEventsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/journeys/{journeyId}/events/raw',
    ...options
});

export const listDepartments = <ThrowOnError extends boolean = false>(options?: Options<ListDepartmentsData, ThrowOnError>): RequestResult<ListDepartmentsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListDepartmentsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/departments',
    ...options
});

/**
 * List modules enabled for the current user's organization
 */
export const listMyModules = <ThrowOnError extends boolean = false>(options?: Options<ListMyModulesData, ThrowOnError>): RequestResult<ListMyModulesResponses, ListMyModulesErrors, ThrowOnError> => (options?.client ?? client).get<ListMyModulesResponses, ListMyModulesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me/modules',
    ...options
});

/**
 * Items waiting on the current user (conversations + reviewable decisions)
 */
export const getWaitingOnMe = <ThrowOnError extends boolean = false>(options?: Options<GetWaitingOnMeData, ThrowOnError>): RequestResult<GetWaitingOnMeResponses, GetWaitingOnMeErrors, ThrowOnError> => (options?.client ?? client).get<GetWaitingOnMeResponses, GetWaitingOnMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me/waiting-on-me',
    ...options
});

export const listConversationGroups = <ThrowOnError extends boolean = false>(options?: Options<ListConversationGroupsData, ThrowOnError>): RequestResult<ListConversationGroupsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListConversationGroupsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/groups',
    ...options
});

export const createConversationGroup = <ThrowOnError extends boolean = false>(options?: Options<CreateConversationGroupData, ThrowOnError>): RequestResult<CreateConversationGroupResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CreateConversationGroupResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteConversationGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteConversationGroupData, ThrowOnError>): RequestResult<DeleteConversationGroupResponses, DeleteConversationGroupErrors, ThrowOnError> => (options.client ?? client).delete<DeleteConversationGroupResponses, DeleteConversationGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/groups/{id}',
    ...options
});

export const listConversations = <ThrowOnError extends boolean = false>(options?: Options<ListConversationsData, ThrowOnError>): RequestResult<ListConversationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListConversationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations',
    ...options
});

export const createConversation = <ThrowOnError extends boolean = false>(options?: Options<CreateConversationData, ThrowOnError>): RequestResult<CreateConversationResponses, CreateConversationErrors, ThrowOnError> => (options?.client ?? client).post<CreateConversationResponses, CreateConversationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const startConversationFromMessage = <ThrowOnError extends boolean = false>(options?: Options<StartConversationFromMessageData, ThrowOnError>): RequestResult<StartConversationFromMessageResponses, StartConversationFromMessageErrors, ThrowOnError> => (options?.client ?? client).post<StartConversationFromMessageResponses, StartConversationFromMessageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteConversation = <ThrowOnError extends boolean = false>(options: Options<DeleteConversationData, ThrowOnError>): RequestResult<DeleteConversationResponses, DeleteConversationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteConversationResponses, DeleteConversationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}',
    ...options
});

export const getConversation = <ThrowOnError extends boolean = false>(options: Options<GetConversationData, ThrowOnError>): RequestResult<GetConversationResponses, GetConversationErrors, ThrowOnError> => (options.client ?? client).get<GetConversationResponses, GetConversationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}',
    ...options
});

export const updateConversation = <ThrowOnError extends boolean = false>(options: Options<UpdateConversationData, ThrowOnError>): RequestResult<UpdateConversationResponses, UpdateConversationErrors, ThrowOnError> => (options.client ?? client).patch<UpdateConversationResponses, UpdateConversationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listConversationMembers = <ThrowOnError extends boolean = false>(options: Options<ListConversationMembersData, ThrowOnError>): RequestResult<ListConversationMembersResponses, ListConversationMembersErrors, ThrowOnError> => (options.client ?? client).get<ListConversationMembersResponses, ListConversationMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/members',
    ...options
});

export const inviteToConversation = <ThrowOnError extends boolean = false>(options: Options<InviteToConversationData, ThrowOnError>): RequestResult<InviteToConversationResponses, InviteToConversationErrors, ThrowOnError> => (options.client ?? client).post<InviteToConversationResponses, InviteToConversationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const removeConversationMember = <ThrowOnError extends boolean = false>(options: Options<RemoveConversationMemberData, ThrowOnError>): RequestResult<RemoveConversationMemberResponses, RemoveConversationMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveConversationMemberResponses, RemoveConversationMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/members/{memberId}',
    ...options
});

export const setConversationLead = <ThrowOnError extends boolean = false>(options: Options<SetConversationLeadData, ThrowOnError>): RequestResult<SetConversationLeadResponses, SetConversationLeadErrors, ThrowOnError> => (options.client ?? client).post<SetConversationLeadResponses, SetConversationLeadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/members/{memberId}/lead',
    ...options
});

export const listConversationEntities = <ThrowOnError extends boolean = false>(options: Options<ListConversationEntitiesData, ThrowOnError>): RequestResult<ListConversationEntitiesResponses, ListConversationEntitiesErrors, ThrowOnError> => (options.client ?? client).get<ListConversationEntitiesResponses, ListConversationEntitiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/entities',
    ...options
});

export const listConversationAttachments = <ThrowOnError extends boolean = false>(options: Options<ListConversationAttachmentsData, ThrowOnError>): RequestResult<ListConversationAttachmentsResponses, ListConversationAttachmentsErrors, ThrowOnError> => (options.client ?? client).get<ListConversationAttachmentsResponses, ListConversationAttachmentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/attachments',
    ...options
});

export const attachToConversation = <ThrowOnError extends boolean = false>(options: Options<AttachToConversationData, ThrowOnError>): RequestResult<AttachToConversationResponses, AttachToConversationErrors, ThrowOnError> => (options.client ?? client).post<AttachToConversationResponses, AttachToConversationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/attachments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const detachFromConversation = <ThrowOnError extends boolean = false>(options: Options<DetachFromConversationData, ThrowOnError>): RequestResult<DetachFromConversationResponses, DetachFromConversationErrors, ThrowOnError> => (options.client ?? client).delete<DetachFromConversationResponses, DetachFromConversationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/attachments/{attachmentId}',
    ...options
});

export const listConversationIntents = <ThrowOnError extends boolean = false>(options: Options<ListConversationIntentsData, ThrowOnError>): RequestResult<ListConversationIntentsResponses, ListConversationIntentsErrors, ThrowOnError> => (options.client ?? client).get<ListConversationIntentsResponses, ListConversationIntentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/intents',
    ...options
});

export const disambiguateConversationIntent = <ThrowOnError extends boolean = false>(options: Options<DisambiguateConversationIntentData, ThrowOnError>): RequestResult<DisambiguateConversationIntentResponses, DisambiguateConversationIntentErrors, ThrowOnError> => (options.client ?? client).post<DisambiguateConversationIntentResponses, DisambiguateConversationIntentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/intents/{decision_id}/disambiguate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const enableConversationIntent = <ThrowOnError extends boolean = false>(options: Options<EnableConversationIntentData, ThrowOnError>): RequestResult<EnableConversationIntentResponses, EnableConversationIntentErrors, ThrowOnError> => (options.client ?? client).delete<EnableConversationIntentResponses, EnableConversationIntentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/intents/disable',
    ...options
});

export const disableConversationIntent = <ThrowOnError extends boolean = false>(options: Options<DisableConversationIntentData, ThrowOnError>): RequestResult<DisableConversationIntentResponses, DisableConversationIntentErrors, ThrowOnError> => (options.client ?? client).post<DisableConversationIntentResponses, DisableConversationIntentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/intents/disable',
    ...options
});

export const getConversationMessageById = <ThrowOnError extends boolean = false>(options: Options<GetConversationMessageByIdData, ThrowOnError>): RequestResult<GetConversationMessageByIdResponses, GetConversationMessageByIdErrors, ThrowOnError> => (options.client ?? client).get<GetConversationMessageByIdResponses, GetConversationMessageByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/messages/{messageId}',
    ...options
});

export const listConversationMessages = <ThrowOnError extends boolean = false>(options: Options<ListConversationMessagesData, ThrowOnError>): RequestResult<ListConversationMessagesResponses, ListConversationMessagesErrors, ThrowOnError> => (options.client ?? client).get<ListConversationMessagesResponses, ListConversationMessagesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/messages',
    ...options
});

export const replyToConversation = <ThrowOnError extends boolean = false>(options: Options<ReplyToConversationData, ThrowOnError>): RequestResult<ReplyToConversationResponses, ReplyToConversationErrors, ThrowOnError> => (options.client ?? client).post<ReplyToConversationResponses, ReplyToConversationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const submitConversationInteraction = <ThrowOnError extends boolean = false>(options: Options<SubmitConversationInteractionData, ThrowOnError>): RequestResult<SubmitConversationInteractionResponses, SubmitConversationInteractionErrors, ThrowOnError> => (options.client ?? client).post<SubmitConversationInteractionResponses, SubmitConversationInteractionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/interactions/{interactionId}/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const closeContextPanel = <ThrowOnError extends boolean = false>(options: Options<CloseContextPanelData, ThrowOnError>): RequestResult<CloseContextPanelResponses, CloseContextPanelErrors, ThrowOnError> => (options.client ?? client).post<CloseContextPanelResponses, CloseContextPanelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/close-panel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const subscribeConversationEvents = <ThrowOnError extends boolean = false>(options: Options<SubscribeConversationEventsData, ThrowOnError, SubscribeConversationEventsResponse>): Promise<ServerSentEventsResult<SubscribeConversationEventsResponses>> => (options.client ?? client).sse.get<SubscribeConversationEventsResponses, SubscribeConversationEventsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/events',
    ...options
});

export const setConversationTyping = <ThrowOnError extends boolean = false>(options: Options<SetConversationTypingData, ThrowOnError>): RequestResult<SetConversationTypingResponses, SetConversationTypingErrors, ThrowOnError> => (options.client ?? client).post<SetConversationTypingResponses, SetConversationTypingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/events/typing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const setConversationRuntimePolicy = <ThrowOnError extends boolean = false>(options: Options<SetConversationRuntimePolicyData, ThrowOnError>): RequestResult<SetConversationRuntimePolicyResponses, SetConversationRuntimePolicyErrors, ThrowOnError> => (options.client ?? client).put<SetConversationRuntimePolicyResponses, SetConversationRuntimePolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/runtime-policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const patchConversationSettings = <ThrowOnError extends boolean = false>(options: Options<PatchConversationSettingsData, ThrowOnError>): RequestResult<PatchConversationSettingsResponses, PatchConversationSettingsErrors, ThrowOnError> => (options.client ?? client).patch<PatchConversationSettingsResponses, PatchConversationSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getConversationContext = <ThrowOnError extends boolean = false>(options: Options<GetConversationContextData, ThrowOnError>): RequestResult<GetConversationContextResponses, GetConversationContextErrors, ThrowOnError> => (options.client ?? client).get<GetConversationContextResponses, GetConversationContextErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/context',
    ...options
});

export const listConversationArtifacts = <ThrowOnError extends boolean = false>(options: Options<ListConversationArtifactsData, ThrowOnError>): RequestResult<ListConversationArtifactsResponses, ListConversationArtifactsErrors, ThrowOnError> => (options.client ?? client).get<ListConversationArtifactsResponses, ListConversationArtifactsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/conversations/{id}/artifacts',
    ...options
});

export const presignUpload = <ThrowOnError extends boolean = false>(options?: Options<PresignUploadData, ThrowOnError>): RequestResult<PresignUploadResponses, PresignUploadErrors, ThrowOnError> => (options?.client ?? client).post<PresignUploadResponses, PresignUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/uploads/presign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const finalizeUpload = <ThrowOnError extends boolean = false>(options: Options<FinalizeUploadData, ThrowOnError>): RequestResult<FinalizeUploadResponses, FinalizeUploadErrors, ThrowOnError> => (options.client ?? client).post<FinalizeUploadResponses, FinalizeUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/uploads/{id}/finalize',
    ...options
});

export const getUploadContent = <ThrowOnError extends boolean = false>(options: Options<GetUploadContentData, ThrowOnError>): RequestResult<GetUploadContentResponses, GetUploadContentErrors, ThrowOnError> => (options.client ?? client).get<GetUploadContentResponses, GetUploadContentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/uploads/{id}/content',
    ...options
});

export const deleteUpload = <ThrowOnError extends boolean = false>(options: Options<DeleteUploadData, ThrowOnError>): RequestResult<DeleteUploadResponses, DeleteUploadErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUploadResponses, DeleteUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/uploads/{id}',
    ...options
});

export const listMemories = <ThrowOnError extends boolean = false>(options?: Options<ListMemoriesData, ThrowOnError>): RequestResult<ListMemoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMemoriesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/memories',
    ...options
});

export const createMemory = <ThrowOnError extends boolean = false>(options?: Options<CreateMemoryData, ThrowOnError>): RequestResult<CreateMemoryResponses, CreateMemoryErrors, ThrowOnError> => (options?.client ?? client).post<CreateMemoryResponses, CreateMemoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/memories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const searchMemories = <ThrowOnError extends boolean = false>(options: Options<SearchMemoriesData, ThrowOnError>): RequestResult<SearchMemoriesResponses, unknown, ThrowOnError> => (options.client ?? client).get<SearchMemoriesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/memories/search',
    ...options
});

export const deleteMemory = <ThrowOnError extends boolean = false>(options: Options<DeleteMemoryData, ThrowOnError>): RequestResult<DeleteMemoryResponses, DeleteMemoryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMemoryResponses, DeleteMemoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/memories/{id}',
    ...options
});

export const getMemory = <ThrowOnError extends boolean = false>(options: Options<GetMemoryData, ThrowOnError>): RequestResult<GetMemoryResponses, GetMemoryErrors, ThrowOnError> => (options.client ?? client).get<GetMemoryResponses, GetMemoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/memories/{id}',
    ...options
});

export const updateMemory = <ThrowOnError extends boolean = false>(options: Options<UpdateMemoryData, ThrowOnError>): RequestResult<UpdateMemoryResponses, UpdateMemoryErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMemoryResponses, UpdateMemoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/memories/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const promoteMemory = <ThrowOnError extends boolean = false>(options: Options<PromoteMemoryData, ThrowOnError>): RequestResult<PromoteMemoryResponses, PromoteMemoryErrors, ThrowOnError> => (options.client ?? client).post<PromoteMemoryResponses, PromoteMemoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/memories/{id}/promote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listArtifacts = <ThrowOnError extends boolean = false>(options?: Options<ListArtifactsData, ThrowOnError>): RequestResult<ListArtifactsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListArtifactsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/artifacts',
    ...options
});

export const createArtifact = <ThrowOnError extends boolean = false>(options?: Options<CreateArtifactData, ThrowOnError>): RequestResult<CreateArtifactResponses, CreateArtifactErrors, ThrowOnError> => (options?.client ?? client).post<CreateArtifactResponses, CreateArtifactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/artifacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const searchArtifacts = <ThrowOnError extends boolean = false>(options: Options<SearchArtifactsData, ThrowOnError>): RequestResult<SearchArtifactsResponses, unknown, ThrowOnError> => (options.client ?? client).get<SearchArtifactsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/artifacts/search',
    ...options
});

export const deleteArtifact = <ThrowOnError extends boolean = false>(options: Options<DeleteArtifactData, ThrowOnError>): RequestResult<DeleteArtifactResponses, DeleteArtifactErrors, ThrowOnError> => (options.client ?? client).delete<DeleteArtifactResponses, DeleteArtifactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/artifacts/{id}',
    ...options
});

export const getArtifact = <ThrowOnError extends boolean = false>(options: Options<GetArtifactData, ThrowOnError>): RequestResult<GetArtifactResponses, GetArtifactErrors, ThrowOnError> => (options.client ?? client).get<GetArtifactResponses, GetArtifactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/artifacts/{id}',
    ...options
});

export const updateArtifact = <ThrowOnError extends boolean = false>(options: Options<UpdateArtifactData, ThrowOnError>): RequestResult<UpdateArtifactResponses, UpdateArtifactErrors, ThrowOnError> => (options.client ?? client).patch<UpdateArtifactResponses, UpdateArtifactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/artifacts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listProjectTeamMembers = <ThrowOnError extends boolean = false>(options: Options<ListProjectTeamMembersData, ThrowOnError>): RequestResult<ListProjectTeamMembersResponses, ListProjectTeamMembersErrors, ThrowOnError> => (options.client ?? client).get<ListProjectTeamMembersResponses, ListProjectTeamMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/teams/{teamId}/members',
    ...options
});

export const addProjectTeamMember = <ThrowOnError extends boolean = false>(options: Options<AddProjectTeamMemberData, ThrowOnError>): RequestResult<AddProjectTeamMemberResponses, AddProjectTeamMemberErrors, ThrowOnError> => (options.client ?? client).post<AddProjectTeamMemberResponses, AddProjectTeamMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/teams/{teamId}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const removeProjectTeamMember = <ThrowOnError extends boolean = false>(options: Options<RemoveProjectTeamMemberData, ThrowOnError>): RequestResult<RemoveProjectTeamMemberResponses, RemoveProjectTeamMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveProjectTeamMemberResponses, RemoveProjectTeamMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/teams/{teamId}/members/{memberId}',
    ...options
});

export const updateProjectTeamMember = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectTeamMemberData, ThrowOnError>): RequestResult<UpdateProjectTeamMemberResponses, UpdateProjectTeamMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProjectTeamMemberResponses, UpdateProjectTeamMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/teams/{teamId}/members/{memberId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listProjectTeams = <ThrowOnError extends boolean = false>(options: Options<ListProjectTeamsData, ThrowOnError>): RequestResult<ListProjectTeamsResponses, ListProjectTeamsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectTeamsResponses, ListProjectTeamsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/teams',
    ...options
});

export const createProjectTeam = <ThrowOnError extends boolean = false>(options: Options<CreateProjectTeamData, ThrowOnError>): RequestResult<CreateProjectTeamResponses, CreateProjectTeamErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectTeamResponses, CreateProjectTeamErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/teams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteProjectTeam = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectTeamData, ThrowOnError>): RequestResult<DeleteProjectTeamResponses, DeleteProjectTeamErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectTeamResponses, DeleteProjectTeamErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/teams/{teamId}',
    ...options
});

export const getProjectTeam = <ThrowOnError extends boolean = false>(options: Options<GetProjectTeamData, ThrowOnError>): RequestResult<GetProjectTeamResponses, GetProjectTeamErrors, ThrowOnError> => (options.client ?? client).get<GetProjectTeamResponses, GetProjectTeamErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/teams/{teamId}',
    ...options
});

export const updateProjectTeam = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectTeamData, ThrowOnError>): RequestResult<UpdateProjectTeamResponses, UpdateProjectTeamErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProjectTeamResponses, UpdateProjectTeamErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/teams/{teamId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listProjectMembers = <ThrowOnError extends boolean = false>(options: Options<ListProjectMembersData, ThrowOnError>): RequestResult<ListProjectMembersResponses, ListProjectMembersErrors, ThrowOnError> => (options.client ?? client).get<ListProjectMembersResponses, ListProjectMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/members',
    ...options
});

export const addProjectMember = <ThrowOnError extends boolean = false>(options: Options<AddProjectMemberData, ThrowOnError>): RequestResult<AddProjectMemberResponses, AddProjectMemberErrors, ThrowOnError> => (options.client ?? client).post<AddProjectMemberResponses, AddProjectMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const removeProjectMember = <ThrowOnError extends boolean = false>(options: Options<RemoveProjectMemberData, ThrowOnError>): RequestResult<RemoveProjectMemberResponses, RemoveProjectMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveProjectMemberResponses, RemoveProjectMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/members/{memberId}',
    ...options
});

export const updateProjectMemberRole = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectMemberRoleData, ThrowOnError>): RequestResult<UpdateProjectMemberRoleResponses, UpdateProjectMemberRoleErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProjectMemberRoleResponses, UpdateProjectMemberRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/members/{memberId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getProjectState = <ThrowOnError extends boolean = false>(options: Options<GetProjectStateData, ThrowOnError>): RequestResult<GetProjectStateResponses, GetProjectStateErrors, ThrowOnError> => (options.client ?? client).get<GetProjectStateResponses, GetProjectStateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{projectId}/state',
    ...options
});

export const listProjectStateEvents = <ThrowOnError extends boolean = false>(options: Options<ListProjectStateEventsData, ThrowOnError>): RequestResult<ListProjectStateEventsResponses, ListProjectStateEventsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectStateEventsResponses, ListProjectStateEventsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{projectId}/events',
    ...options
});

export const listProjects = <ThrowOnError extends boolean = false>(options?: Options<ListProjectsData, ThrowOnError>): RequestResult<ListProjectsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListProjectsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects',
    ...options
});

export const createProject = <ThrowOnError extends boolean = false>(options?: Options<CreateProjectData, ThrowOnError>): RequestResult<CreateProjectResponses, CreateProjectErrors, ThrowOnError> => (options?.client ?? client).post<CreateProjectResponses, CreateProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getProjectCommandCenter = <ThrowOnError extends boolean = false>(options: Options<GetProjectCommandCenterData, ThrowOnError>): RequestResult<GetProjectCommandCenterResponses, GetProjectCommandCenterErrors, ThrowOnError> => (options.client ?? client).get<GetProjectCommandCenterResponses, GetProjectCommandCenterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/command-center',
    ...options
});

export const listProjectWorkModeTemplates = <ThrowOnError extends boolean = false>(options: Options<ListProjectWorkModeTemplatesData, ThrowOnError>): RequestResult<ListProjectWorkModeTemplatesResponses, ListProjectWorkModeTemplatesErrors, ThrowOnError> => (options.client ?? client).get<ListProjectWorkModeTemplatesResponses, ListProjectWorkModeTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/work-mode-templates',
    ...options
});

export const replaceProjectWorkModeTemplates = <ThrowOnError extends boolean = false>(options: Options<ReplaceProjectWorkModeTemplatesData, ThrowOnError>): RequestResult<ReplaceProjectWorkModeTemplatesResponses, ReplaceProjectWorkModeTemplatesErrors, ThrowOnError> => (options.client ?? client).put<ReplaceProjectWorkModeTemplatesResponses, ReplaceProjectWorkModeTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/work-mode-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listProjectThreads = <ThrowOnError extends boolean = false>(options: Options<ListProjectThreadsData, ThrowOnError>): RequestResult<ListProjectThreadsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListProjectThreadsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/threads',
    ...options
});

export const createProjectThread = <ThrowOnError extends boolean = false>(options: Options<CreateProjectThreadData, ThrowOnError>): RequestResult<CreateProjectThreadResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateProjectThreadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/threads',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateProjectThread = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectThreadData, ThrowOnError>): RequestResult<UpdateProjectThreadResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateProjectThreadResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/threads/{threadId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listProjectChanges = <ThrowOnError extends boolean = false>(options: Options<ListProjectChangesData, ThrowOnError>): RequestResult<ListProjectChangesResponses, ListProjectChangesErrors, ThrowOnError> => (options.client ?? client).get<ListProjectChangesResponses, ListProjectChangesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/changes',
    ...options
});

export const createProjectChange = <ThrowOnError extends boolean = false>(options: Options<CreateProjectChangeData, ThrowOnError>): RequestResult<CreateProjectChangeResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateProjectChangeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/changes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getProjectChange = <ThrowOnError extends boolean = false>(options: Options<GetProjectChangeData, ThrowOnError>): RequestResult<GetProjectChangeResponses, GetProjectChangeErrors, ThrowOnError> => (options.client ?? client).get<GetProjectChangeResponses, GetProjectChangeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/changes/{changeId}',
    ...options
});

export const updateProjectChange = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectChangeData, ThrowOnError>): RequestResult<UpdateProjectChangeResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateProjectChangeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/changes/{changeId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getProjectLog = <ThrowOnError extends boolean = false>(options: Options<GetProjectLogData, ThrowOnError>): RequestResult<GetProjectLogResponses, GetProjectLogErrors, ThrowOnError> => (options.client ?? client).get<GetProjectLogResponses, GetProjectLogErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/log',
    ...options
});

export const createProjectChangeRevision = <ThrowOnError extends boolean = false>(options: Options<CreateProjectChangeRevisionData, ThrowOnError>): RequestResult<CreateProjectChangeRevisionResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateProjectChangeRevisionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/changes/{changeId}/revisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const linkProjectThreadResource = <ThrowOnError extends boolean = false>(options: Options<LinkProjectThreadResourceData, ThrowOnError>): RequestResult<LinkProjectThreadResourceResponses, unknown, ThrowOnError> => (options.client ?? client).post<LinkProjectThreadResourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/thread-resources',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const softDeleteProject = <ThrowOnError extends boolean = false>(options: Options<SoftDeleteProjectData, ThrowOnError>): RequestResult<SoftDeleteProjectResponses, SoftDeleteProjectErrors, ThrowOnError> => (options.client ?? client).delete<SoftDeleteProjectResponses, SoftDeleteProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}',
    ...options
});

export const getProject = <ThrowOnError extends boolean = false>(options: Options<GetProjectData, ThrowOnError>): RequestResult<GetProjectResponses, GetProjectErrors, ThrowOnError> => (options.client ?? client).get<GetProjectResponses, GetProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}',
    ...options
});

export const updateProject = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectData, ThrowOnError>): RequestResult<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const archiveProject = <ThrowOnError extends boolean = false>(options: Options<ArchiveProjectData, ThrowOnError>): RequestResult<ArchiveProjectResponses, ArchiveProjectErrors, ThrowOnError> => (options.client ?? client).post<ArchiveProjectResponses, ArchiveProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/archive',
    ...options
});

export const reactivateProject = <ThrowOnError extends boolean = false>(options: Options<ReactivateProjectData, ThrowOnError>): RequestResult<ReactivateProjectResponses, ReactivateProjectErrors, ThrowOnError> => (options.client ?? client).post<ReactivateProjectResponses, ReactivateProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/reactivate',
    ...options
});

export const closeProject = <ThrowOnError extends boolean = false>(options: Options<CloseProjectData, ThrowOnError>): RequestResult<CloseProjectResponses, CloseProjectErrors, ThrowOnError> => (options.client ?? client).post<CloseProjectResponses, CloseProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/close',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getProjectSummary = <ThrowOnError extends boolean = false>(options: Options<GetProjectSummaryData, ThrowOnError>): RequestResult<GetProjectSummaryResponses, GetProjectSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetProjectSummaryResponses, GetProjectSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{id}/summary',
    ...options
});

export const listActionQueue = <ThrowOnError extends boolean = false>(options?: Options<ListActionQueueData, ThrowOnError>): RequestResult<ListActionQueueResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListActionQueueResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/coordination/action-queue',
    ...options
});

export const claimActionQueueItem = <ThrowOnError extends boolean = false>(options: Options<ClaimActionQueueItemData, ThrowOnError>): RequestResult<ClaimActionQueueItemResponses, ClaimActionQueueItemErrors, ThrowOnError> => (options.client ?? client).post<ClaimActionQueueItemResponses, ClaimActionQueueItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/coordination/action-queue/{itemId}/claim',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const resolveActionQueueItem = <ThrowOnError extends boolean = false>(options: Options<ResolveActionQueueItemData, ThrowOnError>): RequestResult<ResolveActionQueueItemResponses, ResolveActionQueueItemErrors, ThrowOnError> => (options.client ?? client).post<ResolveActionQueueItemResponses, ResolveActionQueueItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/coordination/action-queue/{itemId}/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const decideGate = <ThrowOnError extends boolean = false>(options: Options<DecideGateData, ThrowOnError>): RequestResult<DecideGateResponses, DecideGateErrors, ThrowOnError> => (options.client ?? client).post<DecideGateResponses, DecideGateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/coordination/gates/{gateId}/decisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const transitionBlocker = <ThrowOnError extends boolean = false>(options: Options<TransitionBlockerData, ThrowOnError>): RequestResult<TransitionBlockerResponses, TransitionBlockerErrors, ThrowOnError> => (options.client ?? client).post<TransitionBlockerResponses, TransitionBlockerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/coordination/blockers/{blockerId}/transitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const transitionHandoff = <ThrowOnError extends boolean = false>(options: Options<TransitionHandoffData, ThrowOnError>): RequestResult<TransitionHandoffResponses, TransitionHandoffErrors, ThrowOnError> => (options.client ?? client).post<TransitionHandoffResponses, TransitionHandoffErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/coordination/handoffs/{handoffId}/transitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listTaskDecisions = <ThrowOnError extends boolean = false>(options: Options<ListTaskDecisionsData, ThrowOnError>): RequestResult<ListTaskDecisionsResponses, ListTaskDecisionsErrors, ThrowOnError> => (options.client ?? client).get<ListTaskDecisionsResponses, ListTaskDecisionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{id}/decisions',
    ...options
});

export const startTask = <ThrowOnError extends boolean = false>(options: Options<StartTaskData, ThrowOnError>): RequestResult<StartTaskResponses, StartTaskErrors, ThrowOnError> => (options.client ?? client).post<StartTaskResponses, StartTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{id}/start',
    ...options
});

export const cancelTask = <ThrowOnError extends boolean = false>(options: Options<CancelTaskData, ThrowOnError>): RequestResult<CancelTaskResponses, CancelTaskErrors, ThrowOnError> => (options.client ?? client).post<CancelTaskResponses, CancelTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{id}/cancel',
    ...options
});

export const approveTaskAction = <ThrowOnError extends boolean = false>(options: Options<ApproveTaskActionData, ThrowOnError>): RequestResult<ApproveTaskActionResponses, ApproveTaskActionErrors, ThrowOnError> => (options.client ?? client).post<ApproveTaskActionResponses, ApproveTaskActionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{id}/approve-action',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const rejectTaskAction = <ThrowOnError extends boolean = false>(options: Options<RejectTaskActionData, ThrowOnError>): RequestResult<RejectTaskActionResponses, RejectTaskActionErrors, ThrowOnError> => (options.client ?? client).post<RejectTaskActionResponses, RejectTaskActionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{id}/reject-action',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const extendApprovalTimeout = <ThrowOnError extends boolean = false>(options: Options<ExtendApprovalTimeoutData, ThrowOnError>): RequestResult<ExtendApprovalTimeoutResponses, ExtendApprovalTimeoutErrors, ThrowOnError> => (options.client ?? client).post<ExtendApprovalTimeoutResponses, ExtendApprovalTimeoutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{id}/extend-approval',
    ...options
});

export const completeTask = <ThrowOnError extends boolean = false>(options: Options<CompleteTaskData, ThrowOnError>): RequestResult<CompleteTaskResponses, CompleteTaskErrors, ThrowOnError> => (options.client ?? client).post<CompleteTaskResponses, CompleteTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{id}/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const retryTask = <ThrowOnError extends boolean = false>(options: Options<RetryTaskData, ThrowOnError>): RequestResult<RetryTaskResponses, RetryTaskErrors, ThrowOnError> => (options.client ?? client).post<RetryTaskResponses, RetryTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{id}/retry',
    ...options
});

export const reassignTask = <ThrowOnError extends boolean = false>(options: Options<ReassignTaskData, ThrowOnError>): RequestResult<ReassignTaskResponses, ReassignTaskErrors, ThrowOnError> => (options.client ?? client).post<ReassignTaskResponses, ReassignTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{id}/reassign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const transferTaskTeam = <ThrowOnError extends boolean = false>(options: Options<TransferTaskTeamData, ThrowOnError>): RequestResult<TransferTaskTeamResponses, TransferTaskTeamErrors, ThrowOnError> => (options.client ?? client).post<TransferTaskTeamResponses, TransferTaskTeamErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{id}/transfer-team',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listTasks = <ThrowOnError extends boolean = false>(options?: Options<ListTasksData, ThrowOnError>): RequestResult<ListTasksResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListTasksResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks',
    ...options
});

export const createTask = <ThrowOnError extends boolean = false>(options?: Options<CreateTaskData, ThrowOnError>): RequestResult<CreateTaskResponses, CreateTaskErrors, ThrowOnError> => (options?.client ?? client).post<CreateTaskResponses, CreateTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteTask = <ThrowOnError extends boolean = false>(options: Options<DeleteTaskData, ThrowOnError>): RequestResult<DeleteTaskResponses, DeleteTaskErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTaskResponses, DeleteTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{id}',
    ...options
});

export const getTask = <ThrowOnError extends boolean = false>(options: Options<GetTaskData, ThrowOnError>): RequestResult<GetTaskResponses, GetTaskErrors, ThrowOnError> => (options.client ?? client).get<GetTaskResponses, GetTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{id}',
    ...options
});

export const updateTask = <ThrowOnError extends boolean = false>(options: Options<UpdateTaskData, ThrowOnError>): RequestResult<UpdateTaskResponses, UpdateTaskErrors, ThrowOnError> => (options.client ?? client).patch<UpdateTaskResponses, UpdateTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/tasks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listInterventions = <ThrowOnError extends boolean = false>(options?: Options<ListInterventionsData, ThrowOnError>): RequestResult<ListInterventionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListInterventionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/action-requests',
    ...options
});

export const createIntervention = <ThrowOnError extends boolean = false>(options?: Options<CreateInterventionData, ThrowOnError>): RequestResult<CreateInterventionResponses, CreateInterventionErrors, ThrowOnError> => (options?.client ?? client).post<CreateInterventionResponses, CreateInterventionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/action-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getIntervention = <ThrowOnError extends boolean = false>(options: Options<GetInterventionData, ThrowOnError>): RequestResult<GetInterventionResponses, GetInterventionErrors, ThrowOnError> => (options.client ?? client).get<GetInterventionResponses, GetInterventionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/action-requests/{id}',
    ...options
});

export const routeIntervention = <ThrowOnError extends boolean = false>(options: Options<RouteInterventionData, ThrowOnError>): RequestResult<RouteInterventionResponses, RouteInterventionErrors, ThrowOnError> => (options.client ?? client).post<RouteInterventionResponses, RouteInterventionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/action-requests/{id}/route',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const resolveIntervention = <ThrowOnError extends boolean = false>(options: Options<ResolveInterventionData, ThrowOnError>): RequestResult<ResolveInterventionResponses, ResolveInterventionErrors, ThrowOnError> => (options.client ?? client).post<ResolveInterventionResponses, ResolveInterventionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/action-requests/{id}/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const rejectIntervention = <ThrowOnError extends boolean = false>(options: Options<RejectInterventionData, ThrowOnError>): RequestResult<RejectInterventionResponses, RejectInterventionErrors, ThrowOnError> => (options.client ?? client).post<RejectInterventionResponses, RejectInterventionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/action-requests/{id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listWorkstreamMembers = <ThrowOnError extends boolean = false>(options: Options<ListWorkstreamMembersData, ThrowOnError>): RequestResult<ListWorkstreamMembersResponses, ListWorkstreamMembersErrors, ThrowOnError> => (options.client ?? client).get<ListWorkstreamMembersResponses, ListWorkstreamMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workstreams/{id}/members',
    ...options
});

export const addWorkstreamMember = <ThrowOnError extends boolean = false>(options: Options<AddWorkstreamMemberData, ThrowOnError>): RequestResult<AddWorkstreamMemberResponses, AddWorkstreamMemberErrors, ThrowOnError> => (options.client ?? client).post<AddWorkstreamMemberResponses, AddWorkstreamMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workstreams/{id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const removeWorkstreamMember = <ThrowOnError extends boolean = false>(options: Options<RemoveWorkstreamMemberData, ThrowOnError>): RequestResult<RemoveWorkstreamMemberResponses, RemoveWorkstreamMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveWorkstreamMemberResponses, RemoveWorkstreamMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workstreams/{id}/members/{memberId}',
    ...options
});

export const listWorkstreamDecisions = <ThrowOnError extends boolean = false>(options: Options<ListWorkstreamDecisionsData, ThrowOnError>): RequestResult<ListWorkstreamDecisionsResponses, ListWorkstreamDecisionsErrors, ThrowOnError> => (options.client ?? client).get<ListWorkstreamDecisionsResponses, ListWorkstreamDecisionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workstreams/{id}/decisions',
    ...options
});

export const listWorkstreams = <ThrowOnError extends boolean = false>(options?: Options<ListWorkstreamsData, ThrowOnError>): RequestResult<ListWorkstreamsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListWorkstreamsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workstreams',
    ...options
});

export const createWorkstream = <ThrowOnError extends boolean = false>(options?: Options<CreateWorkstreamData, ThrowOnError>): RequestResult<CreateWorkstreamResponses, CreateWorkstreamErrors, ThrowOnError> => (options?.client ?? client).post<CreateWorkstreamResponses, CreateWorkstreamErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workstreams',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const archiveWorkstream = <ThrowOnError extends boolean = false>(options: Options<ArchiveWorkstreamData, ThrowOnError>): RequestResult<ArchiveWorkstreamResponses, ArchiveWorkstreamErrors, ThrowOnError> => (options.client ?? client).delete<ArchiveWorkstreamResponses, ArchiveWorkstreamErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workstreams/{id}',
    ...options
});

export const getWorkstream = <ThrowOnError extends boolean = false>(options: Options<GetWorkstreamData, ThrowOnError>): RequestResult<GetWorkstreamResponses, GetWorkstreamErrors, ThrowOnError> => (options.client ?? client).get<GetWorkstreamResponses, GetWorkstreamErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workstreams/{id}',
    ...options
});

export const updateWorkstream = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkstreamData, ThrowOnError>): RequestResult<UpdateWorkstreamResponses, UpdateWorkstreamErrors, ThrowOnError> => (options.client ?? client).patch<UpdateWorkstreamResponses, UpdateWorkstreamErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workstreams/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listApproverDelegations = <ThrowOnError extends boolean = false>(options?: Options<ListApproverDelegationsData, ThrowOnError>): RequestResult<ListApproverDelegationsResponses, ListApproverDelegationsErrors, ThrowOnError> => (options?.client ?? client).get<ListApproverDelegationsResponses, ListApproverDelegationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/approvals/delegations',
    ...options
});

export const createApproverDelegation = <ThrowOnError extends boolean = false>(options?: Options<CreateApproverDelegationData, ThrowOnError>): RequestResult<CreateApproverDelegationResponses, CreateApproverDelegationErrors, ThrowOnError> => (options?.client ?? client).post<CreateApproverDelegationResponses, CreateApproverDelegationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/approvals/delegations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const revokeApproverDelegation = <ThrowOnError extends boolean = false>(options: Options<RevokeApproverDelegationData, ThrowOnError>): RequestResult<RevokeApproverDelegationResponses, RevokeApproverDelegationErrors, ThrowOnError> => (options.client ?? client).delete<RevokeApproverDelegationResponses, RevokeApproverDelegationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/approvals/delegations/{id}',
    ...options
});

export const listPromotionCandidates = <ThrowOnError extends boolean = false>(options?: Options<ListPromotionCandidatesData, ThrowOnError>): RequestResult<ListPromotionCandidatesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListPromotionCandidatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/promotion-candidates',
    ...options
});

export const getPromotionCandidate = <ThrowOnError extends boolean = false>(options: Options<GetPromotionCandidateData, ThrowOnError>): RequestResult<GetPromotionCandidateResponses, GetPromotionCandidateErrors, ThrowOnError> => (options.client ?? client).get<GetPromotionCandidateResponses, GetPromotionCandidateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/promotion-candidates/{id}',
    ...options
});

export const acceptPromotionCandidate = <ThrowOnError extends boolean = false>(options: Options<AcceptPromotionCandidateData, ThrowOnError>): RequestResult<AcceptPromotionCandidateResponses, AcceptPromotionCandidateErrors, ThrowOnError> => (options.client ?? client).post<AcceptPromotionCandidateResponses, AcceptPromotionCandidateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/promotion-candidates/{id}/accept',
    ...options
});

export const rejectPromotionCandidate = <ThrowOnError extends boolean = false>(options: Options<RejectPromotionCandidateData, ThrowOnError>): RequestResult<RejectPromotionCandidateResponses, RejectPromotionCandidateErrors, ThrowOnError> => (options.client ?? client).post<RejectPromotionCandidateResponses, RejectPromotionCandidateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/promotion-candidates/{id}/reject',
    ...options
});

export const listAdminDaemonFindings = <ThrowOnError extends boolean = false>(options?: Options<ListAdminDaemonFindingsData, ThrowOnError>): RequestResult<ListAdminDaemonFindingsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAdminDaemonFindingsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/daemon-findings',
    ...options
});

export const listDeadLetterEntries = <ThrowOnError extends boolean = false>(options?: Options<ListDeadLetterEntriesData, ThrowOnError>): RequestResult<ListDeadLetterEntriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListDeadLetterEntriesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/dead-letter-entries',
    ...options
});

export const replayDeadLetterEntry = <ThrowOnError extends boolean = false>(options: Options<ReplayDeadLetterEntryData, ThrowOnError>): RequestResult<ReplayDeadLetterEntryResponses, ReplayDeadLetterEntryErrors, ThrowOnError> => (options.client ?? client).post<ReplayDeadLetterEntryResponses, ReplayDeadLetterEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/dead-letter-entries/{id}/replay',
    ...options
});

export const listPlatformRuntimeFlags = <ThrowOnError extends boolean = false>(options?: Options<ListPlatformRuntimeFlagsData, ThrowOnError>): RequestResult<ListPlatformRuntimeFlagsResponses, ListPlatformRuntimeFlagsErrors, ThrowOnError> => (options?.client ?? client).get<ListPlatformRuntimeFlagsResponses, ListPlatformRuntimeFlagsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/runtime-flags/platform',
    ...options
});

export const setPlatformRuntimeFlag = <ThrowOnError extends boolean = false>(options: Options<SetPlatformRuntimeFlagData, ThrowOnError>): RequestResult<SetPlatformRuntimeFlagResponses, SetPlatformRuntimeFlagErrors, ThrowOnError> => (options.client ?? client).put<SetPlatformRuntimeFlagResponses, SetPlatformRuntimeFlagErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/runtime-flags/platform/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listOrganizationRuntimeFlags = <ThrowOnError extends boolean = false>(options?: Options<ListOrganizationRuntimeFlagsData, ThrowOnError>): RequestResult<ListOrganizationRuntimeFlagsResponses, ListOrganizationRuntimeFlagsErrors, ThrowOnError> => (options?.client ?? client).get<ListOrganizationRuntimeFlagsResponses, ListOrganizationRuntimeFlagsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/runtime-flags/organization',
    ...options
});

export const setOrganizationRuntimeFlag = <ThrowOnError extends boolean = false>(options: Options<SetOrganizationRuntimeFlagData, ThrowOnError>): RequestResult<SetOrganizationRuntimeFlagResponses, SetOrganizationRuntimeFlagErrors, ThrowOnError> => (options.client ?? client).put<SetOrganizationRuntimeFlagResponses, SetOrganizationRuntimeFlagErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/runtime-flags/organization/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getSystemOverview = <ThrowOnError extends boolean = false>(options?: Options<GetSystemOverviewData, ThrowOnError>): RequestResult<GetSystemOverviewResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSystemOverviewResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/system/overview',
    ...options
});

export const getSystemHost = <ThrowOnError extends boolean = false>(options: Options<GetSystemHostData, ThrowOnError>): RequestResult<GetSystemHostResponses, GetSystemHostErrors, ThrowOnError> => (options.client ?? client).get<GetSystemHostResponses, GetSystemHostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/system/hosts/{id}',
    ...options
});

export const getSystemHostSeries = <ThrowOnError extends boolean = false>(options: Options<GetSystemHostSeriesData, ThrowOnError>): RequestResult<GetSystemHostSeriesResponses, GetSystemHostSeriesErrors, ThrowOnError> => (options.client ?? client).get<GetSystemHostSeriesResponses, GetSystemHostSeriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/system/hosts/{id}/series',
    ...options
});

export const getSystemDatabase = <ThrowOnError extends boolean = false>(options: Options<GetSystemDatabaseData, ThrowOnError>): RequestResult<GetSystemDatabaseResponses, GetSystemDatabaseErrors, ThrowOnError> => (options.client ?? client).get<GetSystemDatabaseResponses, GetSystemDatabaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/system/databases/{id}',
    ...options
});

export const getSystemDatabaseSeries = <ThrowOnError extends boolean = false>(options: Options<GetSystemDatabaseSeriesData, ThrowOnError>): RequestResult<GetSystemDatabaseSeriesResponses, GetSystemDatabaseSeriesErrors, ThrowOnError> => (options.client ?? client).get<GetSystemDatabaseSeriesResponses, GetSystemDatabaseSeriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/system/databases/{id}/series',
    ...options
});

export const listSystemDatabaseStatements = <ThrowOnError extends boolean = false>(options: Options<ListSystemDatabaseStatementsData, ThrowOnError>): RequestResult<ListSystemDatabaseStatementsResponses, ListSystemDatabaseStatementsErrors, ThrowOnError> => (options.client ?? client).get<ListSystemDatabaseStatementsResponses, ListSystemDatabaseStatementsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/system/databases/{id}/statements',
    ...options
});

export const getSystemRedis = <ThrowOnError extends boolean = false>(options?: Options<GetSystemRedisData, ThrowOnError>): RequestResult<GetSystemRedisResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSystemRedisResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/system/redis',
    ...options
});

export const getSystemRedisSeries = <ThrowOnError extends boolean = false>(options: Options<GetSystemRedisSeriesData, ThrowOnError>): RequestResult<GetSystemRedisSeriesResponses, GetSystemRedisSeriesErrors, ThrowOnError> => (options.client ?? client).get<GetSystemRedisSeriesResponses, GetSystemRedisSeriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/system/redis/series',
    ...options
});

export const cancelAllOrders = <ThrowOnError extends boolean = false>(options?: Options<CancelAllOrdersData, ThrowOnError>): RequestResult<CancelAllOrdersResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<CancelAllOrdersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/orders',
    ...options
});

export const listOrders = <ThrowOnError extends boolean = false>(options?: Options<ListOrdersData, ThrowOnError>): RequestResult<ListOrdersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListOrdersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/orders',
    ...options
});

export const createOrder = <ThrowOnError extends boolean = false>(options?: Options<CreateOrderData, ThrowOnError>): RequestResult<CreateOrderResponses, CreateOrderErrors, ThrowOnError> => (options?.client ?? client).post<CreateOrderResponses, CreateOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/orders',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const cancelOrder = <ThrowOnError extends boolean = false>(options: Options<CancelOrderData, ThrowOnError>): RequestResult<CancelOrderResponses, CancelOrderErrors, ThrowOnError> => (options.client ?? client).delete<CancelOrderResponses, CancelOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/orders/{id}',
    ...options
});

export const getOrder = <ThrowOnError extends boolean = false>(options: Options<GetOrderData, ThrowOnError>): RequestResult<GetOrderResponses, GetOrderErrors, ThrowOnError> => (options.client ?? client).get<GetOrderResponses, GetOrderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/orders/{id}',
    ...options
});

export const listTrades = <ThrowOnError extends boolean = false>(options?: Options<ListTradesData, ThrowOnError>): RequestResult<ListTradesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListTradesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/trades',
    ...options
});

export const getTradeStats = <ThrowOnError extends boolean = false>(options?: Options<GetTradeStatsData, ThrowOnError>): RequestResult<GetTradeStatsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetTradeStatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/stats',
    ...options
});

export const listPositions = <ThrowOnError extends boolean = false>(options?: Options<ListPositionsData, ThrowOnError>): RequestResult<ListPositionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListPositionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/positions',
    ...options
});

export const getPosition = <ThrowOnError extends boolean = false>(options: Options<GetPositionData, ThrowOnError>): RequestResult<GetPositionResponses, GetPositionErrors, ThrowOnError> => (options.client ?? client).get<GetPositionResponses, GetPositionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/positions/{id}',
    ...options
});

export const closePosition = <ThrowOnError extends boolean = false>(options: Options<ClosePositionData, ThrowOnError>): RequestResult<ClosePositionResponses, ClosePositionErrors, ThrowOnError> => (options.client ?? client).post<ClosePositionResponses, ClosePositionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/positions/{id}/close',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listRiskLimits = <ThrowOnError extends boolean = false>(options?: Options<ListRiskLimitsData, ThrowOnError>): RequestResult<ListRiskLimitsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListRiskLimitsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/risk/limits',
    ...options
});

export const createRiskLimit = <ThrowOnError extends boolean = false>(options?: Options<CreateRiskLimitData, ThrowOnError>): RequestResult<CreateRiskLimitResponses, CreateRiskLimitErrors, ThrowOnError> => (options?.client ?? client).post<CreateRiskLimitResponses, CreateRiskLimitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/risk/limits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteRiskLimit = <ThrowOnError extends boolean = false>(options: Options<DeleteRiskLimitData, ThrowOnError>): RequestResult<DeleteRiskLimitResponses, DeleteRiskLimitErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRiskLimitResponses, DeleteRiskLimitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/risk/limits/{id}',
    ...options
});

export const updateRiskLimit = <ThrowOnError extends boolean = false>(options: Options<UpdateRiskLimitData, ThrowOnError>): RequestResult<UpdateRiskLimitResponses, UpdateRiskLimitErrors, ThrowOnError> => (options.client ?? client).patch<UpdateRiskLimitResponses, UpdateRiskLimitErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/risk/limits/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listRiskBreaches = <ThrowOnError extends boolean = false>(options?: Options<ListRiskBreachesData, ThrowOnError>): RequestResult<ListRiskBreachesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListRiskBreachesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/risk/breaches',
    ...options
});

export const acceptRiskBreach = <ThrowOnError extends boolean = false>(options: Options<AcceptRiskBreachData, ThrowOnError>): RequestResult<AcceptRiskBreachResponses, AcceptRiskBreachErrors, ThrowOnError> => (options.client ?? client).post<AcceptRiskBreachResponses, AcceptRiskBreachErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/risk/breaches/{id}/accept',
    ...options
});

export const resolveRiskBreach = <ThrowOnError extends boolean = false>(options: Options<ResolveRiskBreachData, ThrowOnError>): RequestResult<ResolveRiskBreachResponses, ResolveRiskBreachErrors, ThrowOnError> => (options.client ?? client).post<ResolveRiskBreachResponses, ResolveRiskBreachErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/risk/breaches/{id}/resolve',
    ...options
});

export const escalateRiskBreach = <ThrowOnError extends boolean = false>(options: Options<EscalateRiskBreachData, ThrowOnError>): RequestResult<EscalateRiskBreachResponses, EscalateRiskBreachErrors, ThrowOnError> => (options.client ?? client).post<EscalateRiskBreachResponses, EscalateRiskBreachErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/risk/breaches/{id}/escalate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listRiskHalts = <ThrowOnError extends boolean = false>(options?: Options<ListRiskHaltsData, ThrowOnError>): RequestResult<ListRiskHaltsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListRiskHaltsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/risk/halts',
    ...options
});

export const activateRiskHalt = <ThrowOnError extends boolean = false>(options?: Options<ActivateRiskHaltData, ThrowOnError>): RequestResult<ActivateRiskHaltResponses, ActivateRiskHaltErrors, ThrowOnError> => (options?.client ?? client).post<ActivateRiskHaltResponses, ActivateRiskHaltErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/risk/halts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const resumeRiskHalt = <ThrowOnError extends boolean = false>(options: Options<ResumeRiskHaltData, ThrowOnError>): RequestResult<ResumeRiskHaltResponses, ResumeRiskHaltErrors, ThrowOnError> => (options.client ?? client).post<ResumeRiskHaltResponses, ResumeRiskHaltErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/risk/halts/{id}/resume',
    ...options
});

export const getRiskStatus = <ThrowOnError extends boolean = false>(options?: Options<GetRiskStatusData, ThrowOnError>): RequestResult<GetRiskStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRiskStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/risk/status',
    ...options
});

export const listActiveStrategies = <ThrowOnError extends boolean = false>(options?: Options<ListActiveStrategiesData, ThrowOnError>): RequestResult<ListActiveStrategiesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListActiveStrategiesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies/active',
    ...options
});

export const createActiveStrategy = <ThrowOnError extends boolean = false>(options?: Options<CreateActiveStrategyData, ThrowOnError>): RequestResult<CreateActiveStrategyResponses, CreateActiveStrategyErrors, ThrowOnError> => (options?.client ?? client).post<CreateActiveStrategyResponses, CreateActiveStrategyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies/active',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const removeActiveStrategy = <ThrowOnError extends boolean = false>(options: Options<RemoveActiveStrategyData, ThrowOnError>): RequestResult<RemoveActiveStrategyResponses, RemoveActiveStrategyErrors, ThrowOnError> => (options.client ?? client).delete<RemoveActiveStrategyResponses, RemoveActiveStrategyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies/active/{id}',
    ...options
});

export const getActiveStrategy = <ThrowOnError extends boolean = false>(options: Options<GetActiveStrategyData, ThrowOnError>): RequestResult<GetActiveStrategyResponses, GetActiveStrategyErrors, ThrowOnError> => (options.client ?? client).get<GetActiveStrategyResponses, GetActiveStrategyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies/active/{id}',
    ...options
});

export const updateStrategyParameters = <ThrowOnError extends boolean = false>(options: Options<UpdateStrategyParametersData, ThrowOnError>): RequestResult<UpdateStrategyParametersResponses, UpdateStrategyParametersErrors, ThrowOnError> => (options.client ?? client).patch<UpdateStrategyParametersResponses, UpdateStrategyParametersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies/active/{id}/parameters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const startStrategy = <ThrowOnError extends boolean = false>(options: Options<StartStrategyData, ThrowOnError>): RequestResult<StartStrategyResponses, StartStrategyErrors, ThrowOnError> => (options.client ?? client).post<StartStrategyResponses, StartStrategyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies/active/{id}/start',
    ...options
});

export const stopStrategy = <ThrowOnError extends boolean = false>(options: Options<StopStrategyData, ThrowOnError>): RequestResult<StopStrategyResponses, StopStrategyErrors, ThrowOnError> => (options.client ?? client).post<StopStrategyResponses, StopStrategyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies/active/{id}/stop',
    ...options
});

export const deployStrategy = <ThrowOnError extends boolean = false>(options: Options<DeployStrategyData, ThrowOnError>): RequestResult<DeployStrategyResponses, DeployStrategyErrors, ThrowOnError> => (options.client ?? client).post<DeployStrategyResponses, DeployStrategyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies/{id}/deploy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const undeployStrategy = <ThrowOnError extends boolean = false>(options: Options<UndeployStrategyData, ThrowOnError>): RequestResult<UndeployStrategyResponses, UndeployStrategyErrors, ThrowOnError> => (options.client ?? client).post<UndeployStrategyResponses, UndeployStrategyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies/{id}/undeploy',
    ...options
});

export const getStrategyDeploymentStatus = <ThrowOnError extends boolean = false>(options: Options<GetStrategyDeploymentStatusData, ThrowOnError>): RequestResult<GetStrategyDeploymentStatusResponses, GetStrategyDeploymentStatusErrors, ThrowOnError> => (options.client ?? client).get<GetStrategyDeploymentStatusResponses, GetStrategyDeploymentStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies/{id}/status',
    ...options
});

export const generateStrategyDocs = <ThrowOnError extends boolean = false>(options: Options<GenerateStrategyDocsData, ThrowOnError>): RequestResult<GenerateStrategyDocsResponses, GenerateStrategyDocsErrors, ThrowOnError> => (options.client ?? client).post<GenerateStrategyDocsResponses, GenerateStrategyDocsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies/{id}/generate-docs',
    ...options
});

export const checkDeploymentReadiness = <ThrowOnError extends boolean = false>(options: Options<CheckDeploymentReadinessData, ThrowOnError>): RequestResult<CheckDeploymentReadinessResponses, CheckDeploymentReadinessErrors, ThrowOnError> => (options.client ?? client).get<CheckDeploymentReadinessResponses, CheckDeploymentReadinessErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies/{id}/deployment-readiness',
    ...options
});

export const listStrategies = <ThrowOnError extends boolean = false>(options?: Options<ListStrategiesData, ThrowOnError>): RequestResult<ListStrategiesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListStrategiesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies',
    ...options
});

export const runBacktest = <ThrowOnError extends boolean = false>(options?: Options<RunBacktestData, ThrowOnError>): RequestResult<RunBacktestResponses, RunBacktestErrors, ThrowOnError> => (options?.client ?? client).post<RunBacktestResponses, RunBacktestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies/backtest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getStrategy = <ThrowOnError extends boolean = false>(options: Options<GetStrategyData, ThrowOnError>): RequestResult<GetStrategyResponses, GetStrategyErrors, ThrowOnError> => (options.client ?? client).get<GetStrategyResponses, GetStrategyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategies/{name}',
    ...options
});

export const listIngestionJobs = <ThrowOnError extends boolean = false>(options?: Options<ListIngestionJobsData, ThrowOnError>): RequestResult<ListIngestionJobsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListIngestionJobsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-data/ingestion-jobs',
    ...options
});

export const runIngestionJob = <ThrowOnError extends boolean = false>(options: Options<RunIngestionJobData, ThrowOnError>): RequestResult<RunIngestionJobResponses, RunIngestionJobErrors, ThrowOnError> => (options.client ?? client).post<RunIngestionJobResponses, RunIngestionJobErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-data/ingestion-jobs/{id}/run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listCandles = <ThrowOnError extends boolean = false>(options: Options<ListCandlesData, ThrowOnError>): RequestResult<ListCandlesResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListCandlesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-data/candles',
    ...options
});

export const getPrice = <ThrowOnError extends boolean = false>(options: Options<GetPriceData, ThrowOnError>): RequestResult<GetPriceResponses, GetPriceErrors, ThrowOnError> => (options.client ?? client).get<GetPriceResponses, GetPriceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-data/price/{symbol}',
    ...options
});

export const listPrices = <ThrowOnError extends boolean = false>(options: Options<ListPricesData, ThrowOnError>): RequestResult<ListPricesResponses, ListPricesErrors, ThrowOnError> => (options.client ?? client).get<ListPricesResponses, ListPricesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-data/prices',
    ...options
});

export const getOrderBook = <ThrowOnError extends boolean = false>(options: Options<GetOrderBookData, ThrowOnError>): RequestResult<GetOrderBookResponses, GetOrderBookErrors, ThrowOnError> => (options.client ?? client).get<GetOrderBookResponses, GetOrderBookErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-data/orderbook/{symbol}',
    ...options
});

export const createBackfill = <ThrowOnError extends boolean = false>(options?: Options<CreateBackfillData, ThrowOnError>): RequestResult<unknown, CreateBackfillErrors, ThrowOnError> => (options?.client ?? client).post<unknown, CreateBackfillErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-data/backfill',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const checkMarketData = <ThrowOnError extends boolean = false>(options: Options<CheckMarketDataData, ThrowOnError>): RequestResult<CheckMarketDataResponses, unknown, ThrowOnError> => (options.client ?? client).get<CheckMarketDataResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-data/check',
    ...options
});

export const getMarketDataStatus = <ThrowOnError extends boolean = false>(options?: Options<GetMarketDataStatusData, ThrowOnError>): RequestResult<unknown, GetMarketDataStatusErrors, ThrowOnError> => (options?.client ?? client).get<unknown, GetMarketDataStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-data/status',
    ...options
});

export const startMarketData = <ThrowOnError extends boolean = false>(options?: Options<StartMarketDataData, ThrowOnError>): RequestResult<unknown, StartMarketDataErrors, ThrowOnError> => (options?.client ?? client).post<unknown, StartMarketDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-data/start',
    ...options
});

export const stopMarketData = <ThrowOnError extends boolean = false>(options?: Options<StopMarketDataData, ThrowOnError>): RequestResult<unknown, StopMarketDataErrors, ThrowOnError> => (options?.client ?? client).post<unknown, StopMarketDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-data/stop',
    ...options
});

export const listEconomicEvents = <ThrowOnError extends boolean = false>(options?: Options<ListEconomicEventsData, ThrowOnError>): RequestResult<ListEconomicEventsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListEconomicEventsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-data/economic-calendar',
    ...options
});

export const runAnalysisAgents = <ThrowOnError extends boolean = false>(options?: Options<RunAnalysisAgentsData, ThrowOnError>): RequestResult<RunAnalysisAgentsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<RunAnalysisAgentsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/analysis/agents/run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getAgentStatus = <ThrowOnError extends boolean = false>(options?: Options<GetAgentStatusData, ThrowOnError>): RequestResult<GetAgentStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAgentStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/analysis/agents',
    ...options
});

export const setAgentEnabled = <ThrowOnError extends boolean = false>(options: Options<SetAgentEnabledData, ThrowOnError>): RequestResult<SetAgentEnabledResponses, SetAgentEnabledErrors, ThrowOnError> => (options.client ?? client).patch<SetAgentEnabledResponses, SetAgentEnabledErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/analysis/agents/{name}/enabled',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getCurrentSession = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentSessionData, ThrowOnError>): RequestResult<GetCurrentSessionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCurrentSessionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/analysis/session/current',
    ...options
});

export const getSessionTimes = <ThrowOnError extends boolean = false>(options?: Options<GetSessionTimesData, ThrowOnError>): RequestResult<GetSessionTimesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSessionTimesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/analysis/session/times',
    ...options
});

export const calculateOrb = <ThrowOnError extends boolean = false>(options?: Options<CalculateOrbData, ThrowOnError>): RequestResult<CalculateOrbResponses, CalculateOrbErrors, ThrowOnError> => (options?.client ?? client).post<CalculateOrbResponses, CalculateOrbErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/analysis/session/orb',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getSessionStats = <ThrowOnError extends boolean = false>(options?: Options<GetSessionStatsData, ThrowOnError>): RequestResult<GetSessionStatsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<GetSessionStatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/analysis/session/stats',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const analyzeOrderBook = <ThrowOnError extends boolean = false>(options?: Options<AnalyzeOrderBookData, ThrowOnError>): RequestResult<AnalyzeOrderBookResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AnalyzeOrderBookResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/analysis/orderbook/analyze',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const generateOrderBookHeatmap = <ThrowOnError extends boolean = false>(options?: Options<GenerateOrderBookHeatmapData, ThrowOnError>): RequestResult<GenerateOrderBookHeatmapResponses, unknown, ThrowOnError> => (options?.client ?? client).post<GenerateOrderBookHeatmapResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/analysis/orderbook/heatmap',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const analyzeConfluence = <ThrowOnError extends boolean = false>(options?: Options<AnalyzeConfluenceData, ThrowOnError>): RequestResult<AnalyzeConfluenceResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AnalyzeConfluenceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/analysis/confluence',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const analyzeConfluenceFromSignals = <ThrowOnError extends boolean = false>(options?: Options<AnalyzeConfluenceFromSignalsData, ThrowOnError>): RequestResult<AnalyzeConfluenceFromSignalsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AnalyzeConfluenceFromSignalsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/analysis/confluence/from-signals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getDiscoverySummary = <ThrowOnError extends boolean = false>(options?: Options<GetDiscoverySummaryData, ThrowOnError>): RequestResult<GetDiscoverySummaryResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetDiscoverySummaryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/summary',
    ...options
});

export const runStrategyDiscoveryWorkflow = <ThrowOnError extends boolean = false>(options?: Options<RunStrategyDiscoveryWorkflowData, ThrowOnError>): RequestResult<RunStrategyDiscoveryWorkflowResponses, RunStrategyDiscoveryWorkflowErrors, ThrowOnError> => (options?.client ?? client).post<RunStrategyDiscoveryWorkflowResponses, RunStrategyDiscoveryWorkflowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/workflows/strategy-discovery/run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const validateStrategyDefinition = <ThrowOnError extends boolean = false>(options?: Options<ValidateStrategyDefinitionData, ThrowOnError>): RequestResult<ValidateStrategyDefinitionResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ValidateStrategyDefinitionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-definitions/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listStrategyDefinitions = <ThrowOnError extends boolean = false>(options?: Options<ListStrategyDefinitionsData, ThrowOnError>): RequestResult<ListStrategyDefinitionsResponses, ListStrategyDefinitionsErrors, ThrowOnError> => (options?.client ?? client).get<ListStrategyDefinitionsResponses, ListStrategyDefinitionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-definitions',
    ...options
});

export const upsertStrategyDefinition = <ThrowOnError extends boolean = false>(options?: Options<UpsertStrategyDefinitionData, ThrowOnError>): RequestResult<UpsertStrategyDefinitionResponses, UpsertStrategyDefinitionErrors, ThrowOnError> => (options?.client ?? client).post<UpsertStrategyDefinitionResponses, UpsertStrategyDefinitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-definitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const createStrategyDefinitionValidationRun = <ThrowOnError extends boolean = false>(options?: Options<CreateStrategyDefinitionValidationRunData, ThrowOnError>): RequestResult<CreateStrategyDefinitionValidationRunResponses, CreateStrategyDefinitionValidationRunErrors, ThrowOnError> => (options?.client ?? client).post<CreateStrategyDefinitionValidationRunResponses, CreateStrategyDefinitionValidationRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-definitions/validation-runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const importFinanceStrategyCorpus = <ThrowOnError extends boolean = false>(options?: Options<ImportFinanceStrategyCorpusData, ThrowOnError>): RequestResult<ImportFinanceStrategyCorpusResponses, ImportFinanceStrategyCorpusErrors, ThrowOnError> => (options?.client ?? client).post<ImportFinanceStrategyCorpusResponses, ImportFinanceStrategyCorpusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-corpus/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getStrategyDefinition = <ThrowOnError extends boolean = false>(options: Options<GetStrategyDefinitionData, ThrowOnError>): RequestResult<GetStrategyDefinitionResponses, GetStrategyDefinitionErrors, ThrowOnError> => (options.client ?? client).get<GetStrategyDefinitionResponses, GetStrategyDefinitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-definitions/{id}',
    ...options
});

export const listStrategyDefinitionEvaluations = <ThrowOnError extends boolean = false>(options: Options<ListStrategyDefinitionEvaluationsData, ThrowOnError>): RequestResult<ListStrategyDefinitionEvaluationsResponses, ListStrategyDefinitionEvaluationsErrors, ThrowOnError> => (options.client ?? client).get<ListStrategyDefinitionEvaluationsResponses, ListStrategyDefinitionEvaluationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-definitions/{id}/evaluations',
    ...options
});

export const createStrategyDefinitionEvaluation = <ThrowOnError extends boolean = false>(options?: Options<CreateStrategyDefinitionEvaluationData, ThrowOnError>): RequestResult<CreateStrategyDefinitionEvaluationResponses, CreateStrategyDefinitionEvaluationErrors, ThrowOnError> => (options?.client ?? client).post<CreateStrategyDefinitionEvaluationResponses, CreateStrategyDefinitionEvaluationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-definition-evaluations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const validateStrategyBucketDefinition = <ThrowOnError extends boolean = false>(options?: Options<ValidateStrategyBucketDefinitionData, ThrowOnError>): RequestResult<ValidateStrategyBucketDefinitionResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ValidateStrategyBucketDefinitionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-buckets/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listStrategyBucketDefinitions = <ThrowOnError extends boolean = false>(options?: Options<ListStrategyBucketDefinitionsData, ThrowOnError>): RequestResult<ListStrategyBucketDefinitionsResponses, ListStrategyBucketDefinitionsErrors, ThrowOnError> => (options?.client ?? client).get<ListStrategyBucketDefinitionsResponses, ListStrategyBucketDefinitionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-buckets',
    ...options
});

export const upsertStrategyBucketDefinition = <ThrowOnError extends boolean = false>(options?: Options<UpsertStrategyBucketDefinitionData, ThrowOnError>): RequestResult<UpsertStrategyBucketDefinitionResponses, UpsertStrategyBucketDefinitionErrors, ThrowOnError> => (options?.client ?? client).post<UpsertStrategyBucketDefinitionResponses, UpsertStrategyBucketDefinitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-buckets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listStrategyBucketEvaluations = <ThrowOnError extends boolean = false>(options: Options<ListStrategyBucketEvaluationsData, ThrowOnError>): RequestResult<ListStrategyBucketEvaluationsResponses, ListStrategyBucketEvaluationsErrors, ThrowOnError> => (options.client ?? client).get<ListStrategyBucketEvaluationsResponses, ListStrategyBucketEvaluationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-buckets/{id}/evaluations',
    ...options
});

export const getStrategyBucketDefinition = <ThrowOnError extends boolean = false>(options: Options<GetStrategyBucketDefinitionData, ThrowOnError>): RequestResult<GetStrategyBucketDefinitionResponses, GetStrategyBucketDefinitionErrors, ThrowOnError> => (options.client ?? client).get<GetStrategyBucketDefinitionResponses, GetStrategyBucketDefinitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-buckets/{id}',
    ...options
});

export const patchStrategyBucketDefinition = <ThrowOnError extends boolean = false>(options: Options<PatchStrategyBucketDefinitionData, ThrowOnError>): RequestResult<PatchStrategyBucketDefinitionResponses, PatchStrategyBucketDefinitionErrors, ThrowOnError> => (options.client ?? client).patch<PatchStrategyBucketDefinitionResponses, PatchStrategyBucketDefinitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-buckets/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const dispatchStrategyBucketBacktest = <ThrowOnError extends boolean = false>(options: Options<DispatchStrategyBucketBacktestData, ThrowOnError>): RequestResult<DispatchStrategyBucketBacktestResponses, DispatchStrategyBucketBacktestErrors, ThrowOnError> => (options.client ?? client).post<DispatchStrategyBucketBacktestResponses, DispatchStrategyBucketBacktestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-buckets/{id}/backtest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createStrategyBucketEvaluation = <ThrowOnError extends boolean = false>(options?: Options<CreateStrategyBucketEvaluationData, ThrowOnError>): RequestResult<CreateStrategyBucketEvaluationResponses, CreateStrategyBucketEvaluationErrors, ThrowOnError> => (options?.client ?? client).post<CreateStrategyBucketEvaluationResponses, CreateStrategyBucketEvaluationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-bucket-evaluations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const validateStrategyExtensionDescriptor = <ThrowOnError extends boolean = false>(options?: Options<ValidateStrategyExtensionDescriptorData, ThrowOnError>): RequestResult<ValidateStrategyExtensionDescriptorResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ValidateStrategyExtensionDescriptorResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-extensions/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listStrategyExtensionDescriptors = <ThrowOnError extends boolean = false>(options?: Options<ListStrategyExtensionDescriptorsData, ThrowOnError>): RequestResult<ListStrategyExtensionDescriptorsResponses, ListStrategyExtensionDescriptorsErrors, ThrowOnError> => (options?.client ?? client).get<ListStrategyExtensionDescriptorsResponses, ListStrategyExtensionDescriptorsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-extensions',
    ...options
});

export const upsertStrategyExtensionDescriptor = <ThrowOnError extends boolean = false>(options?: Options<UpsertStrategyExtensionDescriptorData, ThrowOnError>): RequestResult<UpsertStrategyExtensionDescriptorResponses, UpsertStrategyExtensionDescriptorErrors, ThrowOnError> => (options?.client ?? client).post<UpsertStrategyExtensionDescriptorResponses, UpsertStrategyExtensionDescriptorErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-extensions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const resolveStrategyAdapters = <ThrowOnError extends boolean = false>(options?: Options<ResolveStrategyAdaptersData, ThrowOnError>): RequestResult<ResolveStrategyAdaptersResponses, ResolveStrategyAdaptersErrors, ThrowOnError> => (options?.client ?? client).post<ResolveStrategyAdaptersResponses, ResolveStrategyAdaptersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-adapters/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listStrategyAdapterResolutions = <ThrowOnError extends boolean = false>(options?: Options<ListStrategyAdapterResolutionsData, ThrowOnError>): RequestResult<ListStrategyAdapterResolutionsResponses, ListStrategyAdapterResolutionsErrors, ThrowOnError> => (options?.client ?? client).get<ListStrategyAdapterResolutionsResponses, ListStrategyAdapterResolutionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-adapter-resolutions',
    ...options
});

export const createStrategyAdapterResolution = <ThrowOnError extends boolean = false>(options?: Options<CreateStrategyAdapterResolutionData, ThrowOnError>): RequestResult<CreateStrategyAdapterResolutionResponses, CreateStrategyAdapterResolutionErrors, ThrowOnError> => (options?.client ?? client).post<CreateStrategyAdapterResolutionResponses, CreateStrategyAdapterResolutionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategy-adapter-resolutions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listFinanceDataBlockers = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceDataBlockersData, ThrowOnError>): RequestResult<ListFinanceDataBlockersResponses, ListFinanceDataBlockersErrors, ThrowOnError> => (options?.client ?? client).get<ListFinanceDataBlockersResponses, ListFinanceDataBlockersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/data-blockers',
    ...options
});

export const upsertFinanceDataBlocker = <ThrowOnError extends boolean = false>(options?: Options<UpsertFinanceDataBlockerData, ThrowOnError>): RequestResult<UpsertFinanceDataBlockerResponses, UpsertFinanceDataBlockerErrors, ThrowOnError> => (options?.client ?? client).post<UpsertFinanceDataBlockerResponses, UpsertFinanceDataBlockerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/data-blockers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listTopSources = <ThrowOnError extends boolean = false>(options?: Options<ListTopSourcesData, ThrowOnError>): RequestResult<ListTopSourcesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListTopSourcesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/sources/top',
    ...options
});

export const listSources = <ThrowOnError extends boolean = false>(options?: Options<ListSourcesData, ThrowOnError>): RequestResult<ListSourcesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListSourcesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/sources',
    ...options
});

export const createSource = <ThrowOnError extends boolean = false>(options?: Options<CreateSourceData, ThrowOnError>): RequestResult<CreateSourceResponses, CreateSourceErrors, ThrowOnError> => (options?.client ?? client).post<CreateSourceResponses, CreateSourceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/sources',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getSource = <ThrowOnError extends boolean = false>(options: Options<GetSourceData, ThrowOnError>): RequestResult<GetSourceResponses, GetSourceErrors, ThrowOnError> => (options.client ?? client).get<GetSourceResponses, GetSourceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/sources/{id}',
    ...options
});

export const getContentStats = <ThrowOnError extends boolean = false>(options?: Options<GetContentStatsData, ThrowOnError>): RequestResult<GetContentStatsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetContentStatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/content/stats',
    ...options
});

export const listHarvestedContent = <ThrowOnError extends boolean = false>(options?: Options<ListHarvestedContentData, ThrowOnError>): RequestResult<ListHarvestedContentResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListHarvestedContentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/content',
    ...options
});

export const getContentDetails = <ThrowOnError extends boolean = false>(options: Options<GetContentDetailsData, ThrowOnError>): RequestResult<GetContentDetailsResponses, GetContentDetailsErrors, ThrowOnError> => (options.client ?? client).get<GetContentDetailsResponses, GetContentDetailsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/content/{id}',
    ...options
});

export const listApprovedStrategies = <ThrowOnError extends boolean = false>(options?: Options<ListApprovedStrategiesData, ThrowOnError>): RequestResult<ListApprovedStrategiesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListApprovedStrategiesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategies/approved',
    ...options
});

export const getStrategyDiscoveryStats = <ThrowOnError extends boolean = false>(options?: Options<GetStrategyDiscoveryStatsData, ThrowOnError>): RequestResult<GetStrategyDiscoveryStatsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetStrategyDiscoveryStatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategies/stats',
    ...options
});

export const listDiscoveredStrategies = <ThrowOnError extends boolean = false>(options?: Options<ListDiscoveredStrategiesData, ThrowOnError>): RequestResult<ListDiscoveredStrategiesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListDiscoveredStrategiesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategies',
    ...options
});

export const getDiscoveredStrategy = <ThrowOnError extends boolean = false>(options: Options<GetDiscoveredStrategyData, ThrowOnError>): RequestResult<GetDiscoveredStrategyResponses, GetDiscoveredStrategyErrors, ThrowOnError> => (options.client ?? client).get<GetDiscoveredStrategyResponses, GetDiscoveredStrategyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategies/{id}',
    ...options
});

export const updateDiscoveredStrategyStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateDiscoveredStrategyStatusData, ThrowOnError>): RequestResult<UpdateDiscoveredStrategyStatusResponses, UpdateDiscoveredStrategyStatusErrors, ThrowOnError> => (options.client ?? client).patch<UpdateDiscoveredStrategyStatusResponses, UpdateDiscoveredStrategyStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/strategies/{id}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAssetSentiment = <ThrowOnError extends boolean = false>(options: Options<GetAssetSentimentData, ThrowOnError>): RequestResult<GetAssetSentimentResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAssetSentimentResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/signals/sentiment/{asset}',
    ...options
});

export const getSignalAccuracy = <ThrowOnError extends boolean = false>(options?: Options<GetSignalAccuracyData, ThrowOnError>): RequestResult<GetSignalAccuracyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSignalAccuracyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/signals/accuracy',
    ...options
});

export const getSignalActivity = <ThrowOnError extends boolean = false>(options?: Options<GetSignalActivityData, ThrowOnError>): RequestResult<GetSignalActivityResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSignalActivityResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/signals/activity',
    ...options
});

export const listSignals = <ThrowOnError extends boolean = false>(options?: Options<ListSignalsData, ThrowOnError>): RequestResult<ListSignalsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListSignalsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/discovery/signals',
    ...options
});

export const testTradingViewWebhook = <ThrowOnError extends boolean = false>(options?: Options<TestTradingViewWebhookData, ThrowOnError>): RequestResult<TestTradingViewWebhookResponses, unknown, ThrowOnError> => (options?.client ?? client).post<TestTradingViewWebhookResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/webhooks/tradingview/test',
    ...options
});

export const generatePineScript = <ThrowOnError extends boolean = false>(options?: Options<GeneratePineScriptData, ThrowOnError>): RequestResult<GeneratePineScriptResponses, unknown, ThrowOnError> => (options?.client ?? client).post<GeneratePineScriptResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/webhooks/tradingview/pine-script',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getTradingViewConfig = <ThrowOnError extends boolean = false>(options?: Options<GetTradingViewConfigData, ThrowOnError>): RequestResult<GetTradingViewConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetTradingViewConfigResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/webhooks/tradingview/config',
    ...options
});

export const rotateTradingViewToken = <ThrowOnError extends boolean = false>(options?: Options<RotateTradingViewTokenData, ThrowOnError>): RequestResult<RotateTradingViewTokenResponses, unknown, ThrowOnError> => (options?.client ?? client).post<RotateTradingViewTokenResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/webhooks/tradingview/token',
    ...options
});

export const receiveTradingViewAlert = <ThrowOnError extends boolean = false>(options: Options<ReceiveTradingViewAlertData, ThrowOnError>): RequestResult<ReceiveTradingViewAlertResponses, ReceiveTradingViewAlertErrors, ThrowOnError> => (options.client ?? client).post<ReceiveTradingViewAlertResponses, ReceiveTradingViewAlertErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/webhooks/tradingview/ingest/{token}',
    ...options
});

export const listWatchlist = <ThrowOnError extends boolean = false>(options?: Options<ListWatchlistData, ThrowOnError>): RequestResult<ListWatchlistResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListWatchlistResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/watchlists',
    ...options
});

export const addToWatchlist = <ThrowOnError extends boolean = false>(options?: Options<AddToWatchlistData, ThrowOnError>): RequestResult<AddToWatchlistResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AddToWatchlistResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/watchlists',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const removeFromWatchlist = <ThrowOnError extends boolean = false>(options: Options<RemoveFromWatchlistData, ThrowOnError>): RequestResult<RemoveFromWatchlistResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RemoveFromWatchlistResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/watchlists/{ticker}',
    ...options
});

export const getWatchlistEntry = <ThrowOnError extends boolean = false>(options: Options<GetWatchlistEntryData, ThrowOnError>): RequestResult<GetWatchlistEntryResponses, GetWatchlistEntryErrors, ThrowOnError> => (options.client ?? client).get<GetWatchlistEntryResponses, GetWatchlistEntryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/watchlists/{ticker}',
    ...options
});

export const listAnalyses = <ThrowOnError extends boolean = false>(options: Options<ListAnalysesData, ThrowOnError>): RequestResult<ListAnalysesResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListAnalysesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/watchlists/{ticker}/analyses',
    ...options
});

export const getAnalysis = <ThrowOnError extends boolean = false>(options: Options<GetAnalysisData, ThrowOnError>): RequestResult<GetAnalysisResponses, GetAnalysisErrors, ThrowOnError> => (options.client ?? client).get<GetAnalysisResponses, GetAnalysisErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/watchlists/{ticker}/analyses/{analysisId}',
    ...options
});

export const analyzeTickerAdHoc = <ThrowOnError extends boolean = false>(options: Options<AnalyzeTickerAdHocData, ThrowOnError>): RequestResult<AnalyzeTickerAdHocResponses, unknown, ThrowOnError> => (options.client ?? client).post<AnalyzeTickerAdHocResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/watchlists/{ticker}/analyze',
    ...options
});

export const comparePortfolios = <ThrowOnError extends boolean = false>(options: Options<ComparePortfoliosData, ThrowOnError>): RequestResult<ComparePortfoliosResponses, ComparePortfoliosErrors, ThrowOnError> => (options.client ?? client).get<ComparePortfoliosResponses, ComparePortfoliosErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/compare',
    ...options
});

export const getRiskProfiles = <ThrowOnError extends boolean = false>(options?: Options<GetRiskProfilesData, ThrowOnError>): RequestResult<GetRiskProfilesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRiskProfilesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/risk-profiles',
    ...options
});

export const listPortfolios = <ThrowOnError extends boolean = false>(options?: Options<ListPortfoliosData, ThrowOnError>): RequestResult<ListPortfoliosResponses, ListPortfoliosErrors, ThrowOnError> => (options?.client ?? client).get<ListPortfoliosResponses, ListPortfoliosErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios',
    ...options
});

export const createPortfolio = <ThrowOnError extends boolean = false>(options?: Options<CreatePortfolioData, ThrowOnError>): RequestResult<CreatePortfolioResponses, CreatePortfolioErrors, ThrowOnError> => (options?.client ?? client).post<CreatePortfolioResponses, CreatePortfolioErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getPortfolio = <ThrowOnError extends boolean = false>(options: Options<GetPortfolioData, ThrowOnError>): RequestResult<GetPortfolioResponses, GetPortfolioErrors, ThrowOnError> => (options.client ?? client).get<GetPortfolioResponses, GetPortfolioErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/{id}',
    ...options
});

export const updatePortfolio = <ThrowOnError extends boolean = false>(options: Options<UpdatePortfolioData, ThrowOnError>): RequestResult<UpdatePortfolioResponses, UpdatePortfolioErrors, ThrowOnError> => (options.client ?? client).put<UpdatePortfolioResponses, UpdatePortfolioErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getPerformanceMetrics = <ThrowOnError extends boolean = false>(options: Options<GetPerformanceMetricsData, ThrowOnError>): RequestResult<GetPerformanceMetricsResponses, GetPerformanceMetricsErrors, ThrowOnError> => (options.client ?? client).get<GetPerformanceMetricsResponses, GetPerformanceMetricsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/{id}/performance',
    ...options
});

export const listPortfolioSnapshots = <ThrowOnError extends boolean = false>(options: Options<ListPortfolioSnapshotsData, ThrowOnError>): RequestResult<ListPortfolioSnapshotsResponses, ListPortfolioSnapshotsErrors, ThrowOnError> => (options.client ?? client).get<ListPortfolioSnapshotsResponses, ListPortfolioSnapshotsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/{id}/snapshots',
    ...options
});

export const getPortfolioSnapshot = <ThrowOnError extends boolean = false>(options: Options<GetPortfolioSnapshotData, ThrowOnError>): RequestResult<GetPortfolioSnapshotResponses, GetPortfolioSnapshotErrors, ThrowOnError> => (options.client ?? client).get<GetPortfolioSnapshotResponses, GetPortfolioSnapshotErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/{id}/snapshots/{snapshotId}',
    ...options
});

export const getRecommendation = <ThrowOnError extends boolean = false>(options: Options<GetRecommendationData, ThrowOnError>): RequestResult<GetRecommendationResponses, GetRecommendationErrors, ThrowOnError> => (options.client ?? client).get<GetRecommendationResponses, GetRecommendationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/{id}/recommendations',
    ...options
});

export const approveRecommendation = <ThrowOnError extends boolean = false>(options: Options<ApproveRecommendationData, ThrowOnError>): RequestResult<ApproveRecommendationResponses, ApproveRecommendationErrors, ThrowOnError> => (options.client ?? client).post<ApproveRecommendationResponses, ApproveRecommendationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/{id}/recommendations/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const rejectRecommendation = <ThrowOnError extends boolean = false>(options: Options<RejectRecommendationData, ThrowOnError>): RequestResult<RejectRecommendationResponses, RejectRecommendationErrors, ThrowOnError> => (options.client ?? client).post<RejectRecommendationResponses, RejectRecommendationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/{id}/recommendations/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listHoldings = <ThrowOnError extends boolean = false>(options: Options<ListHoldingsData, ThrowOnError>): RequestResult<ListHoldingsResponses, ListHoldingsErrors, ThrowOnError> => (options.client ?? client).get<ListHoldingsResponses, ListHoldingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/{id}/holdings',
    ...options
});

export const createHolding = <ThrowOnError extends boolean = false>(options: Options<CreateHoldingData, ThrowOnError>): RequestResult<CreateHoldingResponses, CreateHoldingErrors, ThrowOnError> => (options.client ?? client).post<CreateHoldingResponses, CreateHoldingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/{id}/holdings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteHolding = <ThrowOnError extends boolean = false>(options: Options<DeleteHoldingData, ThrowOnError>): RequestResult<DeleteHoldingResponses, DeleteHoldingErrors, ThrowOnError> => (options.client ?? client).delete<DeleteHoldingResponses, DeleteHoldingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/{id}/holdings/{ticker}',
    ...options
});

export const updateHolding = <ThrowOnError extends boolean = false>(options: Options<UpdateHoldingData, ThrowOnError>): RequestResult<UpdateHoldingResponses, UpdateHoldingErrors, ThrowOnError> => (options.client ?? client).put<UpdateHoldingResponses, UpdateHoldingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/{id}/holdings/{ticker}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listContractEvents = <ThrowOnError extends boolean = false>(options?: Options<ListContractEventsData, ThrowOnError>): RequestResult<ListContractEventsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListContractEventsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/contracts/events',
    ...options
});

export const getContractHealth = <ThrowOnError extends boolean = false>(options?: Options<GetContractHealthData, ThrowOnError>): RequestResult<GetContractHealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetContractHealthResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/contracts/health',
    ...options
});

export const applyContractResolution = <ThrowOnError extends boolean = false>(options?: Options<ApplyContractResolutionData, ThrowOnError>): RequestResult<ApplyContractResolutionResponses, ApplyContractResolutionErrors, ThrowOnError> => (options?.client ?? client).post<ApplyContractResolutionResponses, ApplyContractResolutionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/contracts/apply',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const checkAlertPrice = <ThrowOnError extends boolean = false>(options?: Options<CheckAlertPriceData, ThrowOnError>): RequestResult<CheckAlertPriceResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CheckAlertPriceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/alerts/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listAlertsBySymbol = <ThrowOnError extends boolean = false>(options: Options<ListAlertsBySymbolData, ThrowOnError>): RequestResult<ListAlertsBySymbolResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListAlertsBySymbolResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/alerts/symbol/{symbol}',
    ...options
});

export const listAlerts = <ThrowOnError extends boolean = false>(options?: Options<ListAlertsData, ThrowOnError>): RequestResult<ListAlertsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAlertsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/alerts',
    ...options
});

export const createAlert = <ThrowOnError extends boolean = false>(options?: Options<CreateAlertData, ThrowOnError>): RequestResult<CreateAlertResponses, CreateAlertErrors, ThrowOnError> => (options?.client ?? client).post<CreateAlertResponses, CreateAlertErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/alerts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteAlert = <ThrowOnError extends boolean = false>(options: Options<DeleteAlertData, ThrowOnError>): RequestResult<DeleteAlertResponses, DeleteAlertErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAlertResponses, DeleteAlertErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/alerts/{id}',
    ...options
});

export const setAlertEnabled = <ThrowOnError extends boolean = false>(options: Options<SetAlertEnabledData, ThrowOnError>): RequestResult<SetAlertEnabledResponses, SetAlertEnabledErrors, ThrowOnError> => (options.client ?? client).patch<SetAlertEnabledResponses, SetAlertEnabledErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/alerts/{id}/enabled',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const resetAlert = <ThrowOnError extends boolean = false>(options: Options<ResetAlertData, ThrowOnError>): RequestResult<ResetAlertResponses, ResetAlertErrors, ThrowOnError> => (options.client ?? client).post<ResetAlertResponses, ResetAlertErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/alerts/{id}/reset',
    ...options
});

export const listAlertRules = <ThrowOnError extends boolean = false>(options?: Options<ListAlertRulesData, ThrowOnError>): RequestResult<ListAlertRulesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAlertRulesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/alert-rules',
    ...options
});

export const createAlertRule = <ThrowOnError extends boolean = false>(options: Options<CreateAlertRuleData, ThrowOnError>): RequestResult<CreateAlertRuleResponses, CreateAlertRuleErrors, ThrowOnError> => (options.client ?? client).post<CreateAlertRuleResponses, CreateAlertRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/alert-rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteAlertRule = <ThrowOnError extends boolean = false>(options: Options<DeleteAlertRuleData, ThrowOnError>): RequestResult<DeleteAlertRuleResponses, DeleteAlertRuleErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAlertRuleResponses, DeleteAlertRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/alert-rules/{id}',
    ...options
});

export const getAlertRule = <ThrowOnError extends boolean = false>(options: Options<GetAlertRuleData, ThrowOnError>): RequestResult<GetAlertRuleResponses, GetAlertRuleErrors, ThrowOnError> => (options.client ?? client).get<GetAlertRuleResponses, GetAlertRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/alert-rules/{id}',
    ...options
});

export const updateAlertRule = <ThrowOnError extends boolean = false>(options: Options<UpdateAlertRuleData, ThrowOnError>): RequestResult<UpdateAlertRuleResponses, UpdateAlertRuleErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAlertRuleResponses, UpdateAlertRuleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/alert-rules/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listMarketEventReactionTypes = <ThrowOnError extends boolean = false>(options?: Options<ListMarketEventReactionTypesData, ThrowOnError>): RequestResult<ListMarketEventReactionTypesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMarketEventReactionTypesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-event-reactions/types',
    ...options
});

export const listMarketEventReactions = <ThrowOnError extends boolean = false>(options?: Options<ListMarketEventReactionsData, ThrowOnError>): RequestResult<ListMarketEventReactionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMarketEventReactionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-event-reactions',
    ...options
});

export const createMarketEventReaction = <ThrowOnError extends boolean = false>(options: Options<CreateMarketEventReactionData, ThrowOnError>): RequestResult<CreateMarketEventReactionResponses, CreateMarketEventReactionErrors, ThrowOnError> => (options.client ?? client).post<CreateMarketEventReactionResponses, CreateMarketEventReactionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-event-reactions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteMarketEventReaction = <ThrowOnError extends boolean = false>(options: Options<DeleteMarketEventReactionData, ThrowOnError>): RequestResult<DeleteMarketEventReactionResponses, DeleteMarketEventReactionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMarketEventReactionResponses, DeleteMarketEventReactionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/market-event-reactions/{id}',
    ...options
});

export const listWalletWatches = <ThrowOnError extends boolean = false>(options?: Options<ListWalletWatchesData, ThrowOnError>): RequestResult<ListWalletWatchesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListWalletWatchesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/wallets',
    ...options
});

export const createWalletWatch = <ThrowOnError extends boolean = false>(options: Options<CreateWalletWatchData, ThrowOnError>): RequestResult<CreateWalletWatchResponses, CreateWalletWatchErrors, ThrowOnError> => (options.client ?? client).post<CreateWalletWatchResponses, CreateWalletWatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/wallets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteWalletWatch = <ThrowOnError extends boolean = false>(options: Options<DeleteWalletWatchData, ThrowOnError>): RequestResult<DeleteWalletWatchResponses, DeleteWalletWatchErrors, ThrowOnError> => (options.client ?? client).delete<DeleteWalletWatchResponses, DeleteWalletWatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/wallets/{id}',
    ...options
});

export const getWalletWatch = <ThrowOnError extends boolean = false>(options: Options<GetWalletWatchData, ThrowOnError>): RequestResult<GetWalletWatchResponses, GetWalletWatchErrors, ThrowOnError> => (options.client ?? client).get<GetWalletWatchResponses, GetWalletWatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/wallets/{id}',
    ...options
});

export const listFinanceStrategyRuns = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceStrategyRunsData, ThrowOnError>): RequestResult<ListFinanceStrategyRunsResponses, ListFinanceStrategyRunsErrors, ThrowOnError> => (options?.client ?? client).get<ListFinanceStrategyRunsResponses, ListFinanceStrategyRunsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-runs',
    ...options
});

export const createFinanceStrategyRun = <ThrowOnError extends boolean = false>(options?: Options<CreateFinanceStrategyRunData, ThrowOnError>): RequestResult<CreateFinanceStrategyRunResponses, CreateFinanceStrategyRunErrors, ThrowOnError> => (options?.client ?? client).post<CreateFinanceStrategyRunResponses, CreateFinanceStrategyRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listFinanceStrategyRunRequests = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceStrategyRunRequestsData, ThrowOnError>): RequestResult<ListFinanceStrategyRunRequestsResponses, ListFinanceStrategyRunRequestsErrors, ThrowOnError> => (options?.client ?? client).get<ListFinanceStrategyRunRequestsResponses, ListFinanceStrategyRunRequestsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-runs/requests',
    ...options
});

export const createFinanceStrategyRunRequest = <ThrowOnError extends boolean = false>(options?: Options<CreateFinanceStrategyRunRequestData, ThrowOnError>): RequestResult<CreateFinanceStrategyRunRequestResponses, CreateFinanceStrategyRunRequestErrors, ThrowOnError> => (options?.client ?? client).post<CreateFinanceStrategyRunRequestResponses, CreateFinanceStrategyRunRequestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-runs/requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getFinanceStrategyRunRequest = <ThrowOnError extends boolean = false>(options: Options<GetFinanceStrategyRunRequestData, ThrowOnError>): RequestResult<GetFinanceStrategyRunRequestResponses, GetFinanceStrategyRunRequestErrors, ThrowOnError> => (options.client ?? client).get<GetFinanceStrategyRunRequestResponses, GetFinanceStrategyRunRequestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-runs/requests/{id}',
    ...options
});

export const getFinanceStrategyRun = <ThrowOnError extends boolean = false>(options: Options<GetFinanceStrategyRunData, ThrowOnError>): RequestResult<GetFinanceStrategyRunResponses, GetFinanceStrategyRunErrors, ThrowOnError> => (options.client ?? client).get<GetFinanceStrategyRunResponses, GetFinanceStrategyRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-runs/{id}',
    ...options
});

export const getStrategyRunResult = <ThrowOnError extends boolean = false>(options: Options<GetStrategyRunResultData, ThrowOnError>): RequestResult<GetStrategyRunResultResponses, GetStrategyRunResultErrors, ThrowOnError> => (options.client ?? client).get<GetStrategyRunResultResponses, GetStrategyRunResultErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-runs/{id}/result',
    ...options
});

export const getStrategyRunArtifact = <ThrowOnError extends boolean = false>(options: Options<GetStrategyRunArtifactData, ThrowOnError>): RequestResult<GetStrategyRunArtifactResponses, GetStrategyRunArtifactErrors, ThrowOnError> => (options.client ?? client).get<GetStrategyRunArtifactResponses, GetStrategyRunArtifactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-runs/{id}/artifacts/{kind}',
    ...options
});

export const getStrategyRunAnalytics = <ThrowOnError extends boolean = false>(options: Options<GetStrategyRunAnalyticsData, ThrowOnError>): RequestResult<GetStrategyRunAnalyticsResponses, GetStrategyRunAnalyticsErrors, ThrowOnError> => (options.client ?? client).get<GetStrategyRunAnalyticsResponses, GetStrategyRunAnalyticsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-runs/{id}/analytics',
    ...options
});

export const listStrategyDefinitionGroups = <ThrowOnError extends boolean = false>(options?: Options<ListStrategyDefinitionGroupsData, ThrowOnError>): RequestResult<ListStrategyDefinitionGroupsResponses, ListStrategyDefinitionGroupsErrors, ThrowOnError> => (options?.client ?? client).get<ListStrategyDefinitionGroupsResponses, ListStrategyDefinitionGroupsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-definitions/summaries/groups',
    ...options
});

export const listStrategyDefinitionSummaries = <ThrowOnError extends boolean = false>(options?: Options<ListStrategyDefinitionSummariesData, ThrowOnError>): RequestResult<ListStrategyDefinitionSummariesResponses, ListStrategyDefinitionSummariesErrors, ThrowOnError> => (options?.client ?? client).get<ListStrategyDefinitionSummariesResponses, ListStrategyDefinitionSummariesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-definitions/summaries',
    ...options
});

export const listStrategyDefinitionRuns = <ThrowOnError extends boolean = false>(options: Options<ListStrategyDefinitionRunsData, ThrowOnError>): RequestResult<ListStrategyDefinitionRunsResponses, ListStrategyDefinitionRunsErrors, ThrowOnError> => (options.client ?? client).get<ListStrategyDefinitionRunsResponses, ListStrategyDefinitionRunsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-definitions/{id}/runs',
    ...options
});

export const createStrategyDefinitionRun = <ThrowOnError extends boolean = false>(options: Options<CreateStrategyDefinitionRunData, ThrowOnError>): RequestResult<CreateStrategyDefinitionRunResponses, CreateStrategyDefinitionRunErrors, ThrowOnError> => (options.client ?? client).post<CreateStrategyDefinitionRunResponses, CreateStrategyDefinitionRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-definitions/{id}/runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const amendStrategyDefinitionParameters = <ThrowOnError extends boolean = false>(options: Options<AmendStrategyDefinitionParametersData, ThrowOnError>): RequestResult<AmendStrategyDefinitionParametersResponses, AmendStrategyDefinitionParametersErrors, ThrowOnError> => (options.client ?? client).post<AmendStrategyDefinitionParametersResponses, AmendStrategyDefinitionParametersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-definitions/{id}/parameters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const forkStrategyDefinition = <ThrowOnError extends boolean = false>(options: Options<ForkStrategyDefinitionData, ThrowOnError>): RequestResult<ForkStrategyDefinitionResponses, ForkStrategyDefinitionErrors, ThrowOnError> => (options.client ?? client).post<ForkStrategyDefinitionResponses, ForkStrategyDefinitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-definitions/{id}/fork',
    ...options
});

export const listFinanceStrategyTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceStrategyTemplatesData, ThrowOnError>): RequestResult<ListFinanceStrategyTemplatesResponses, ListFinanceStrategyTemplatesErrors, ThrowOnError> => (options?.client ?? client).get<ListFinanceStrategyTemplatesResponses, ListFinanceStrategyTemplatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-templates',
    ...options
});

export const getFinanceStrategyTemplate = <ThrowOnError extends boolean = false>(options: Options<GetFinanceStrategyTemplateData, ThrowOnError>): RequestResult<GetFinanceStrategyTemplateResponses, GetFinanceStrategyTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetFinanceStrategyTemplateResponses, GetFinanceStrategyTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-templates/{id}',
    ...options
});

export const previewFinanceStrategyTemplate = <ThrowOnError extends boolean = false>(options?: Options<PreviewFinanceStrategyTemplateData, ThrowOnError>): RequestResult<PreviewFinanceStrategyTemplateResponses, PreviewFinanceStrategyTemplateErrors, ThrowOnError> => (options?.client ?? client).post<PreviewFinanceStrategyTemplateResponses, PreviewFinanceStrategyTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-templates/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const enqueueFinanceStrategyTemplateRun = <ThrowOnError extends boolean = false>(options?: Options<EnqueueFinanceStrategyTemplateRunData, ThrowOnError>): RequestResult<EnqueueFinanceStrategyTemplateRunResponses, EnqueueFinanceStrategyTemplateRunErrors, ThrowOnError> => (options?.client ?? client).post<EnqueueFinanceStrategyTemplateRunResponses, EnqueueFinanceStrategyTemplateRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-templates/enqueue-run',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listFinanceProviderUnlockPrompts = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceProviderUnlockPromptsData, ThrowOnError>): RequestResult<ListFinanceProviderUnlockPromptsResponses, ListFinanceProviderUnlockPromptsErrors, ThrowOnError> => (options?.client ?? client).get<ListFinanceProviderUnlockPromptsResponses, ListFinanceProviderUnlockPromptsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/provider-unlocks',
    ...options
});

export const getFinanceProviderUnlockPrompt = <ThrowOnError extends boolean = false>(options: Options<GetFinanceProviderUnlockPromptData, ThrowOnError>): RequestResult<GetFinanceProviderUnlockPromptResponses, GetFinanceProviderUnlockPromptErrors, ThrowOnError> => (options.client ?? client).get<GetFinanceProviderUnlockPromptResponses, GetFinanceProviderUnlockPromptErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/provider-unlocks/{unlockId}',
    ...options
});

export const listFinanceStrategyCostModels = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceStrategyCostModelsData, ThrowOnError>): RequestResult<ListFinanceStrategyCostModelsResponses, ListFinanceStrategyCostModelsErrors, ThrowOnError> => (options?.client ?? client).get<ListFinanceStrategyCostModelsResponses, ListFinanceStrategyCostModelsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-execution-config/cost-models',
    ...options
});

export const createFinanceStrategyCostModel = <ThrowOnError extends boolean = false>(options?: Options<CreateFinanceStrategyCostModelData, ThrowOnError>): RequestResult<CreateFinanceStrategyCostModelResponses, CreateFinanceStrategyCostModelErrors, ThrowOnError> => (options?.client ?? client).post<CreateFinanceStrategyCostModelResponses, CreateFinanceStrategyCostModelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-execution-config/cost-models',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getFinanceStrategyCostModel = <ThrowOnError extends boolean = false>(options: Options<GetFinanceStrategyCostModelData, ThrowOnError>): RequestResult<GetFinanceStrategyCostModelResponses, GetFinanceStrategyCostModelErrors, ThrowOnError> => (options.client ?? client).get<GetFinanceStrategyCostModelResponses, GetFinanceStrategyCostModelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-execution-config/cost-models/{id}',
    ...options
});

export const listFinanceStrategyLifecycleTransitions = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceStrategyLifecycleTransitionsData, ThrowOnError>): RequestResult<ListFinanceStrategyLifecycleTransitionsResponses, ListFinanceStrategyLifecycleTransitionsErrors, ThrowOnError> => (options?.client ?? client).get<ListFinanceStrategyLifecycleTransitionsResponses, ListFinanceStrategyLifecycleTransitionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-execution-config/lifecycle-transitions',
    ...options
});

export const createFinanceStrategyLifecycleTransition = <ThrowOnError extends boolean = false>(options?: Options<CreateFinanceStrategyLifecycleTransitionData, ThrowOnError>): RequestResult<CreateFinanceStrategyLifecycleTransitionResponses, CreateFinanceStrategyLifecycleTransitionErrors, ThrowOnError> => (options?.client ?? client).post<CreateFinanceStrategyLifecycleTransitionResponses, CreateFinanceStrategyLifecycleTransitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-execution-config/lifecycle-transitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const commitFinanceStrategyLifecycleTransition = <ThrowOnError extends boolean = false>(options?: Options<CommitFinanceStrategyLifecycleTransitionData, ThrowOnError>): RequestResult<CommitFinanceStrategyLifecycleTransitionResponses, CommitFinanceStrategyLifecycleTransitionErrors, ThrowOnError> => (options?.client ?? client).post<CommitFinanceStrategyLifecycleTransitionResponses, CommitFinanceStrategyLifecycleTransitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-execution-config/lifecycle-transitions/commit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getFinanceArtifactPreview = <ThrowOnError extends boolean = false>(options: Options<GetFinanceArtifactPreviewData, ThrowOnError>): RequestResult<GetFinanceArtifactPreviewResponses, GetFinanceArtifactPreviewErrors, ThrowOnError> => (options.client ?? client).get<GetFinanceArtifactPreviewResponses, GetFinanceArtifactPreviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/artifacts/{artifactId}/preview',
    ...options
});

export const listFinanceResearchWorkflows = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceResearchWorkflowsData, ThrowOnError>): RequestResult<ListFinanceResearchWorkflowsResponses, ListFinanceResearchWorkflowsErrors, ThrowOnError> => (options?.client ?? client).get<ListFinanceResearchWorkflowsResponses, ListFinanceResearchWorkflowsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/research-workflows',
    ...options
});

export const startFinanceResearchWorkflowRun = <ThrowOnError extends boolean = false>(options: Options<StartFinanceResearchWorkflowRunData, ThrowOnError>): RequestResult<StartFinanceResearchWorkflowRunResponses, StartFinanceResearchWorkflowRunErrors, ThrowOnError> => (options.client ?? client).post<StartFinanceResearchWorkflowRunResponses, StartFinanceResearchWorkflowRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/research-workflows/{id}/runs',
    ...options
});

export const listFinancePlannerRecommendations = <ThrowOnError extends boolean = false>(options?: Options<ListFinancePlannerRecommendationsData, ThrowOnError>): RequestResult<ListFinancePlannerRecommendationsResponses, ListFinancePlannerRecommendationsErrors, ThrowOnError> => (options?.client ?? client).get<ListFinancePlannerRecommendationsResponses, ListFinancePlannerRecommendationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/planner-recommendations',
    ...options
});

export const getFinanceBucketComposition = <ThrowOnError extends boolean = false>(options?: Options<GetFinanceBucketCompositionData, ThrowOnError>): RequestResult<GetFinanceBucketCompositionResponses, GetFinanceBucketCompositionErrors, ThrowOnError> => (options?.client ?? client).get<GetFinanceBucketCompositionResponses, GetFinanceBucketCompositionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/bucket-composition',
    ...options
});

export const applyFinanceBucketDecision = <ThrowOnError extends boolean = false>(options: Options<ApplyFinanceBucketDecisionData, ThrowOnError>): RequestResult<ApplyFinanceBucketDecisionResponses, ApplyFinanceBucketDecisionErrors, ThrowOnError> => (options.client ?? client).post<ApplyFinanceBucketDecisionResponses, ApplyFinanceBucketDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/bucket-composition/decisions/{id}/apply',
    ...options
});

export const proposeFinanceBucketReweight = <ThrowOnError extends boolean = false>(options?: Options<ProposeFinanceBucketReweightData, ThrowOnError>): RequestResult<ProposeFinanceBucketReweightResponses, ProposeFinanceBucketReweightErrors, ThrowOnError> => (options?.client ?? client).post<ProposeFinanceBucketReweightResponses, ProposeFinanceBucketReweightErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/bucket-composition/decisions/propose-reweight',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listFinanceIndicatorDecisions = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceIndicatorDecisionsData, ThrowOnError>): RequestResult<ListFinanceIndicatorDecisionsResponses, ListFinanceIndicatorDecisionsErrors, ThrowOnError> => (options?.client ?? client).get<ListFinanceIndicatorDecisionsResponses, ListFinanceIndicatorDecisionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/indicator-decisions',
    ...options
});

export const enqueueFinanceIndicatorDecision = <ThrowOnError extends boolean = false>(options?: Options<EnqueueFinanceIndicatorDecisionData, ThrowOnError>): RequestResult<EnqueueFinanceIndicatorDecisionResponses, EnqueueFinanceIndicatorDecisionErrors, ThrowOnError> => (options?.client ?? client).post<EnqueueFinanceIndicatorDecisionResponses, EnqueueFinanceIndicatorDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/indicator-decisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getFinanceIndicatorDecision = <ThrowOnError extends boolean = false>(options: Options<GetFinanceIndicatorDecisionData, ThrowOnError>): RequestResult<GetFinanceIndicatorDecisionResponses, GetFinanceIndicatorDecisionErrors, ThrowOnError> => (options.client ?? client).get<GetFinanceIndicatorDecisionResponses, GetFinanceIndicatorDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/indicator-decisions/{requestId}',
    ...options
});

export const listFinanceStrategyDecisions = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceStrategyDecisionsData, ThrowOnError>): RequestResult<ListFinanceStrategyDecisionsResponses, ListFinanceStrategyDecisionsErrors, ThrowOnError> => (options?.client ?? client).get<ListFinanceStrategyDecisionsResponses, ListFinanceStrategyDecisionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-decisions',
    ...options
});

export const getFinanceStrategyDecision = <ThrowOnError extends boolean = false>(options: Options<GetFinanceStrategyDecisionData, ThrowOnError>): RequestResult<GetFinanceStrategyDecisionResponses, GetFinanceStrategyDecisionErrors, ThrowOnError> => (options.client ?? client).get<GetFinanceStrategyDecisionResponses, GetFinanceStrategyDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-decisions/{definitionId}',
    ...options
});

export const evaluateFinanceStrategyDecision = <ThrowOnError extends boolean = false>(options: Options<EvaluateFinanceStrategyDecisionData, ThrowOnError>): RequestResult<EvaluateFinanceStrategyDecisionResponses, EvaluateFinanceStrategyDecisionErrors, ThrowOnError> => (options.client ?? client).post<EvaluateFinanceStrategyDecisionResponses, EvaluateFinanceStrategyDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-decisions/{definitionId}/evaluate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const evaluateFinanceStrategyDefinition = <ThrowOnError extends boolean = false>(options: Options<EvaluateFinanceStrategyDefinitionData, ThrowOnError>): RequestResult<EvaluateFinanceStrategyDefinitionResponses, EvaluateFinanceStrategyDefinitionErrors, ThrowOnError> => (options.client ?? client).post<EvaluateFinanceStrategyDefinitionResponses, EvaluateFinanceStrategyDefinitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/strategy-evaluations/{definitionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getFinanceOperationsSummary = <ThrowOnError extends boolean = false>(options?: Options<GetFinanceOperationsSummaryData, ThrowOnError>): RequestResult<GetFinanceOperationsSummaryResponses, GetFinanceOperationsSummaryErrors, ThrowOnError> => (options?.client ?? client).get<GetFinanceOperationsSummaryResponses, GetFinanceOperationsSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/operations-summary',
    ...options
});

export const lookupFinanceCommandOptions = <ThrowOnError extends boolean = false>(options: Options<LookupFinanceCommandOptionsData, ThrowOnError>): RequestResult<LookupFinanceCommandOptionsResponses, LookupFinanceCommandOptionsErrors, ThrowOnError> => (options.client ?? client).get<LookupFinanceCommandOptionsResponses, LookupFinanceCommandOptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/command-lookup',
    ...options
});

export const listFinanceConversationPersonas = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceConversationPersonasData, ThrowOnError>): RequestResult<ListFinanceConversationPersonasResponses, ListFinanceConversationPersonasErrors, ThrowOnError> => (options?.client ?? client).get<ListFinanceConversationPersonasResponses, ListFinanceConversationPersonasErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/conversation-personas',
    ...options
});

export const previewFinanceIndicatorImport = <ThrowOnError extends boolean = false>(options?: Options<PreviewFinanceIndicatorImportData, ThrowOnError>): RequestResult<PreviewFinanceIndicatorImportResponses, PreviewFinanceIndicatorImportErrors, ThrowOnError> => (options?.client ?? client).post<PreviewFinanceIndicatorImportResponses, PreviewFinanceIndicatorImportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/indicator-imports/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const transpileFinanceIndicatorImport = <ThrowOnError extends boolean = false>(options?: Options<TranspileFinanceIndicatorImportData, ThrowOnError>): RequestResult<TranspileFinanceIndicatorImportResponses, TranspileFinanceIndicatorImportErrors, ThrowOnError> => (options?.client ?? client).post<TranspileFinanceIndicatorImportResponses, TranspileFinanceIndicatorImportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/indicator-imports/transpile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const listFinanceIndicators = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceIndicatorsData, ThrowOnError>): RequestResult<ListFinanceIndicatorsResponses, ListFinanceIndicatorsErrors, ThrowOnError> => (options?.client ?? client).get<ListFinanceIndicatorsResponses, ListFinanceIndicatorsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/indicators',
    ...options
});

export const applyFinanceIndicatorPromotion = <ThrowOnError extends boolean = false>(options: Options<ApplyFinanceIndicatorPromotionData, ThrowOnError>): RequestResult<ApplyFinanceIndicatorPromotionResponses, ApplyFinanceIndicatorPromotionErrors, ThrowOnError> => (options.client ?? client).post<ApplyFinanceIndicatorPromotionResponses, ApplyFinanceIndicatorPromotionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/indicator-promotions/decisions/{id}/apply',
    ...options
});

export const createTickerResearchNote = <ThrowOnError extends boolean = false>(options: Options<CreateTickerResearchNoteData, ThrowOnError>): RequestResult<CreateTickerResearchNoteResponses, CreateTickerResearchNoteErrors, ThrowOnError> => (options.client ?? client).post<CreateTickerResearchNoteResponses, CreateTickerResearchNoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/research-notes/ticker',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listVarEstimates = <ThrowOnError extends boolean = false>(options?: Options<ListVarEstimatesData, ThrowOnError>): RequestResult<ListVarEstimatesResponses, ListVarEstimatesErrors, ThrowOnError> => (options?.client ?? client).get<ListVarEstimatesResponses, ListVarEstimatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/var',
    ...options
});

export const listVarBacktests = <ThrowOnError extends boolean = false>(options?: Options<ListVarBacktestsData, ThrowOnError>): RequestResult<ListVarBacktestsResponses, ListVarBacktestsErrors, ThrowOnError> => (options?.client ?? client).get<ListVarBacktestsResponses, ListVarBacktestsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/var/backtests',
    ...options
});

export const getVarEstimate = <ThrowOnError extends boolean = false>(options: Options<GetVarEstimateData, ThrowOnError>): RequestResult<GetVarEstimateResponses, GetVarEstimateErrors, ThrowOnError> => (options.client ?? client).get<GetVarEstimateResponses, GetVarEstimateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/var/{id}',
    ...options
});

export const listVarComponents = <ThrowOnError extends boolean = false>(options: Options<ListVarComponentsData, ThrowOnError>): RequestResult<ListVarComponentsResponses, ListVarComponentsErrors, ThrowOnError> => (options.client ?? client).get<ListVarComponentsResponses, ListVarComponentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/var/{id}/components',
    ...options
});

export const listStressScenarios = <ThrowOnError extends boolean = false>(options?: Options<ListStressScenariosData, ThrowOnError>): RequestResult<ListStressScenariosResponses, ListStressScenariosErrors, ThrowOnError> => (options?.client ?? client).get<ListStressScenariosResponses, ListStressScenariosErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/stress-scenarios',
    ...options
});

export const getStressScenario = <ThrowOnError extends boolean = false>(options: Options<GetStressScenarioData, ThrowOnError>): RequestResult<GetStressScenarioResponses, GetStressScenarioErrors, ThrowOnError> => (options.client ?? client).get<GetStressScenarioResponses, GetStressScenarioErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/stress-scenarios/{scenarioKey}',
    ...options
});

export const listStressResults = <ThrowOnError extends boolean = false>(options?: Options<ListStressResultsData, ThrowOnError>): RequestResult<ListStressResultsResponses, ListStressResultsErrors, ThrowOnError> => (options?.client ?? client).get<ListStressResultsResponses, ListStressResultsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/stress-results',
    ...options
});

export const getStressResult = <ThrowOnError extends boolean = false>(options: Options<GetStressResultData, ThrowOnError>): RequestResult<GetStressResultResponses, GetStressResultErrors, ThrowOnError> => (options.client ?? client).get<GetStressResultResponses, GetStressResultErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/stress-results/{id}',
    ...options
});

export const listAttributionRuns = <ThrowOnError extends boolean = false>(options?: Options<ListAttributionRunsData, ThrowOnError>): RequestResult<ListAttributionRunsResponses, ListAttributionRunsErrors, ThrowOnError> => (options?.client ?? client).get<ListAttributionRunsResponses, ListAttributionRunsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/attribution-runs',
    ...options
});

export const getAttributionRun = <ThrowOnError extends boolean = false>(options: Options<GetAttributionRunData, ThrowOnError>): RequestResult<GetAttributionRunResponses, GetAttributionRunErrors, ThrowOnError> => (options.client ?? client).get<GetAttributionRunResponses, GetAttributionRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/attribution-runs/{id}',
    ...options
});

export const listAttributionEffects = <ThrowOnError extends boolean = false>(options: Options<ListAttributionEffectsData, ThrowOnError>): RequestResult<ListAttributionEffectsResponses, ListAttributionEffectsErrors, ThrowOnError> => (options.client ?? client).get<ListAttributionEffectsResponses, ListAttributionEffectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/attribution-runs/{id}/effects',
    ...options
});

export const listTcaScorecards = <ThrowOnError extends boolean = false>(options: Options<ListTcaScorecardsData, ThrowOnError>): RequestResult<ListTcaScorecardsResponses, ListTcaScorecardsErrors, ThrowOnError> => (options.client ?? client).get<ListTcaScorecardsResponses, ListTcaScorecardsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/tca-scorecards',
    ...options
});

export const listCrowdingScores = <ThrowOnError extends boolean = false>(options?: Options<ListCrowdingScoresData, ThrowOnError>): RequestResult<ListCrowdingScoresResponses, ListCrowdingScoresErrors, ThrowOnError> => (options?.client ?? client).get<ListCrowdingScoresResponses, ListCrowdingScoresErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/crowding',
    ...options
});

export const listCapitalAllocations = <ThrowOnError extends boolean = false>(options?: Options<ListCapitalAllocationsData, ThrowOnError>): RequestResult<ListCapitalAllocationsResponses, ListCapitalAllocationsErrors, ThrowOnError> => (options?.client ?? client).get<ListCapitalAllocationsResponses, ListCapitalAllocationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/capital-allocations',
    ...options
});

export const getCapitalAllocation = <ThrowOnError extends boolean = false>(options: Options<GetCapitalAllocationData, ThrowOnError>): RequestResult<GetCapitalAllocationResponses, GetCapitalAllocationErrors, ThrowOnError> => (options.client ?? client).get<GetCapitalAllocationResponses, GetCapitalAllocationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/capital-allocations/{id}',
    ...options
});

export const listCapitalAllocationSleeves = <ThrowOnError extends boolean = false>(options: Options<ListCapitalAllocationSleevesData, ThrowOnError>): RequestResult<ListCapitalAllocationSleevesResponses, ListCapitalAllocationSleevesErrors, ThrowOnError> => (options.client ?? client).get<ListCapitalAllocationSleevesResponses, ListCapitalAllocationSleevesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/capital-allocations/{id}/sleeves',
    ...options
});

export const submitCapitalAllocation = <ThrowOnError extends boolean = false>(options: Options<SubmitCapitalAllocationData, ThrowOnError>): RequestResult<SubmitCapitalAllocationResponses, SubmitCapitalAllocationErrors, ThrowOnError> => (options.client ?? client).post<SubmitCapitalAllocationResponses, SubmitCapitalAllocationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/capital-allocations/{id}/submit-for-approval',
    ...options
});

export const listCapacityCurves = <ThrowOnError extends boolean = false>(options?: Options<ListCapacityCurvesData, ThrowOnError>): RequestResult<ListCapacityCurvesResponses, ListCapacityCurvesErrors, ThrowOnError> => (options?.client ?? client).get<ListCapacityCurvesResponses, ListCapacityCurvesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/capacity-curves',
    ...options
});

export const getCapacityCurve = <ThrowOnError extends boolean = false>(options: Options<GetCapacityCurveData, ThrowOnError>): RequestResult<GetCapacityCurveResponses, GetCapacityCurveErrors, ThrowOnError> => (options.client ?? client).get<GetCapacityCurveResponses, GetCapacityCurveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/capacity-curves/{id}',
    ...options
});

export const getTradingAccount = <ThrowOnError extends boolean = false>(options: Options<GetTradingAccountData, ThrowOnError>): RequestResult<GetTradingAccountResponses, GetTradingAccountErrors, ThrowOnError> => (options.client ?? client).get<GetTradingAccountResponses, GetTradingAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/accounts/{id}',
    ...options
});

export const createDeposit = <ThrowOnError extends boolean = false>(options: Options<CreateDepositData, ThrowOnError>): RequestResult<CreateDepositResponses, CreateDepositErrors, ThrowOnError> => (options.client ?? client).post<CreateDepositResponses, CreateDepositErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/accounts/{id}/deposits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createWithdrawal = <ThrowOnError extends boolean = false>(options: Options<CreateWithdrawalData, ThrowOnError>): RequestResult<CreateWithdrawalResponses, CreateWithdrawalErrors, ThrowOnError> => (options.client ?? client).post<CreateWithdrawalResponses, CreateWithdrawalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/accounts/{id}/withdrawals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createAdjustment = <ThrowOnError extends boolean = false>(options: Options<CreateAdjustmentData, ThrowOnError>): RequestResult<CreateAdjustmentResponses, CreateAdjustmentErrors, ThrowOnError> => (options.client ?? client).post<CreateAdjustmentResponses, CreateAdjustmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/accounts/{id}/adjustments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAccountFxCash = <ThrowOnError extends boolean = false>(options: Options<GetAccountFxCashData, ThrowOnError>): RequestResult<GetAccountFxCashResponses, GetAccountFxCashErrors, ThrowOnError> => (options.client ?? client).get<GetAccountFxCashResponses, GetAccountFxCashErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/accounts/{id}/fx/cash',
    ...options
});

export const listPositionLots = <ThrowOnError extends boolean = false>(options: Options<ListPositionLotsData, ThrowOnError>): RequestResult<ListPositionLotsResponses, ListPositionLotsErrors, ThrowOnError> => (options.client ?? client).get<ListPositionLotsResponses, ListPositionLotsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/accounts/{id}/lots',
    ...options
});

export const listLotDisposals = <ThrowOnError extends boolean = false>(options: Options<ListLotDisposalsData, ThrowOnError>): RequestResult<ListLotDisposalsResponses, ListLotDisposalsErrors, ThrowOnError> => (options.client ?? client).get<ListLotDisposalsResponses, ListLotDisposalsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/accounts/{id}/disposals',
    ...options
});

export const listBookSnapshots = <ThrowOnError extends boolean = false>(options: Options<ListBookSnapshotsData, ThrowOnError>): RequestResult<ListBookSnapshotsResponses, ListBookSnapshotsErrors, ThrowOnError> => (options.client ?? client).get<ListBookSnapshotsResponses, ListBookSnapshotsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/accounts/{id}/snapshots',
    ...options
});

export const dtiOperatorKillSwitch = <ThrowOnError extends boolean = false>(options: Options<DtiOperatorKillSwitchData, ThrowOnError>): RequestResult<DtiOperatorKillSwitchResponses, DtiOperatorKillSwitchErrors, ThrowOnError> => (options.client ?? client).post<DtiOperatorKillSwitchResponses, DtiOperatorKillSwitchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/dti/forward-runs/{id}/kill-switch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const dtiOperatorResume = <ThrowOnError extends boolean = false>(options: Options<DtiOperatorResumeData, ThrowOnError>): RequestResult<DtiOperatorResumeResponses, DtiOperatorResumeErrors, ThrowOnError> => (options.client ?? client).post<DtiOperatorResumeResponses, DtiOperatorResumeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/dti/forward-runs/{id}/resume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createDiscretionaryRun = <ThrowOnError extends boolean = false>(options?: Options<CreateDiscretionaryRunData, ThrowOnError>): RequestResult<CreateDiscretionaryRunResponses, CreateDiscretionaryRunErrors, ThrowOnError> => (options?.client ?? client).post<CreateDiscretionaryRunResponses, CreateDiscretionaryRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/dti/runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getIntelSourceStyleProfile = <ThrowOnError extends boolean = false>(options: Options<GetIntelSourceStyleProfileData, ThrowOnError>): RequestResult<GetIntelSourceStyleProfileResponses, GetIntelSourceStyleProfileErrors, ThrowOnError> => (options.client ?? client).get<GetIntelSourceStyleProfileResponses, GetIntelSourceStyleProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/intel-sources/{id}/style-profile',
    ...options
});

export const getIntelSourceViewConfirmation = <ThrowOnError extends boolean = false>(options: Options<GetIntelSourceViewConfirmationData, ThrowOnError>): RequestResult<GetIntelSourceViewConfirmationResponses, GetIntelSourceViewConfirmationErrors, ThrowOnError> => (options.client ?? client).get<GetIntelSourceViewConfirmationResponses, GetIntelSourceViewConfirmationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/intel-sources/{id}/view-confirmation',
    ...options
});

export const getFinanceAuditLedgerChain = <ThrowOnError extends boolean = false>(options?: Options<GetFinanceAuditLedgerChainData, ThrowOnError>): RequestResult<GetFinanceAuditLedgerChainResponses, GetFinanceAuditLedgerChainErrors, ThrowOnError> => (options?.client ?? client).get<GetFinanceAuditLedgerChainResponses, GetFinanceAuditLedgerChainErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/audit-ledger/chain',
    ...options
});

export const getFinanceAuditLedgerOrderHistory = <ThrowOnError extends boolean = false>(options: Options<GetFinanceAuditLedgerOrderHistoryData, ThrowOnError>): RequestResult<GetFinanceAuditLedgerOrderHistoryResponses, GetFinanceAuditLedgerOrderHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetFinanceAuditLedgerOrderHistoryResponses, GetFinanceAuditLedgerOrderHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/audit-ledger/orders/{order_id}',
    ...options
});

export const getFinanceAuditLedgerHead = <ThrowOnError extends boolean = false>(options?: Options<GetFinanceAuditLedgerHeadData, ThrowOnError>): RequestResult<GetFinanceAuditLedgerHeadResponses, GetFinanceAuditLedgerHeadErrors, ThrowOnError> => (options?.client ?? client).get<GetFinanceAuditLedgerHeadResponses, GetFinanceAuditLedgerHeadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/audit-ledger/head',
    ...options
});

export const verifyFinanceAuditLedgerChain = <ThrowOnError extends boolean = false>(options?: Options<VerifyFinanceAuditLedgerChainData, ThrowOnError>): RequestResult<VerifyFinanceAuditLedgerChainResponses, VerifyFinanceAuditLedgerChainErrors, ThrowOnError> => (options?.client ?? client).get<VerifyFinanceAuditLedgerChainResponses, VerifyFinanceAuditLedgerChainErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/audit-ledger/verify',
    ...options
});

export const listExecutionDeployments = <ThrowOnError extends boolean = false>(options?: Options<ListExecutionDeploymentsData, ThrowOnError>): RequestResult<ListExecutionDeploymentsResponses, ListExecutionDeploymentsErrors, ThrowOnError> => (options?.client ?? client).get<ListExecutionDeploymentsResponses, ListExecutionDeploymentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/execution-deployments',
    ...options
});

export const createExecutionDeployment = <ThrowOnError extends boolean = false>(options?: Options<CreateExecutionDeploymentData, ThrowOnError>): RequestResult<CreateExecutionDeploymentResponses, CreateExecutionDeploymentErrors, ThrowOnError> => (options?.client ?? client).post<CreateExecutionDeploymentResponses, CreateExecutionDeploymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/execution-deployments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getExecutionDeployment = <ThrowOnError extends boolean = false>(options: Options<GetExecutionDeploymentData, ThrowOnError>): RequestResult<GetExecutionDeploymentResponses, GetExecutionDeploymentErrors, ThrowOnError> => (options.client ?? client).get<GetExecutionDeploymentResponses, GetExecutionDeploymentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/execution-deployments/{id}',
    ...options
});

export const getPortfolioValuation = <ThrowOnError extends boolean = false>(options: Options<GetPortfolioValuationData, ThrowOnError>): RequestResult<GetPortfolioValuationResponses, GetPortfolioValuationErrors, ThrowOnError> => (options.client ?? client).get<GetPortfolioValuationResponses, GetPortfolioValuationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/portfolios/{id}/valuation',
    ...options
});

export const getPositionValuation = <ThrowOnError extends boolean = false>(options: Options<GetPositionValuationData, ThrowOnError>): RequestResult<GetPositionValuationResponses, GetPositionValuationErrors, ThrowOnError> => (options.client ?? client).get<GetPositionValuationResponses, GetPositionValuationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/positions/{id}/valuation',
    ...options
});

export const listFinanceModelLineage = <ThrowOnError extends boolean = false>(options?: Options<ListFinanceModelLineageData, ThrowOnError>): RequestResult<ListFinanceModelLineageResponses, ListFinanceModelLineageErrors, ThrowOnError> => (options?.client ?? client).get<ListFinanceModelLineageResponses, ListFinanceModelLineageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/model-lineage',
    ...options
});

export const getFinanceModelLineageHistory = <ThrowOnError extends boolean = false>(options: Options<GetFinanceModelLineageHistoryData, ThrowOnError>): RequestResult<GetFinanceModelLineageHistoryResponses, GetFinanceModelLineageHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetFinanceModelLineageHistoryResponses, GetFinanceModelLineageHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/model-lineage/{subjectKind}/{subjectId}/versions',
    ...options
});

export const getFinanceModelLineage = <ThrowOnError extends boolean = false>(options: Options<GetFinanceModelLineageData, ThrowOnError>): RequestResult<GetFinanceModelLineageResponses, GetFinanceModelLineageErrors, ThrowOnError> => (options.client ?? client).get<GetFinanceModelLineageResponses, GetFinanceModelLineageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/model-lineage/{subjectKind}/{subjectId}/versions/{version}',
    ...options
});

export const getFinanceModelLineageGraph = <ThrowOnError extends boolean = false>(options: Options<GetFinanceModelLineageGraphData, ThrowOnError>): RequestResult<GetFinanceModelLineageGraphResponses, GetFinanceModelLineageGraphErrors, ThrowOnError> => (options.client ?? client).get<GetFinanceModelLineageGraphResponses, GetFinanceModelLineageGraphErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/model-lineage/{subjectKind}/{subjectId}/versions/{version}/graph',
    ...options
});

export const getFinanceKgRegimeProfile = <ThrowOnError extends boolean = false>(options: Options<GetFinanceKgRegimeProfileData, ThrowOnError>): RequestResult<GetFinanceKgRegimeProfileResponses, GetFinanceKgRegimeProfileErrors, ThrowOnError> => (options.client ?? client).get<GetFinanceKgRegimeProfileResponses, GetFinanceKgRegimeProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/knowledge/signals/{subjectKind}/{subjectId}/regime-profile',
    ...options
});

export const getFinanceKgNodeEdges = <ThrowOnError extends boolean = false>(options: Options<GetFinanceKgNodeEdgesData, ThrowOnError>): RequestResult<GetFinanceKgNodeEdgesResponses, GetFinanceKgNodeEdgesErrors, ThrowOnError> => (options.client ?? client).get<GetFinanceKgNodeEdgesResponses, GetFinanceKgNodeEdgesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/knowledge/nodes/{nodeId}/edges',
    ...options
});

export const searchFinanceKg = <ThrowOnError extends boolean = false>(options: Options<SearchFinanceKgData, ThrowOnError>): RequestResult<SearchFinanceKgResponses, SearchFinanceKgErrors, ThrowOnError> => (options.client ?? client).get<SearchFinanceKgResponses, SearchFinanceKgErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/knowledge/search',
    ...options
});

export const listBrokerCredentials = <ThrowOnError extends boolean = false>(options?: Options<ListBrokerCredentialsData, ThrowOnError>): RequestResult<ListBrokerCredentialsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListBrokerCredentialsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/broker-credentials',
    ...options
});

export const createBrokerCredential = <ThrowOnError extends boolean = false>(options?: Options<CreateBrokerCredentialData, ThrowOnError>): RequestResult<CreateBrokerCredentialResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CreateBrokerCredentialResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/broker-credentials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const deleteBrokerCredential = <ThrowOnError extends boolean = false>(options: Options<DeleteBrokerCredentialData, ThrowOnError>): RequestResult<DeleteBrokerCredentialResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteBrokerCredentialResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/broker-credentials/{id}',
    ...options
});

export const getBrokerCredential = <ThrowOnError extends boolean = false>(options: Options<GetBrokerCredentialData, ThrowOnError>): RequestResult<GetBrokerCredentialResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetBrokerCredentialResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/broker-credentials/{id}',
    ...options
});

export const updateBrokerCredential = <ThrowOnError extends boolean = false>(options: Options<UpdateBrokerCredentialData, ThrowOnError>): RequestResult<UpdateBrokerCredentialResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateBrokerCredentialResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/broker-credentials/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const verifyBrokerCredential = <ThrowOnError extends boolean = false>(options: Options<VerifyBrokerCredentialData, ThrowOnError>): RequestResult<VerifyBrokerCredentialResponses, unknown, ThrowOnError> => (options.client ?? client).post<VerifyBrokerCredentialResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/broker-credentials/{id}/verify',
    ...options
});

export const listExecutionAlgos = <ThrowOnError extends boolean = false>(options?: Options<ListExecutionAlgosData, ThrowOnError>): RequestResult<ListExecutionAlgosResponses, ListExecutionAlgosErrors, ThrowOnError> => (options?.client ?? client).get<ListExecutionAlgosResponses, ListExecutionAlgosErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/execution-algos',
    ...options
});

export const createExecutionAlgo = <ThrowOnError extends boolean = false>(options?: Options<CreateExecutionAlgoData, ThrowOnError>): RequestResult<CreateExecutionAlgoResponses, CreateExecutionAlgoErrors, ThrowOnError> => (options?.client ?? client).post<CreateExecutionAlgoResponses, CreateExecutionAlgoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/execution-algos',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getExecutionAlgo = <ThrowOnError extends boolean = false>(options: Options<GetExecutionAlgoData, ThrowOnError>): RequestResult<GetExecutionAlgoResponses, GetExecutionAlgoErrors, ThrowOnError> => (options.client ?? client).get<GetExecutionAlgoResponses, GetExecutionAlgoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/execution-algos/{id}',
    ...options
});

export const cancelExecutionAlgo = <ThrowOnError extends boolean = false>(options: Options<CancelExecutionAlgoData, ThrowOnError>): RequestResult<CancelExecutionAlgoResponses, CancelExecutionAlgoErrors, ThrowOnError> => (options.client ?? client).post<CancelExecutionAlgoResponses, CancelExecutionAlgoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/execution-algos/{id}/cancel',
    ...options
});

export const pauseExecutionAlgo = <ThrowOnError extends boolean = false>(options: Options<PauseExecutionAlgoData, ThrowOnError>): RequestResult<PauseExecutionAlgoResponses, PauseExecutionAlgoErrors, ThrowOnError> => (options.client ?? client).post<PauseExecutionAlgoResponses, PauseExecutionAlgoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/execution-algos/{id}/pause',
    ...options
});

export const resumeExecutionAlgo = <ThrowOnError extends boolean = false>(options: Options<ResumeExecutionAlgoData, ThrowOnError>): RequestResult<ResumeExecutionAlgoResponses, ResumeExecutionAlgoErrors, ThrowOnError> => (options.client ?? client).post<ResumeExecutionAlgoResponses, ResumeExecutionAlgoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/trading/execution-algos/{id}/resume',
    ...options
});

export const listForwardRuns = <ThrowOnError extends boolean = false>(options?: Options<ListForwardRunsData, ThrowOnError>): RequestResult<ListForwardRunsResponses, ListForwardRunsErrors, ThrowOnError> => (options?.client ?? client).get<ListForwardRunsResponses, ListForwardRunsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/forward-runs',
    ...options
});

export const createSystematicForwardRun = <ThrowOnError extends boolean = false>(options?: Options<CreateSystematicForwardRunData, ThrowOnError>): RequestResult<CreateSystematicForwardRunResponses, CreateSystematicForwardRunErrors, ThrowOnError> => (options?.client ?? client).post<CreateSystematicForwardRunResponses, CreateSystematicForwardRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/forward-runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const createBucketForwardRun = <ThrowOnError extends boolean = false>(options?: Options<CreateBucketForwardRunData, ThrowOnError>): RequestResult<CreateBucketForwardRunResponses, CreateBucketForwardRunErrors, ThrowOnError> => (options?.client ?? client).post<CreateBucketForwardRunResponses, CreateBucketForwardRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/forward-runs/bucket',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

export const getForwardRun = <ThrowOnError extends boolean = false>(options: Options<GetForwardRunData, ThrowOnError>): RequestResult<GetForwardRunResponses, GetForwardRunErrors, ThrowOnError> => (options.client ?? client).get<GetForwardRunResponses, GetForwardRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/forward-runs/{id}',
    ...options
});

export const listShadowModeDaemons = <ThrowOnError extends boolean = false>(options?: Options<ListShadowModeDaemonsData, ThrowOnError>): RequestResult<ListShadowModeDaemonsResponses, ListShadowModeDaemonsErrors, ThrowOnError> => (options?.client ?? client).get<ListShadowModeDaemonsResponses, ListShadowModeDaemonsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/shadow-mode/daemons',
    ...options
});

export const getShadowModeDaemon = <ThrowOnError extends boolean = false>(options: Options<GetShadowModeDaemonData, ThrowOnError>): RequestResult<GetShadowModeDaemonResponses, GetShadowModeDaemonErrors, ThrowOnError> => (options.client ?? client).get<GetShadowModeDaemonResponses, GetShadowModeDaemonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/shadow-mode/daemons/{daemonId}',
    ...options
});

export const updateShadowModeDaemonEnrollment = <ThrowOnError extends boolean = false>(options: Options<UpdateShadowModeDaemonEnrollmentData, ThrowOnError>): RequestResult<UpdateShadowModeDaemonEnrollmentResponses, UpdateShadowModeDaemonEnrollmentErrors, ThrowOnError> => (options.client ?? client).patch<UpdateShadowModeDaemonEnrollmentResponses, UpdateShadowModeDaemonEnrollmentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/shadow-mode/daemons/{daemonId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const certifyShadowModeDaemon = <ThrowOnError extends boolean = false>(options: Options<CertifyShadowModeDaemonData, ThrowOnError>): RequestResult<CertifyShadowModeDaemonResponses, CertifyShadowModeDaemonErrors, ThrowOnError> => (options.client ?? client).post<CertifyShadowModeDaemonResponses, CertifyShadowModeDaemonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/shadow-mode/daemons/{daemonId}/certify',
    ...options
});

export const graduateShadowModeDaemon = <ThrowOnError extends boolean = false>(options: Options<GraduateShadowModeDaemonData, ThrowOnError>): RequestResult<GraduateShadowModeDaemonResponses, GraduateShadowModeDaemonErrors, ThrowOnError> => (options.client ?? client).post<GraduateShadowModeDaemonResponses, GraduateShadowModeDaemonErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/finance/shadow-mode/daemons/{daemonId}/graduate',
    ...options
});

export const getProjectCodeOperationalMetrics = <ThrowOnError extends boolean = false>(options: Options<GetProjectCodeOperationalMetricsData, ThrowOnError>): RequestResult<GetProjectCodeOperationalMetricsResponses, GetProjectCodeOperationalMetricsErrors, ThrowOnError> => (options.client ?? client).get<GetProjectCodeOperationalMetricsResponses, GetProjectCodeOperationalMetricsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/code/metrics',
    ...options
});

export const getProjectCodeWorkspace = <ThrowOnError extends boolean = false>(options: Options<GetProjectCodeWorkspaceData, ThrowOnError>): RequestResult<GetProjectCodeWorkspaceResponses, GetProjectCodeWorkspaceErrors, ThrowOnError> => (options.client ?? client).get<GetProjectCodeWorkspaceResponses, GetProjectCodeWorkspaceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/code/workspace',
    ...options
});

export const listProjectCodeRepositoryConnections = <ThrowOnError extends boolean = false>(options: Options<ListProjectCodeRepositoryConnectionsData, ThrowOnError>): RequestResult<ListProjectCodeRepositoryConnectionsResponses, ListProjectCodeRepositoryConnectionsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectCodeRepositoryConnectionsResponses, ListProjectCodeRepositoryConnectionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/code/repository-connections',
    ...options
});

export const createProjectCodeRepositoryConnection = <ThrowOnError extends boolean = false>(options: Options<CreateProjectCodeRepositoryConnectionData, ThrowOnError>): RequestResult<CreateProjectCodeRepositoryConnectionResponses, CreateProjectCodeRepositoryConnectionErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectCodeRepositoryConnectionResponses, CreateProjectCodeRepositoryConnectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/code/repository-connections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const enableProjectCodeWorkspace = <ThrowOnError extends boolean = false>(options: Options<EnableProjectCodeWorkspaceData, ThrowOnError>): RequestResult<EnableProjectCodeWorkspaceResponses, EnableProjectCodeWorkspaceErrors, ThrowOnError> => (options.client ?? client).post<EnableProjectCodeWorkspaceResponses, EnableProjectCodeWorkspaceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/code/workspace/enable',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listProjectCodeCheckpoints = <ThrowOnError extends boolean = false>(options: Options<ListProjectCodeCheckpointsData, ThrowOnError>): RequestResult<ListProjectCodeCheckpointsResponses, ListProjectCodeCheckpointsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectCodeCheckpointsResponses, ListProjectCodeCheckpointsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/code/workspace/checkpoints',
    ...options
});

export const listProjectCodeWorkspaceOperations = <ThrowOnError extends boolean = false>(options: Options<ListProjectCodeWorkspaceOperationsData, ThrowOnError>): RequestResult<ListProjectCodeWorkspaceOperationsResponses, ListProjectCodeWorkspaceOperationsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectCodeWorkspaceOperationsResponses, ListProjectCodeWorkspaceOperationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/code/workspace/operations',
    ...options
});

export const materializeProjectChangeCode = <ThrowOnError extends boolean = false>(options: Options<MaterializeProjectChangeCodeData, ThrowOnError>): RequestResult<MaterializeProjectChangeCodeResponses, MaterializeProjectChangeCodeErrors, ThrowOnError> => (options.client ?? client).post<MaterializeProjectChangeCodeResponses, MaterializeProjectChangeCodeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/changes/{changeId}/code/materialize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const openProjectChangeCodeReview = <ThrowOnError extends boolean = false>(options: Options<OpenProjectChangeCodeReviewData, ThrowOnError>): RequestResult<OpenProjectChangeCodeReviewResponses, OpenProjectChangeCodeReviewErrors, ThrowOnError> => (options.client ?? client).post<OpenProjectChangeCodeReviewResponses, OpenProjectChangeCodeReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/changes/{changeId}/code/open-review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const rollbackProjectCodeCheckpoint = <ThrowOnError extends boolean = false>(options: Options<RollbackProjectCodeCheckpointData, ThrowOnError>): RequestResult<RollbackProjectCodeCheckpointResponses, RollbackProjectCodeCheckpointErrors, ThrowOnError> => (options.client ?? client).post<RollbackProjectCodeCheckpointResponses, RollbackProjectCodeCheckpointErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/code/checkpoints/{checkpointId}/rollback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getProjectCodeClientDatabase = <ThrowOnError extends boolean = false>(options: Options<GetProjectCodeClientDatabaseData, ThrowOnError>): RequestResult<GetProjectCodeClientDatabaseResponses, GetProjectCodeClientDatabaseErrors, ThrowOnError> => (options.client ?? client).get<GetProjectCodeClientDatabaseResponses, GetProjectCodeClientDatabaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/code/client-db',
    ...options
});

export const configureProjectCodeClientDatabase = <ThrowOnError extends boolean = false>(options: Options<ConfigureProjectCodeClientDatabaseData, ThrowOnError>): RequestResult<ConfigureProjectCodeClientDatabaseResponses, ConfigureProjectCodeClientDatabaseErrors, ThrowOnError> => (options.client ?? client).put<ConfigureProjectCodeClientDatabaseResponses, ConfigureProjectCodeClientDatabaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/code/client-db',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getProjectWorkstreamCodeTuningView = <ThrowOnError extends boolean = false>(options: Options<GetProjectWorkstreamCodeTuningViewData, ThrowOnError>): RequestResult<GetProjectWorkstreamCodeTuningViewResponses, GetProjectWorkstreamCodeTuningViewErrors, ThrowOnError> => (options.client ?? client).get<GetProjectWorkstreamCodeTuningViewResponses, GetProjectWorkstreamCodeTuningViewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code',
    ...options
});

export const enableProjectWorkstreamCodeWorkforce = <ThrowOnError extends boolean = false>(options: Options<EnableProjectWorkstreamCodeWorkforceData, ThrowOnError>): RequestResult<EnableProjectWorkstreamCodeWorkforceResponses, EnableProjectWorkstreamCodeWorkforceErrors, ThrowOnError> => (options.client ?? client).post<EnableProjectWorkstreamCodeWorkforceResponses, EnableProjectWorkstreamCodeWorkforceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/workforce/enable',
    ...options
});

export const createProjectWorkstreamCodeGenerationRun = <ThrowOnError extends boolean = false>(options: Options<CreateProjectWorkstreamCodeGenerationRunData, ThrowOnError>): RequestResult<CreateProjectWorkstreamCodeGenerationRunResponses, CreateProjectWorkstreamCodeGenerationRunErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectWorkstreamCodeGenerationRunResponses, CreateProjectWorkstreamCodeGenerationRunErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/generation-runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listProjectWorkstreamCodeReviewRequests = <ThrowOnError extends boolean = false>(options: Options<ListProjectWorkstreamCodeReviewRequestsData, ThrowOnError>): RequestResult<ListProjectWorkstreamCodeReviewRequestsResponses, ListProjectWorkstreamCodeReviewRequestsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectWorkstreamCodeReviewRequestsResponses, ListProjectWorkstreamCodeReviewRequestsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/review-requests',
    ...options
});

export const createProjectWorkstreamCodeReviewRequest = <ThrowOnError extends boolean = false>(options: Options<CreateProjectWorkstreamCodeReviewRequestData, ThrowOnError>): RequestResult<CreateProjectWorkstreamCodeReviewRequestResponses, CreateProjectWorkstreamCodeReviewRequestErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectWorkstreamCodeReviewRequestResponses, CreateProjectWorkstreamCodeReviewRequestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/versions/{versionId}/review-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getProjectWorkstreamCodeReviewRequest = <ThrowOnError extends boolean = false>(options: Options<GetProjectWorkstreamCodeReviewRequestData, ThrowOnError>): RequestResult<GetProjectWorkstreamCodeReviewRequestResponses, GetProjectWorkstreamCodeReviewRequestErrors, ThrowOnError> => (options.client ?? client).get<GetProjectWorkstreamCodeReviewRequestResponses, GetProjectWorkstreamCodeReviewRequestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/review-requests/{reviewRequestId}',
    ...options
});

export const decideProjectWorkstreamCodeReviewRequest = <ThrowOnError extends boolean = false>(options: Options<DecideProjectWorkstreamCodeReviewRequestData, ThrowOnError>): RequestResult<DecideProjectWorkstreamCodeReviewRequestResponses, DecideProjectWorkstreamCodeReviewRequestErrors, ThrowOnError> => (options.client ?? client).post<DecideProjectWorkstreamCodeReviewRequestResponses, DecideProjectWorkstreamCodeReviewRequestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/review-requests/{reviewRequestId}/decisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createProjectWorkstreamCodePreviewSession = <ThrowOnError extends boolean = false>(options: Options<CreateProjectWorkstreamCodePreviewSessionData, ThrowOnError>): RequestResult<CreateProjectWorkstreamCodePreviewSessionResponses, CreateProjectWorkstreamCodePreviewSessionErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectWorkstreamCodePreviewSessionResponses, CreateProjectWorkstreamCodePreviewSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/preview/sessions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const heartbeatProjectWorkstreamCodePreviewSession = <ThrowOnError extends boolean = false>(options: Options<HeartbeatProjectWorkstreamCodePreviewSessionData, ThrowOnError>): RequestResult<HeartbeatProjectWorkstreamCodePreviewSessionResponses, HeartbeatProjectWorkstreamCodePreviewSessionErrors, ThrowOnError> => (options.client ?? client).post<HeartbeatProjectWorkstreamCodePreviewSessionResponses, HeartbeatProjectWorkstreamCodePreviewSessionErrors, ThrowOnError>({ url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/preview/sessions/{sessionId}/heartbeat', ...options });

export const streamProjectWorkstreamCodePreviewSessionEvents = <ThrowOnError extends boolean = false>(options: Options<StreamProjectWorkstreamCodePreviewSessionEventsData, ThrowOnError, StreamProjectWorkstreamCodePreviewSessionEventsResponse>): Promise<ServerSentEventsResult<StreamProjectWorkstreamCodePreviewSessionEventsResponses>> => (options.client ?? client).sse.get<StreamProjectWorkstreamCodePreviewSessionEventsResponses, StreamProjectWorkstreamCodePreviewSessionEventsErrors, ThrowOnError>({ url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/preview/sessions/{sessionId}/events', ...options });

export const viewProjectWorkstreamCodePreviewSession = <ThrowOnError extends boolean = false>(options: Options<ViewProjectWorkstreamCodePreviewSessionData, ThrowOnError>): RequestResult<ViewProjectWorkstreamCodePreviewSessionResponses, ViewProjectWorkstreamCodePreviewSessionErrors, ThrowOnError> => (options.client ?? client).get<ViewProjectWorkstreamCodePreviewSessionResponses, ViewProjectWorkstreamCodePreviewSessionErrors, ThrowOnError>({ url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/preview/sessions/{sessionId}/view', ...options });

export const deleteProjectWorkstreamCodePreviewSession = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectWorkstreamCodePreviewSessionData, ThrowOnError>): RequestResult<DeleteProjectWorkstreamCodePreviewSessionResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteProjectWorkstreamCodePreviewSessionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/preview/sessions/{sessionId}',
    ...options
});

export const acceptProjectWorkstreamCodeTuningVersion = <ThrowOnError extends boolean = false>(options: Options<AcceptProjectWorkstreamCodeTuningVersionData, ThrowOnError>): RequestResult<AcceptProjectWorkstreamCodeTuningVersionResponses, AcceptProjectWorkstreamCodeTuningVersionErrors, ThrowOnError> => (options.client ?? client).post<AcceptProjectWorkstreamCodeTuningVersionResponses, AcceptProjectWorkstreamCodeTuningVersionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/versions/{versionId}/accept',
    ...options
});

export const handleGitHubCodeWorkspaceWebhook = <ThrowOnError extends boolean = false>(options?: Options<HandleGitHubCodeWorkspaceWebhookData, ThrowOnError>): RequestResult<HandleGitHubCodeWorkspaceWebhookResponses, HandleGitHubCodeWorkspaceWebhookErrors, ThrowOnError> => (options?.client ?? client).post<HandleGitHubCodeWorkspaceWebhookResponses, HandleGitHubCodeWorkspaceWebhookErrors, ThrowOnError>({ url: '/api/v1/code/internal/workspace-webhooks/github', ...options });

/**
 * Requests waiting on a person (or recently decided)
 */
export const apiListDecisions = <ThrowOnError extends boolean = false>(options?: Options<ApiListDecisionsData, ThrowOnError>): RequestResult<ApiListDecisionsResponses, ApiListDecisionsErrors, ThrowOnError> => (options?.client ?? client).get<ApiListDecisionsResponses, ApiListDecisionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/decisions',
    ...options
});

/**
 * Approve a pending request as the key’s person
 *
 * The review rules apply: the key needs the policy the request asks of its reviewer, and the person who raised a request approves it only when its kind is self-approvable. `state` says what happened.
 */
export const apiApproveDecision = <ThrowOnError extends boolean = false>(options: Options<ApiApproveDecisionData, ThrowOnError>): RequestResult<ApiApproveDecisionResponses, ApiApproveDecisionErrors, ThrowOnError> => (options.client ?? client).post<ApiApproveDecisionResponses, ApiApproveDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/decisions/{id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Turn down a pending request, with the reason
 */
export const apiRejectDecision = <ThrowOnError extends boolean = false>(options: Options<ApiRejectDecisionData, ThrowOnError>): RequestResult<ApiRejectDecisionResponses, ApiRejectDecisionErrors, ThrowOnError> => (options.client ?? client).post<ApiRejectDecisionResponses, ApiRejectDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/decisions/{id}/reject',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One output part of a workflow run, whole (≤ 512 KB inline)
 */
export const apiGetWorkflowRunPart = <ThrowOnError extends boolean = false>(options: Options<ApiGetWorkflowRunPartData, ThrowOnError>): RequestResult<ApiGetWorkflowRunPartResponses, ApiGetWorkflowRunPartErrors, ThrowOnError> => (options.client ?? client).get<ApiGetWorkflowRunPartResponses, ApiGetWorkflowRunPartErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/workflows/{id}/runs/{runId}/parts/{partId}',
    ...options
});

/**
 * A dashboard with what each widget shows now
 */
export const apiGetDashboardData = <ThrowOnError extends boolean = false>(options: Options<ApiGetDashboardDataData, ThrowOnError>): RequestResult<ApiGetDashboardDataResponses, ApiGetDashboardDataErrors, ThrowOnError> => (options.client ?? client).get<ApiGetDashboardDataResponses, ApiGetDashboardDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboards/{id}/data',
    ...options
});

/**
 * The sources (channels, accounts, feeds) the organization knows, and whether it follows each
 */
export const apiListIntelSources = <ThrowOnError extends boolean = false>(options?: Options<ApiListIntelSourcesData, ThrowOnError>): RequestResult<ApiListIntelSourcesResponses, ApiListIntelSourcesErrors, ThrowOnError> => (options?.client ?? client).get<ApiListIntelSourcesResponses, ApiListIntelSourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel-sources',
    ...options
});

/**
 * A source’s newest items (videos, posts, articles), each marked analysed or not
 */
export const apiListIntelSourceItems = <ThrowOnError extends boolean = false>(options: Options<ApiListIntelSourceItemsData, ThrowOnError>): RequestResult<ApiListIntelSourceItemsResponses, ApiListIntelSourceItemsErrors, ThrowOnError> => (options.client ?? client).get<ApiListIntelSourceItemsResponses, ApiListIntelSourceItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/intel-sources/{id}/content',
    ...options
});

/**
 * Withdraw a pending request the key’s person raised
 *
 * Only the person who raised a request may withdraw it, and only while it is pending; otherwise 400 with the reason (404 when nothing pending has that id).
 */
export const apiCancelDecision = <ThrowOnError extends boolean = false>(options: Options<ApiCancelDecisionData, ThrowOnError>): RequestResult<ApiCancelDecisionResponses, ApiCancelDecisionErrors, ThrowOnError> => (options.client ?? client).post<ApiCancelDecisionResponses, ApiCancelDecisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/decisions/{id}/cancel',
    ...options
});

/**
 * The organization’s strategies
 */
export const apiListStrategies = <ThrowOnError extends boolean = false>(options?: Options<ApiListStrategiesData, ThrowOnError>): RequestResult<ApiListStrategiesResponses, ApiListStrategiesErrors, ThrowOnError> => (options?.client ?? client).get<ApiListStrategiesResponses, ApiListStrategiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/strategies',
    ...options
});

/**
 * One strategy: its metrics, definition, parameters, readiness and per-regime results
 */
export const apiGetStrategy = <ThrowOnError extends boolean = false>(options: Options<ApiGetStrategyData, ThrowOnError>): RequestResult<ApiGetStrategyResponses, ApiGetStrategyErrors, ThrowOnError> => (options.client ?? client).get<ApiGetStrategyResponses, ApiGetStrategyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/strategies/{id}',
    ...options
});

/**
 * The organization’s strategy buckets
 */
export const apiListStrategyBuckets = <ThrowOnError extends boolean = false>(options?: Options<ApiListStrategyBucketsData, ThrowOnError>): RequestResult<ApiListStrategyBucketsResponses, ApiListStrategyBucketsErrors, ThrowOnError> => (options?.client ?? client).get<ApiListStrategyBucketsResponses, ApiListStrategyBucketsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/strategy-buckets',
    ...options
});

/**
 * One bucket: its legs, their weights and each leg’s latest backtest
 */
export const apiGetStrategyBucket = <ThrowOnError extends boolean = false>(options: Options<ApiGetStrategyBucketData, ThrowOnError>): RequestResult<ApiGetStrategyBucketResponses, ApiGetStrategyBucketErrors, ThrowOnError> => (options.client ?? client).get<ApiGetStrategyBucketResponses, ApiGetStrategyBucketErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/strategy-buckets/{id}',
    ...options
});

/**
 * Two to five simulations side by side, with the leader of each column
 */
export const apiCompareBacktests = <ThrowOnError extends boolean = false>(options: Options<ApiCompareBacktestsData, ThrowOnError>): RequestResult<ApiCompareBacktestsResponses, ApiCompareBacktestsErrors, ThrowOnError> => (options.client ?? client).get<ApiCompareBacktestsResponses, ApiCompareBacktestsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/backtests/compare',
    ...options
});

/**
 * The current market regime of each symbol
 */
export const apiListMarketRegimes = <ThrowOnError extends boolean = false>(options: Options<ApiListMarketRegimesData, ThrowOnError>): RequestResult<ApiListMarketRegimesResponses, ApiListMarketRegimesErrors, ThrowOnError> => (options.client ?? client).get<ApiListMarketRegimesResponses, ApiListMarketRegimesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/market-data/regimes',
    ...options
});

/**
 * Simulations on record, newest first (one strategy’s, or the organization’s)
 */
export const apiListBacktests = <ThrowOnError extends boolean = false>(options?: Options<ApiListBacktestsData, ThrowOnError>): RequestResult<ApiListBacktestsResponses, ApiListBacktestsErrors, ThrowOnError> => (options?.client ?? client).get<ApiListBacktestsResponses, ApiListBacktestsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/backtests',
    ...options
});

/**
 * Queue a research-only simulation of a strategy
 *
 * Answers 202 with the queued request (`requestId`), or the finished run (`run.id`) when the same simulation already ran. Send an `Idempotency-Key` to make a retry safe. At most 10 a minute per key.
 */
export const apiCreateBacktest = <ThrowOnError extends boolean = false>(options: Options<ApiCreateBacktestData, ThrowOnError>): RequestResult<ApiCreateBacktestResponses, ApiCreateBacktestErrors, ThrowOnError> => (options.client ?? client).post<ApiCreateBacktestResponses, ApiCreateBacktestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/backtests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One simulation: its window, full statistics, scores and series sizes
 */
export const apiGetBacktest = <ThrowOnError extends boolean = false>(options: Options<ApiGetBacktestData, ThrowOnError>): RequestResult<ApiGetBacktestResponses, ApiGetBacktestErrors, ThrowOnError> => (options.client ?? client).get<ApiGetBacktestResponses, ApiGetBacktestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/backtests/{id}',
    ...options
});

/**
 * One page of a simulation's series (equity, trades, regimes, drawdown_series, buy_hold_equity, oos_returns_series)
 */
export const apiListBacktestSeries = <ThrowOnError extends boolean = false>(options: Options<ApiListBacktestSeriesData, ThrowOnError>): RequestResult<ApiListBacktestSeriesResponses, ApiListBacktestSeriesErrors, ThrowOnError> => (options.client ?? client).get<ApiListBacktestSeriesResponses, ApiListBacktestSeriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/backtests/{id}/series/{kind}',
    ...options
});

/**
 * A simulation’s full analysis, computed once per run (the same as the platform’s Strategy Tester)
 */
export const apiGetBacktestAnalytics = <ThrowOnError extends boolean = false>(options: Options<ApiGetBacktestAnalyticsData, ThrowOnError>): RequestResult<ApiGetBacktestAnalyticsResponses, ApiGetBacktestAnalyticsErrors, ThrowOnError> => (options.client ?? client).get<ApiGetBacktestAnalyticsResponses, ApiGetBacktestAnalyticsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/backtests/{id}/analytics',
    ...options
});

/**
 * A window of stored OHLCV bars for a chart ([from, to), newest page first in time order)
 *
 * `countback` bars ending before `to`, or up to `limit` in [`from`, `to`) (≤ 5000). `paging.next` pages back in time; `meta.nextTime` is where older bars resume. `format=columnar` answers TradingView UDF columns {s,t,o,h,l,c,v,nextTime}. The key needs data access.
 */
export const apiGetCandles = <ThrowOnError extends boolean = false>(options: Options<ApiGetCandlesData, ThrowOnError>): RequestResult<ApiGetCandlesResponses, ApiGetCandlesErrors, ThrowOnError> => (options.client ?? client).get<ApiGetCandlesResponses, ApiGetCandlesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/market-data/candles',
    ...options
});

/**
 * A simulation’s status and progress as server-sent events, until it is done
 *
 * Events `status` (whenever the status changes; always first), `progress` (when the run reports one), `done` (then the stream ends), `error`; monotonic ids, resume with `Last-Event-ID`; a `: heartbeat` comment every 20 s. Accepts a backtest id or the `requestId` of `POST /backtests`. The server polls the run every 2 s.
 */
export const apiStreamBacktestEvents = <ThrowOnError extends boolean = false>(options: Options<ApiStreamBacktestEventsData, ThrowOnError, ApiStreamBacktestEventsResponse>): Promise<ServerSentEventsResult<ApiStreamBacktestEventsResponses>> => (options.client ?? client).sse.get<ApiStreamBacktestEventsResponses, ApiStreamBacktestEventsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/backtests/{id}/events',
    ...options
});

/**
 * Download the market database as a SQL backup
 *
 * One gzip’d plain-SQL file of the market tables: everything (the first load of an organization copy, into an empty database) or, with `days`, the rows of the last N UTC days (upserted by primary key, so it loads over an existing copy). Restore with `gunzip -c file.sql.gz | psql "$URL"` into a database with the same migrations. The body streams and can be tens of GB. Needs data access.
 */
export const getMarketDataBackup = <ThrowOnError extends boolean = false>(options?: Options<GetMarketDataBackupData, ThrowOnError>): RequestResult<GetMarketDataBackupResponses, GetMarketDataBackupErrors, ThrowOnError> => (options?.client ?? client).get<GetMarketDataBackupResponses, GetMarketDataBackupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/market-data/backup',
    ...options
});

/**
 * Get a worker's direct routes to the market data
 *
 * For a control plane that is not the platform: the routes one of its workers can read the market data on directly (nearest first: the same machine, its LAN, the private network), each with a short-lived token for the key's organization. An empty list means no route fits the worker's network. Needs data access.
 */
export const createMarketDataGrants = <ThrowOnError extends boolean = false>(options: Options<CreateMarketDataGrantsData, ThrowOnError>): RequestResult<CreateMarketDataGrantsResponses, CreateMarketDataGrantsErrors, ThrowOnError> => (options.client ?? client).post<CreateMarketDataGrantsResponses, CreateMarketDataGrantsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/market-data/grants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The market tables' coverage
 *
 * First and last row and row count of every market series (per symbol and bar size for the candles), as the platform's market database service computed them (hourly). For a control plane that is not the platform: it reads this instead of counting the shared market database itself. Needs data access.
 */
export const getMarketDataCoverage = <ThrowOnError extends boolean = false>(options?: Options<GetMarketDataCoverageData, ThrowOnError>): RequestResult<GetMarketDataCoverageResponses, GetMarketDataCoverageErrors, ThrowOnError> => (options?.client ?? client).get<GetMarketDataCoverageResponses, GetMarketDataCoverageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/market-data/coverage',
    ...options
});
